webpackJsonp([2],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return mgrlogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return changePwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getparamsByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return deleteCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return companyPageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return addCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return editCompany; });
/* unused harmony export editService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return companyPageListdc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return memberPageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return editMemberInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return deleteMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return addMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return memberPageListdc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return companyFilePageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return addCompanyFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return deletecompanyFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return companyFilePageListdc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return companyGuestPageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return addCompanyGuest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return updateCompanyGuest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return companyCarPageListdc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return companyCarPageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return addCompanyCar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return deleteCompanyCar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return selfCheckPlanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return addSelfCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return allWorkerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return deleteSelfCheckPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return selfCheckRecordList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return companyCheckDetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return updateSelfCheckZgInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return updateSelfCheckYsInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return addRecordPic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return addSelfCheckRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return selfCheckReportList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return addSelfCheckReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return addReportPic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return updateZgInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return updateYsInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return companyTrainPageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return addCompanyTrain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return deleteCompanyTrain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return gjCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return updateYhOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return gjCheckDetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return updateCorrectDeadTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return updateCorrectInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return updateReviewInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return updateReviewNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return govCheckPageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return addGovCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateGovCheckInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return safefilecheckSumPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selfcheckSumPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return recordMonthPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reportMonthPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return gjcheckSumPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getGwCheckItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return updateGwCheckItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAccountList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetAccountpwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return allCompanyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getNoticeListPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getcompanyNoticeListPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addNotice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deleteNotice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addCompanyFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getNoticeFileList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return noticeCompanyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return noticeUnreadCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateNoticeCompanyStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var base = '/yhpczl/mgr';
var mgrlogin = function mgrlogin(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/mgrlogin', { params: params });
};
var changePwd = function changePwd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/changePwd', params);
};

// 获取选项字典表
var getparamsByType = function getparamsByType(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/getparamsByType', { params: params });
};

// 企业管理
var deleteCompany = function deleteCompany(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deleteCompany', params);
};
var companyPageList = function companyPageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyPageList', { params: params });
};
var addCompany = function addCompany(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addCompany', params);
};
var editCompany = function editCompany(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/editCompany', params);
};
var editService = function editService(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/editService', params);
};
var companyPageListdc = function companyPageListdc(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyPageListdc', { params: params });
};

// 人员管理
var memberPageList = function memberPageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/memberPageList', { params: params });
};
var editMemberInfo = function editMemberInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/editMemberInfo', params);
};
var deleteMember = function deleteMember(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deleteMember', params);
};
var addMember = function addMember(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addMember', params);
};
var memberPageListdc = function memberPageListdc(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/memberPageListdc', { params: params });
};

// 资料管理
var companyFilePageList = function companyFilePageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyFilePageList', { params: params });
};
var addCompanyFile = function addCompanyFile(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addCompanyFile', params);
};
var deletecompanyFile = function deletecompanyFile(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deletecompanyFile', params);
};
var companyFilePageListdc = function companyFilePageListdc(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyFilePageListdc', { params: params });
};

// 协议客户管理（企业管理员）
var companyGuestPageList = function companyGuestPageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyGuestPageList', { params: params });
};
var addCompanyGuest = function addCompanyGuest(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addCompanyGuest', params);
};
var updateCompanyGuest = function updateCompanyGuest(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateCompanyGuest', params);
};

// 车辆管理
var companyCarPageListdc = function companyCarPageListdc(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyCarPageListdc', { params: params });
};

var companyCarPageList = function companyCarPageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyCarPageList', { params: params });
};
var addCompanyCar = function addCompanyCar(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addCompanyCar', params);
};
var deleteCompanyCar = function deleteCompanyCar(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deleteCompanyCar', params);
};

//隐患排查-计划
var selfCheckPlanList = function selfCheckPlanList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/selfCheckPlanList', { params: params });
};
var addSelfCheckPlan = function addSelfCheckPlan(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addSelfCheckPlan', params);
};
var allWorkerList = function allWorkerList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/allWorkerList', { params: params });
};
var deleteSelfCheckPlan = function deleteSelfCheckPlan(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deleteSelfCheckPlan', params);
};

//隐患排查-记录
var selfCheckRecordList = function selfCheckRecordList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/selfCheckRecordList', { params: params });
};
var companyCheckDetailList = function companyCheckDetailList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyCheckDetailList', { params: params });
};
var updateSelfCheckZgInfo = function updateSelfCheckZgInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateSelfCheckZgInfo', params);
};
var updateSelfCheckYsInfo = function updateSelfCheckYsInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateSelfCheckYsInfo', params);
};
var addRecordPic = function addRecordPic(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addRecordPic', params);
};

var addSelfCheckRecord = function addSelfCheckRecord(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addSelfCheckRecord', params);
};

//隐患排查-上报
var selfCheckReportList = function selfCheckReportList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/selfCheckReportList', { params: params });
};
var addSelfCheckReport = function addSelfCheckReport(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addSelfCheckReport', params);
};
var addReportPic = function addReportPic(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addReportPic', params);
};
var updateZgInfo = function updateZgInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateZgInfo', params);
};
var updateYsInfo = function updateYsInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateYsInfo', params);
};

//培训管理
var companyTrainPageList = function companyTrainPageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/companyTrainPageList', { params: params });
};
var addCompanyTrain = function addCompanyTrain(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addCompanyTrain', params);
};
var deleteCompanyTrain = function deleteCompanyTrain(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deleteCompanyTrain', params);
};

//监督检查
var gjCheckList = function gjCheckList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/gjCheckList', { params: params });
};
var updateYhOK = function updateYhOK(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateYhOK', params);
};
var gjCheckDetailList = function gjCheckDetailList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/gjCheckDetailList', { params: params });
};
var updateCorrectDeadTime = function updateCorrectDeadTime(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateCorrectDeadTime', params);
};
var updateCorrectInfo = function updateCorrectInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateCorrectInfo', params);
};
var updateReviewInfo = function updateReviewInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateReviewInfo', params);
};
var updateReviewNG = function updateReviewNG(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateReviewNG', params);
};

//20260320简化版gov检查记录
var govCheckPageList = function govCheckPageList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/govCheckPageList', { params: params });
};
var addGovCheck = function addGovCheck(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addGovCheck', params);
};
var updateGovCheckInfo = function updateGovCheckInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateGovCheckInfo', params);
};

//统计分析
var safefilecheckSumPage = function safefilecheckSumPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/safefilecheckSumPage', { params: params });
};

var selfcheckSumPage = function selfcheckSumPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/selfcheckSumPage', { params: params });
};
var recordMonthPage = function recordMonthPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/recordMonthPage', { params: params });
};
var reportMonthPage = function reportMonthPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/reportMonthPage', { params: params });
};

var gjcheckSumPage = function gjcheckSumPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/gjcheckSumPage', { params: params });
};

//系统管理-栏目管理
var getGwCheckItem = function getGwCheckItem(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/getGwCheckItem', { params: params });
};
var updateGwCheckItem = function updateGwCheckItem(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateGwCheckItem', params);
};

//系统管理-用户管理
var getAccountList = function getAccountList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/getAccountList', { params: params });
};
var updateAccount = function updateAccount(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateAccount', params);
};
var resetAccountpwd = function resetAccountpwd(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/resetAccountpwd', params);
};

//通知管理
var allCompanyList = function allCompanyList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/allCompanyList', { params: params });
};
var getNoticeListPage = function getNoticeListPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/getNoticeListPage', { params: params });
};
var getcompanyNoticeListPage = function getcompanyNoticeListPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/getcompanyNoticeListPage', { params: params });
};

var addNotice = function addNotice(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addNotice', params);
};
var deleteNotice = function deleteNotice(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/deleteNotice', params);
};
var addCompanyFiles = function addCompanyFiles(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/addCompanyFiles', params);
};

var getNoticeFileList = function getNoticeFileList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/getNoticeFileList', { params: params });
};
var noticeCompanyList = function noticeCompanyList(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/noticeCompanyList', { params: params });
};

//企业首页显示未读通知数量
var noticeUnreadCount = function noticeUnreadCount(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/notice/unreadCount', { params: params });
};

var updateNoticeCompanyStatus = function updateNoticeCompanyStatus(params) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/updateNoticeCompanyStatus', params);
};

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notificationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchUnreadCount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);



// 创建响应式对象
var notificationState = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].observable({
    unreadCount: 0
});

// 更新方法
var fetchUnreadCount = function fetchUnreadCount() {
    //企业显示未读通知数目
    notificationState.unreadCount = 0;
    var user = sessionStorage.getItem('user');
    if (user) {
        user = JSON.parse(user);
        if (user.data.roleId == '4') {
            var para = {
                coId: user.data.coId
            };

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["q" /* noticeUnreadCount */])(para).then(function (res) {
                // console.log(res.data)
                if (res.data.code == 0) {
                    notificationState.unreadCount = res.data.data;
                }
            });
        }
    }
};

// 使用方法
// 显示页面
// <span v-if="unreadCount!=0" style="margin-right: 10px;color: white;">未读通知<el-badge :max="99"  :value="unreadCount" /></span>
// import { notificationState, fetchUnreadCount  } from '../common/js/notificationState';
// computed: {
//     unreadCount() {
//     return notificationState.unreadCount // 响应式获取
//     }
// },
// mounted() {
//     fetchUnreadCount() //读取
// }
// 其他页面
// import {fetchUnreadCount  } from '../../common/js/notificationState';
//fetchUnreadCount() //未读通知数

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Login_vue__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_404_vue__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Main_vue__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_nav_enterprise_vue__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_nav_enterprise_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_nav_enterprise_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_nav_enterpriseMember_vue__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_nav_enterpriseMember_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_nav_enterpriseMember_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_nav_enterpriseFile_vue__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_nav_enterpriseFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_nav_enterpriseFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_nav_enterpriseGuest_vue__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_nav_enterpriseGuest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_nav_enterpriseGuest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_nav_enterpriseCar_vue__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_nav_enterpriseCar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_nav_enterpriseCar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_nav_selfcheckPlan_vue__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_nav_selfcheckPlan_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_nav_selfcheckPlan_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_nav_selfcheckRecord_vue__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_nav_selfcheckRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_nav_selfcheckRecord_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_nav_selfcheckReport_vue__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_nav_selfcheckReport_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_nav_selfcheckReport_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_nav_enterpriseTrain_vue__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_nav_enterpriseTrain_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_nav_enterpriseTrain_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_nav_govCheckRecord_vue__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_nav_govCheckRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_nav_govCheckRecord_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_nav_govCheckCorrect_vue__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_nav_govCheckCorrect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_nav_govCheckCorrect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_nav_checkView_vue__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_nav_checkView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_nav_checkView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_nav_checkCorrect_vue__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_nav_checkCorrect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_nav_checkCorrect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_nav_checkReview_vue__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_nav_checkReview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_nav_checkReview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_nav_checkRecord_vue__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_nav_checkRecord_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_nav_checkRecord_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_nav_noticeManager_vue__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_nav_noticeManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_nav_noticeManager_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_nav_safefileCheckForm_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_nav_safefileCheckForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__views_nav_safefileCheckForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_nav_selfcheckForm_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_nav_selfcheckForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__views_nav_selfcheckForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_nav_checkForm_vue__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_nav_checkForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__views_nav_checkForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_nav_gwCheckItem_vue__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_nav_gwCheckItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__views_nav_gwCheckItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_nav_accountManager_vue__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_nav_accountManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__views_nav_accountManager_vue__);
















//简化版 检查记录

















var routes = [{
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_0__views_Login_vue___default.a,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_1__views_404_vue___default.a,
    name: '',
    hidden: true
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
},
// { path: '/main', component: Main  ,name: '主页', hidden: true, children:null},
{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a,
    name: '基础管理',
    iconCls: 'fa fa-institution', //图标样式class
    children: [
    // 如果管局增加首页，需修改home文件，企业和管局的显示配置
    // { path: '/main', component: Main, name: '首页'},
    { path: '/enterprise', component: __WEBPACK_IMPORTED_MODULE_4__views_nav_enterprise_vue___default.a, name: '企业管理' }, { path: '/enterpriseMember', component: __WEBPACK_IMPORTED_MODULE_5__views_nav_enterpriseMember_vue___default.a, name: '人员管理' }, { path: '/enterpriseFile', component: __WEBPACK_IMPORTED_MODULE_6__views_nav_enterpriseFile_vue___default.a, name: '资料管理' }, { path: '/enterpriseGuest', component: __WEBPACK_IMPORTED_MODULE_7__views_nav_enterpriseGuest_vue___default.a, name: '协议客户管理' }, { path: '/enterpriseCar', component: __WEBPACK_IMPORTED_MODULE_8__views_nav_enterpriseCar_vue___default.a, name: '车辆管理' }]
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a,
    name: '安全生产管理',
    iconCls: 'fa fa-server', //图标样式class
    children: [
    // { path: '/selfcheckPlan', component: selfcheckPlan, name: '隐患排查计划' },
    { path: '/selfcheckRecord', component: __WEBPACK_IMPORTED_MODULE_10__views_nav_selfcheckRecord_vue___default.a, name: '隐患排查记录' }, { path: '/selfcheckReport', component: __WEBPACK_IMPORTED_MODULE_11__views_nav_selfcheckReport_vue___default.a, name: '重大隐患上报管理' }, { path: '/enterpriseTrain', component: __WEBPACK_IMPORTED_MODULE_12__views_nav_enterpriseTrain_vue___default.a, name: '安全生产培训教育' }]
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a,
    name: '监督检查',
    iconCls: 'fa fa-calendar-check-o', //图标样式class
    children: [
    // { path: '/checkView', component: checkView, name: '隐患审核' },
    // { path: '/checkCorrect', component: checkCorrect, name: '隐患整改' },
    // { path: '/checkReview', component: checkReview, name: '隐患复查' },
    // { path: '/checkRecord', component: checkRecord, name: '隐患记录' },
    { path: '/govCheckRecord', component: __WEBPACK_IMPORTED_MODULE_13__views_nav_govCheckRecord_vue___default.a, name: '检查记录' }, { path: '/govCheckCorrect', component: __WEBPACK_IMPORTED_MODULE_14__views_nav_govCheckCorrect_vue___default.a, name: '整改情况' }]
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a,
    name: '通知管理',
    iconCls: 'fa fa-newspaper-o', //图标样式class
    children: [{ path: '/noticeManager', component: __WEBPACK_IMPORTED_MODULE_19__views_nav_noticeManager_vue___default.a, name: '企业通知管理' }]
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a,
    name: '统计分析',
    iconCls: 'fa fa-list-alt', //图标样式class 
    children: [{ path: '/safefileCheckForm', component: __WEBPACK_IMPORTED_MODULE_20__views_nav_safefileCheckForm_vue___default.a, name: '企业安全专项检查' }, { path: '/selfcheckForm', component: __WEBPACK_IMPORTED_MODULE_21__views_nav_selfcheckForm_vue___default.a, name: '企业隐患排查统计' }]
}, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home_vue___default.a,
    name: '系统管理',
    iconCls: 'fa fa-cogs', //图标样式class
    children: [
    // { path: '/gwCheckItem', component: gwCheckItem, name: '岗位排查栏目管理' },
    { path: '/accountManager', component: __WEBPACK_IMPORTED_MODULE_24__views_nav_accountManager_vue___default.a, name: '企业用户管理' }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(456);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// 应用初始状态
var state = {
    count: 10

    // 定义所需的 mutations
};var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

// 创建 store 实例
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    state: state,
    mutations: mutations
}));

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(785)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {}
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    url: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeClick: function closeClick() {
      //子组件可以使用 $emit 触发父组件的自定义事件
      this.$emit("closeClick");
    }
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_notificationState__ = __webpack_require__(152);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			sysName: '宜春邮政快递业安全监管系统',

			objectId: 0, //用户表id，改密码用

			collapsed: false,
			sysUserName: '',

			//修改密码界面
			changeFormVisible: false, //界面是否显示
			changeLoading: false,
			changeFormRules: {
				oldpassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
				newpassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
				newpassword2: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }]
			},

			changeForm: {
				oldpassword: '',
				newpassword: '',
				newpassword2: ''
			},

			//未读通知数目
			showcnt: false,
			unreadcnt: 0

		};
	},

	methods: {
		onSubmit: function onSubmit() {},
		handleopen: function handleopen() {},
		handleclose: function handleclose() {},

		handleselect: function handleselect(a, b) {},

		// 修改密码
		handleModify: function handleModify() {
			this.changeFormVisible = true;
			this.changeForm = {
				oldpassword: '',
				newpassword: '',
				newpassword2: ''
			};
		},

		changePwd: function changePwd() {
			var _this2 = this;

			this.$refs.changeForm.validate(function (valid) {
				if (valid) {
					if (_this2.changeForm.newpassword != _this2.changeForm.newpassword2) {
						_this2.$message.error("两次输入的新密码不一致");
					} else {
						_this2.$confirm('确认修改吗？', '提示', {}).then(function () {
							_this2.changeLoading = true;
							var para = {
								userId: _this2.objectId,
								oldPwd: _this2.changeForm.oldpassword,
								pwd: _this2.changeForm.newpassword
							};

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_5" /* changePwd */])(para).then(function (res) {
								_this2.changeLoading = false;
								_this2.changeFormVisible = false;
								if (res.data.code == 0) {
									_this2.$message.success(res.data.message);
								} else {
									_this2.$message.error(res.data.message);
								}
							});
						});
					}
				}
			});
		},
		//退出登录
		logout: function logout() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {
				//type: 'warning'
			}).then(function () {
				sessionStorage.removeItem('user');
				_this.$router.push('/login');
			}).catch(function () {});
		},
		//折叠导航栏
		collapse: function collapse() {
			this.collapsed = !this.collapsed;
		},
		showMenu: function showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	computed: {
		unreadCount: function unreadCount() {
			return __WEBPACK_IMPORTED_MODULE_1__common_js_notificationState__["b" /* notificationState */].unreadCount; // 响应式获取
		}
	},
	mounted: function mounted() {
		var user = sessionStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.objectId = user.data.userId;
			this.sysUserName = user.data.userName || '';
		}
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js_notificationState__["a" /* fetchUnreadCount */])(); //未读通知数
		var routes = this.$router.options.routes;

		//企业用户，只显示：基础管理3，隐患排查4，监督检查-检查记录 5-0 5-1，通知管理6
		if (user.data.roleId == '4') {
			for (var index = 3; index < routes.length; index++) {
				var element = routes[index];
				if (index == 3 || index == 4 || index == 5 || index == 6) {
					element.hidden = false;
					var curroute = this.$router.options.routes[index].children;
					for (var index2 = 0; index2 < curroute.length; index2++) {
						var element2 = curroute[index2];
						if (index == 5) {
							if (index2 != 0 || index2 != 1) {
								element2.hidden = false;
							} else {
								element2.hidden = true;
							}
						} else {
							element2.hidden = false;
						}
					}
				} else {
					element.hidden = true;
				}
			}
		} else {
			//去掉默认的前3个，显示全部菜单
			for (var _index = 3; _index < routes.length; _index++) {
				var _element = routes[_index];
				_element.hidden = false;

				var _curroute = _element.children;
				for (var _index2 = 0; _index2 < _curroute.length; _index2++) {
					var _element2 = _curroute[_index2];
					_element2.hidden = false;
				}
			}
			//协议客户管理3-3，不显示 2025-11-25 也显示，栏目有差异 2026-03-20会议
			// let  newroute = this.$router.options.routes[3].children;
			// const newelement2 = newroute[3];
			// newelement2.hidden = true; 
		}
	}
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      //登录数据
      logining: false,
      loginForm: {
        loginName: '',
        password: ''
      },
      rules2: {
        loginName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }

    };
  },

  methods: {
    // 点击登录
    handleLogin: function handleLogin(ev) {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.logining = true;
          var para = {
            loginName: _this.loginForm.loginName,
            password: _this.loginForm.password
          };

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_6" /* mgrlogin */])(para).then(function (res) {
            _this.logining = false;
            if (res.data.code == 0) {
              _this.$message.success("登录成功");
              var responsedata = res.data;
              //保存登录数据
              sessionStorage.setItem('user', JSON.stringify(responsedata));
              _this.$router.push({ path: '/enterprise' });
            } else {
              _this.$message.error(res.data.message);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_map_yichun_json__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_map_yichun_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_map_yichun_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// 引入江西省地图JSON数据（需自行下载或通过CDN引入）


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HomePage',
  data: function data() {
    return {
      // 核心统计数据
      statsData: [{ label: '企业总数', value: 1258, unit: '家' }, { label: '企业人员总数', value: 86420, unit: '人' }, { label: '规上企业数', value: 326, unit: '家' }, { label: '高新技术企业', value: 158, unit: '家' }],
      // 额外统计数据
      extraStatsData: [{ label: '年营收总额', value: 468.5, unit: '亿元' }, { label: '纳税总额', value: 32.8, unit: '亿元' }],
      mapChart: null
    };
  },
  mounted: function mounted() {
    // 强制设置容器宽高（关键！）
    var mapDom = document.getElementById('jiangxi-map');
    mapDom.style.width = '100%';
    mapDom.style.height = '600px'; // 固定高度，优先保证渲染

    this.initMap();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose();
    }
  },

  methods: {
    // 初始化江西地图
    initMap: function initMap() {
      var _this = this;

      // 注册地图
      __WEBPACK_IMPORTED_MODULE_0_echarts__["registerMap"]('yichun', __WEBPACK_IMPORTED_MODULE_1__assets_map_yichun_json___default.a);
      // 初始化图表
      this.mapChart = __WEBPACK_IMPORTED_MODULE_0_echarts__["init"](document.getElementById('jiangxi-map'));
      // 配置项
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c}',
          textStyle: { fontSize: 12 }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 2000,
          left: 'left',
          top: 'bottom',
          text: ['高', '低'],
          calculable: true,
          seriesIndex: [0]
        },
        series: [{
          name: '企业数量',
          type: 'map',
          mapType: 'yichun',
          roam: false, // 禁止缩放和平移
          label: {
            show: true, // 显示名称
            fontSize: 10,
            color: '#333'
          },
          emphasis: {
            label: {
              color: '#fff',
              fontSize: 12
            },
            itemStyle: {
              areaColor: '#4e79a7'
            }
          },
          data: [{ name: '袁州区', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '奉新县', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '万载县', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '上高县', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '宜丰县', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '靖安县', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '铜鼓县', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '丰城市', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '樟树市', value: 286, itemStyle: { areaColor: '#ff4d4f' } }, { name: '高安市', value: 286, itemStyle: { areaColor: '#ff4d4f' } }]
        }]
        // 渲染地图
      };this.mapChart.setOption(option);
      // 自适应窗口大小
      window.addEventListener('resize', function () {
        _this.mapChart.resize();
      });
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id

			filters: {
				coName: ''
			},

			companylist: [],
			total: 0,
			page: 1,
			listLoading: false
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getListPage();
		},

		//获取列表
		getListPage: function getListPage() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.coName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["a" /* getAccountList */])(para).then(function (res) {

				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.companylist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},

		handleClose: function handleClose(index, row) {
			var _this2 = this;

			this.$confirm('确认禁用这个账号吗？', '提示', {}).then(function () {

				var newparam = {
					createUserId: _this2.objectId,
					accountId: row.accountId,
					locked: '1'
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["b" /* updateAccount */])(newparam).then(function (res) {
					if (res.data.code == 0) {
						_this2.$message.success(res.data.message);
						_this2.getListPage();
					} else {
						_this2.$message.error(res.data.message);
					}
				});
			});
		},

		handleOpen: function handleOpen(index, row) {
			var _this3 = this;

			this.$confirm('确认启用这个账号吗？', '提示', {}).then(function () {

				var newparam = {
					createUserId: _this3.objectId,
					accountId: row.accountId,
					locked: '0'
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["b" /* updateAccount */])(newparam).then(function (res) {
					if (res.data.code == 0) {
						_this3.$message.success(res.data.message);
						_this3.getListPage();
					} else {
						_this3.$message.error(res.data.message);
					}
				});
			});
		},

		handleresetpwd: function handleresetpwd(index, row) {
			var _this4 = this;

			this.$confirm('确认重置这个账号的密码吗？', '提示', {}).then(function () {

				var newparam = {
					createUserId: _this4.objectId,
					accountId: row.accountId
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["c" /* resetAccountpwd */])(newparam).then(function (res) {
					if (res.data.code == 0) {
						_this4.$message.success(res.data.message);
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			});
		}

	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.getListPage();
	}
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_big_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 4-1 




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BigImg: __WEBPACK_IMPORTED_MODULE_0__components_big_img___default.a
	},
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//隐患详情
			detailFormVisible: false,
			feedata: [],
			detailForm: {
				coName: "",
				checkNumber: "",
				checkTime: ""
			},

			//上传资料
			uploadstart: true,
			fcfile: null,

			//编辑
			editFormTitle: '', //编辑的时候，显示企业名称
			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				correctTime: [{ required: true, message: "请选择整改完成日期", trigger: "blur" }],
				correctContent: [{ required: true, message: "请输入整改措施相关说明", trigger: "blur" }]
			},

			editForm: {
				checkNumber: "",
				correctFileURL: "",

				correctContent: "",
				correctTime: "",
				selCorrectTime: null
			},

			picbaseurl: "https://aqjg.ycsyzglj.com/",

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/",

			// 4-5
			photoVisible: false,
			bigImgUrl: ""

		};
	},

	methods: {
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'zip') {
				this.fcfile = event.target.files[0];
			} else {
				this.fcfile = null;
				this.$message.error("请选择zip格式的文件");
			}
		},
		uploadGjfcFile: function uploadGjfcFile() {
			var _this = this;

			if (this.fcfile != null) {
				var formData = new FormData();
				formData.append('file', this.fcfile);
				formData.append('filetype', "Yhpczl");
				formData.append('secondarydir', "yhpczl_gjfc_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this.editForm.correctFileURL = response.data.data.url;
						_this.uploadstart = false;
						_this.$message.success("文件上传成功，请填写其他信息后点击提交");
					} else {
						_this.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.correctNoticeURL;
			this.pdfFileName = row.coName + " 责令整改通知书";
			this.pdfVisible = true;
		},
		//4-4点击图片函数，点击后，把photoVisible设置成true
		showBigImage: function showBigImage(e) {
			if (e != "") {
				this.photoVisible = true;
				this.bigImgUrl = e;
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this2 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName,
				checkType: "correct"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_10" /* gjCheckList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.total = res.data.data.total;
					_this2.pagelist = res.data.data.list;
				}

				_this2.listLoading = false;
			});
		},


		yhDetail: function yhDetail(index, row) {
			var _this3 = this;

			this.detailForm.coName = row.coName;
			this.detailForm.checkNumber = row.checkNumber;
			this.detailForm.checkTime = row.checkTime;
			var para = {
				checkNumber: row.checkNumber
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_11" /* gjCheckDetailList */])(para).then(function (res) {
				_this3.detailFormVisible = true;
				if (res.data.code == 0) {
					_this3.feedata = res.data.data;
				}
			});
		},
		handleSQFC: function handleSQFC(index, row) {
			this.editFormVisible = true;

			this.editFormTitle = row.coName;

			this.editForm = {
				checkNumber: row.checkNumber,
				correctFileURL: '',
				correctContent: "",
				correctTime: "",
				selCorrectTime: null
			};
			this.fcfile = null;
			this.uploadstart = true;
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}
		},
		updateCorrect: function updateCorrect() {
			var _this4 = this;

			if (this.editForm.correctFileURL != "") {
				if (this.editForm.selCorrectTime != null) {
					this.editForm.correctTime = this.editForm.selCorrectTime.toLocaleString();
				}

				this.$refs.editForm.validate(function (valid) {
					if (valid) {
						_this4.$confirm('确认提交申请复查资料吗？', '提示', {}).then(function () {
							_this4.editLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_14" /* updateCorrectInfo */])(_this4.editForm).then(function (res) {
								_this4.editLoading = false;
								_this4.editFormVisible = false;
								if (res.data.code == 0) {
									_this4.$message.success(res.data.message);
									_this4.getPageList();
								} else {
									_this4.$message.error(res.data.message);
								}
							});
						});
					}
				});
			} else {
				this.$message.error("请提交申请复查的相关资料压缩文件（zip格式）");
			}
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		this.getPageList();
	}
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id

			companylist: [],
			total: 0,
			page: 1,
			listLoading: false

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getGjCheckSumListPage();
		},

		//获取列表
		getGjCheckSumListPage: function getGjCheckSumListPage() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_9" /* gjcheckSumPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.companylist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.getGjCheckSumListPage();
	}
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_big_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 4-1 



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BigImg: __WEBPACK_IMPORTED_MODULE_0__components_big_img___default.a
	},
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到

			filters: {
				companyName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//隐患详情
			detailFormVisible: false,
			feedata: [],
			detailForm: {
				coName: "",
				checkNumber: "",
				checkTime: ""
			},

			//上传资料
			uploadstart: true,
			fcfile: null,

			picbaseurl: "https://aqjg.ycsyzglj.com/",

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/",

			// 4-5
			photoVisible: false,
			bigImgUrl: ""

		};
	},

	methods: {
		handleDownloadFile: function handleDownloadFile(index, row) {
			if (row.correctFileURL != "") {
				var zipurl = "https://aqjg.ycsyzglj.com/" + row.correctFileURL;
				var a = document.createElement("a"); //创建a标签
				a.setAttribute("href", zipurl); //设置文件下载地址
				a.setAttribute('target', '_blank'); //在当前页面创建下载
				document.body.appendChild(a); //添加到body
				a.click(); //触发事件
				document.body.removeChild(a); //移除标签
			}
		},
		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.correctNoticeURL;
			this.pdfFileName = row.coName + " 责令整改通知书";
			this.pdfVisible = true;
		},
		//4-4点击图片函数，点击后，把photoVisible设置成true
		showBigImage: function showBigImage(e) {
			if (e != "") {
				this.photoVisible = true;
				this.bigImgUrl = e;
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName,
				checkType: "record"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["_10" /* gjCheckList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.pagelist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},


		yhDetail: function yhDetail(index, row) {
			var _this2 = this;

			this.detailForm.coName = row.coName;
			this.detailForm.checkNumber = row.checkNumber;
			this.detailForm.checkTime = row.checkTime;
			var para = {
				checkNumber: row.checkNumber
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["_11" /* gjCheckDetailList */])(para).then(function (res) {
				_this2.detailFormVisible = true;
				if (res.data.code == 0) {
					_this2.feedata = res.data.data;
				}
			});
		}

	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.getPageList();
	}
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_big_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 4-1 



/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BigImg: __WEBPACK_IMPORTED_MODULE_0__components_big_img___default.a
	},
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到


			filters: {
				companyName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//隐患详情
			detailFormVisible: false,
			feedata: [],
			detailForm: {
				coName: "",
				checkNumber: "",
				checkTime: ""
			},

			//上传资料
			uploadstart: true,
			fcfile: null,

			//编辑
			reviewradio: '0',
			editFormTitle: '', //编辑的时候，显示企业名称
			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				reviewTime: [{ required: true, message: "请选择整改完成日期", trigger: "blur" }],
				reviewContent: [{ required: true, message: "请输入整改措施相关说明", trigger: "blur" }]
			},

			editForm: {
				checkNumber: "",

				reviewContent: "",
				reviewTime: "",
				selReviewTime: null
			},

			picbaseurl: "https://aqjg.ycsyzglj.com/",

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/",

			// 4-5
			photoVisible: false,
			bigImgUrl: ""

		};
	},

	methods: {
		handleDownloadFile: function handleDownloadFile(index, row) {
			if (row.correctFileURL != "") {
				var zipurl = "https://aqjg.ycsyzglj.com/" + row.correctFileURL;
				var a = document.createElement("a"); //创建a标签
				a.setAttribute("href", zipurl); //设置文件下载地址
				a.setAttribute('target', '_blank'); //在当前页面创建下载
				document.body.appendChild(a); //添加到body
				a.click(); //触发事件
				document.body.removeChild(a); //移除标签
			}
		},

		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.correctNoticeURL;
			this.pdfFileName = row.coName + " 责令整改通知书";
			this.pdfVisible = true;
		},
		//4-4点击图片函数，点击后，把photoVisible设置成true
		showBigImage: function showBigImage(e) {
			if (e != "") {
				this.photoVisible = true;
				this.bigImgUrl = e;
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName,
				checkType: "review"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["_10" /* gjCheckList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.pagelist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},


		yhDetail: function yhDetail(index, row) {
			var _this2 = this;

			this.detailForm.coName = row.coName;
			this.detailForm.checkNumber = row.checkNumber;
			this.detailForm.checkTime = row.checkTime;
			var para = {
				checkNumber: row.checkNumber
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["_11" /* gjCheckDetailList */])(para).then(function (res) {
				_this2.detailFormVisible = true;
				if (res.data.code == 0) {
					_this2.feedata = res.data.data;
				}
			});
		},
		handleZGFC: function handleZGFC(index, row) {
			this.editFormVisible = true;

			this.editFormTitle = row.coName;

			this.editForm = {
				checkNumber: row.checkNumber,

				reviewContent: "",
				reviewTime: "",
				selReviewTime: null
			};
		},
		updateReview: function updateReview() {
			var _this3 = this;

			if (this.reviewradio == '1') {
				if (this.editForm.selReviewTime != null) {
					this.editForm.reviewTime = this.editForm.selReviewTime.toLocaleString();
				}

				this.$refs.editForm.validate(function (valid) {
					if (valid) {
						_this3.$confirm('确认提交复查结果吗？', '提示', {}).then(function () {
							_this3.editLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["_12" /* updateReviewInfo */])(_this3.editForm).then(function (res) {
								_this3.editLoading = false;
								_this3.editFormVisible = false;
								if (res.data.code == 0) {
									_this3.$message.success(res.data.message);
									_this3.getPageList();
								} else {
									_this3.$message.error(res.data.message);
								}
							});
						});
					}
				});
			} else {
				this.editForm.reviewContent = "", this.editForm.reviewTime = "";

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["_13" /* updateReviewNG */])(this.editForm).then(function (res) {
					_this3.editLoading = false;
					_this3.editFormVisible = false;
					if (res.data.code == 0) {
						_this3.$message.success(res.data.message);
						_this3.getPageList();
					} else {
						_this3.$message.error(res.data.message);
					}
				});
			}
		}

	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;

		this.getPageList();
	}
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_big_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 4-1 




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BigImg: __WEBPACK_IMPORTED_MODULE_0__components_big_img___default.a
	},
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到

			filters: {
				companyName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//隐患详情
			detailFormVisible: false,
			feedata: [],
			detailForm: {
				coName: "",
				checkNumber: "",
				checkTime: ""
			},

			//编辑
			editFormTitle: '', //编辑的时候，显示企业名称
			editFormVisible: false,
			editLoading: false,
			editFormRules: {},

			editForm: {
				checkNumber: "",
				correctNoticeURL: "",
				correctDeadTime: "",
				selCorrectDeadTime: null
			},

			//上传通知书
			uploadstart: true,
			imageFile: null,

			picbaseurl: "https://aqjg.ycsyzglj.com/",

			// 4-5
			photoVisible: false,
			bigImgUrl: ""

		};
	},

	methods: {
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'pdf') {
				this.imageFile = event.target.files[0];
			} else {
				this.imageFile = null;
				this.$message.error("请选择pdf格式的文件");
			}
		},
		uploadGjFile: function uploadGjFile() {
			var _this = this;

			if (this.imageFile != null) {
				var formData = new FormData();
				formData.append('file', this.imageFile);
				formData.append('filetype', "Yhpczl");
				formData.append('secondarydir', "yhpczl_gj_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this.editForm.correctNoticeURL = response.data.data.url;
						_this.uploadstart = false;
						_this.$message.success("文件上传成功，请填写其他信息后点击保存");
					} else {
						_this.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		//4-4点击图片函数，点击后，把photoVisible设置成true
		showBigImage: function showBigImage(e) {
			if (e != "") {
				this.photoVisible = true;
				this.bigImgUrl = e;
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this2 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName,
				checkType: "view"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_10" /* gjCheckList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.total = res.data.data.total;
					_this2.pagelist = res.data.data.list;
				}

				_this2.listLoading = false;
			});
		},

		handleZG: function handleZG(index, row) {
			this.editFormVisible = true;
			this.editFormTitle = row.coName;

			this.editForm = {
				checkNumber: row.checkNumber,
				correctDeadTime: "",
				selCorrectDeadTime: null
			};
			this.imageFile = null;
			this.uploadstart = true;
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}
		},
		updateCDTime: function updateCDTime() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.$confirm('确认提交整改期限吗？', '提示', {}).then(function () {
						_this3.editLoading = true;

						if (_this3.editForm.selCorrectDeadTime != null) {
							_this3.editForm.correctDeadTime = _this3.editForm.selCorrectDeadTime.toLocaleString();
						}

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_15" /* updateCorrectDeadTime */])(_this3.editForm).then(function (res) {
							_this3.editLoading = false;
							_this3.editFormVisible = false;
							if (res.data.code == 0) {
								_this3.$message.success(res.data.message);
								_this3.getPageList();
							} else {
								_this3.$message.error(res.data.message);
							}
						});
					});
				}
			});
		},
		handleyhStatus: function handleyhStatus(index, row) {
			var _this4 = this;

			this.$confirm('确认 ' + row.coName + ' 隐患查验合格吗？', '提示', {}).then(function () {
				var deletecompanyparam = {
					checkNumber: row.checkNumber,
					yhStatus: "CYHG"
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_16" /* updateYhOK */])(deletecompanyparam).then(function (res) {
					if (res.data.code == 0) {
						_this4.$message.success(res.data.message);
						_this4.getPageList();
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			});
		},
		yhDetail: function yhDetail(index, row) {
			var _this5 = this;

			this.detailForm.coName = row.coName;
			this.detailForm.checkNumber = row.checkNumber;
			this.detailForm.checkTime = row.checkTime;
			var para = {
				checkNumber: row.checkNumber
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["_11" /* gjCheckDetailList */])(para).then(function (res) {
				_this5.detailFormVisible = true;
				if (res.data.code == 0) {
					_this5.feedata = res.data.data;
				}
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.getPageList();
	}
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: ''
			},
			companylist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//新增企业信息
			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				coName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
				coHeadName: [{ required: true, message: "请输入法人或负责人姓名", trigger: "blur" }],
				coHeadWidNo: [{ required: true, message: "请输入法人或负责人身份证号", trigger: "blur" }],
				coHeadMobile: [{ required: true, message: "请输入法人或负责人电话", trigger: "blur" }]
			},

			addForm: {
				createUserId: "",
				cityCode: '',
				province: '',

				districtCode: '',
				kdppType: '',

				coName: "",
				coHeadName: "",
				coHeadWidNo: "",
				coHeadMobile: "",
				socialCreditCode: "",
				coAddress: "",
				businessNumber: "",
				coEmail: "",
				coDesc: "",
				businessNumberEffectDate: "",
				selBusinessNumberEffectDate: null
			},

			//编辑企业信息
			editFormTitle: '', //编辑的时候，显示企业名称
			editFormVisible: false,
			editLoading: false,
			editFormRules: {

				coHeadMobile: [{ required: true, message: "请输入法人或负责人电话", trigger: "blur" }]
			},

			editForm: {
				coHeadMobile: "",
				coEmail: "",
				businessNumber: "",
				businessNumberEffectDate: "",
				selBusinessNumberEffectDate: null,

				coAddress: "",
				coDesc: "",

				coId: 0
			},

			poptions: [],
			pvalue: '',
			pvalueid: '',

			coptions: [],
			cvalue: '',
			cvalueid: '',
			cityFix: true,

			//企业详情页面
			detailFormTitle: '', //编辑的时候，显示企业名称
			detailFormVisible: false,

			detailForm: {
				coName: '',
				coHeadName: '',
				coHeadMobile: '',
				coHeadWidNo: '',
				socialCreditCode: '',
				coEmail: '',
				businessNumber: '',
				businessNumberEffectDate: '',
				coAddress: '',
				coDesc: ''
			},

			//品牌选择
			ppoptions: [],
			ppvalue: '',
			//所在区选择
			doptions: [],
			dvalue: '',

			comguestlist: [],
			gtotal: 0,
			gpage: 1,
			curcoId: 0,
			guestcomVisible: false,

			gfilters: {
				guestComName: ''
			},

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/",

			//要导出的数据list
			exportList: [],
			dcLoading: false
			//end
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getCompanyList();
		},

		//获取用户列表
		getCompanyList: function getCompanyList() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_0" /* companyPageList */])(para).then(function (res) {

				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.companylist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},
		isValidIdCard: function isValidIdCard(idCard) {
			var regex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[\dXx]$/;
			if (!regex.test(idCard)) {
				return false;
			}
			var coefficient = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
			var checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
			var sum = 0;
			for (var i = 0; i < 17; i++) {
				sum += parseInt(idCard[i], 10) * coefficient[i];
			}
			var mod = sum % 11;
			var lastChar = idCard[17].toUpperCase(); // 将最后一位转为大写，以支持大小写混合的X
			return checkCode[mod] === lastChar;
		},
		isValidatePhone: function isValidatePhone(phonenumber) {
			// 手机号正则表达式
			var regphone = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
			// 验证手机号
			if (!regphone.test(phonenumber)) {
				return false;
			} else {
				return true;
			}
		},
		isValidateEmail: function isValidateEmail(email) {
			// 邮箱地址email正则表达式
			var regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;

			// 验证手机号
			if (!regEmail.test(email)) {
				return false;
			} else {
				return true;
			}
		},

		//管理员新增企业信息
		handleAdd: function handleAdd() {
			this.addFormVisible = true;

			//二级选项
			this.addForm.province = this.pvalue;
			this.addForm.cityCode = this.cvalue;
			this.addForm.createUserId = this.objectId;

			this.addForm.districtCode = this.dvalue;
			this.addForm.kdppType = this.ppvalue;

			this.addForm.coName = "";
			this.addForm.coHeadName = "";
			this.addForm.coHeadWidNo = "";
			this.addForm.coHeadMobile = "";
			this.addForm.socialCreditCode = "";
			this.addForm.coAddress = "";
			this.addForm.businessNumber = "";
			this.addForm.coEmail = "";
			this.addForm.coDesc = "";
			this.addForm.businessNumberEffectDate = "";
			this.addForm.selBusinessNumberEffectDate = null;
		},
		addCompany: function addCompany() {
			//对于输入邮箱合法性进行判断
			if (this.addForm.coEmail != "") {
				if (this.isValidateEmail(this.addForm.coEmail)) {
					this.addCompanyReq();
				} else {
					this.$message.error("请输入有效的邮箱");
				}
			} else {
				this.addCompanyReq();
			}
		},
		addCompanyReq: function addCompanyReq() {
			var _this2 = this;

			if (this.cvalue == '') {
				this.$message.error("请选择企业所在的城市");
			} else if (this.dvalue == '') {
				this.$message.error("请选择企业所在的区");
			} else {
				//二级选项
				this.addForm.province = this.pvalue;
				this.addForm.cityCode = this.cvalue;
				this.addForm.districtCode = this.dvalue;

				this.addForm.kdppType = this.ppvalue;

				if (this.addForm.selBusinessNumberEffectDate != null) {
					this.addForm.businessNumberEffectDate = this.addForm.selBusinessNumberEffectDate.toLocaleString();
				}

				this.$refs.addForm.validate(function (valid) {
					if (valid) {
						//对于输入电话，身份证号合法性进行判断
						if (!_this2.isValidIdCard(_this2.addForm.coHeadWidNo)) {
							_this2.$message.error("请输入有效的身份证号");
						} else if (!_this2.isValidatePhone(_this2.addForm.coHeadMobile)) {
							_this2.$message.error("请输入有效的手机号");
						} else {
							_this2.$confirm('确认添加企业信息吗？', '提示', {}).then(function () {
								_this2.addLoading = true;

								__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_1" /* addCompany */])(_this2.addForm).then(function (res) {
									_this2.addLoading = false;
									_this2.addFormVisible = false;
									if (res.data.code == 0) {
										_this2.$message.success(res.data.message);
										_this2.getCompanyList();
									} else {
										_this2.$message.error(res.data.message);
									}
								});
							});
						}
					}
				});
			}
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;

			this.editFormTitle = row.coName;

			this.editForm = {
				coHeadMobile: row.coHeadMobile,
				coEmail: row.coEmail,

				businessNumber: row.businessNumber,
				businessNumberEffectDate: "",
				selBusinessNumberEffectDate: row.businessNumberEffectDate,

				coAddress: row.coAddress,
				coDesc: row.coDesc,
				coId: row.coId
			};
		},
		updateInfo: function updateInfo() {
			//对于输入邮箱合法性进行判断
			if (this.editForm.coEmail != "") {
				if (this.isValidateEmail(this.editForm.coEmail)) {
					this.updateCompanyInfo();
				} else {
					this.$message.error("请输入有效的邮箱");
				}
			} else {
				this.updateCompanyInfo();
			}
		},
		updateCompanyInfo: function updateCompanyInfo() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					if (!_this3.isValidatePhone(_this3.editForm.coHeadMobile)) {
						_this3.$message.error("请输入有效的手机号");
					} else {
						_this3.$confirm('确认更新企业信息吗？', '提示', {}).then(function () {
							_this3.editLoading = true;

							if (_this3.editForm.selBusinessNumberEffectDate != null) {
								_this3.editForm.businessNumberEffectDate = _this3.editForm.selBusinessNumberEffectDate.toLocaleString();
							}

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_2" /* editCompany */])(_this3.editForm).then(function (res) {
								_this3.editLoading = false;
								_this3.editFormVisible = false;
								if (res.data.code == 0) {
									_this3.$message.success(res.data.message);

									_this3.getCompanyList();
								} else {
									_this3.$message.error(res.data.message);
								}
							});
						});
					}
				}
			});
		},

		handleDetail: function handleDetail(index, row) {
			this.detailFormVisible = true;

			this.detailForm.coName = row.coName;

			this.detailForm.coHeadName = row.coHeadName;
			this.detailForm.coHeadMobile = row.coHeadMobile;
			this.detailForm.coHeadWidNo = row.coHeadWidNo;

			this.detailForm.socialCreditCode = row.socialCreditCode;
			this.detailForm.coEmail = row.coEmail, this.detailForm.businessNumber = row.businessNumber, this.detailForm.businessNumberEffectDate = row.businessNumberEffectDate;
			this.detailForm.coAddress = row.coAddress;
			this.detailForm.coDesc = row.coDesc;
		},

		handleDelete: function handleDelete(index, row) {
			var _this4 = this;

			this.$confirm('确认删除这个企业吗？', '提示', {}).then(function () {

				var deletecompanyparam = {
					coId: row.coId
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_3" /* deleteCompany */])(deletecompanyparam).then(function (res) {
					if (res.data.code == 0) {
						_this4.$message.success(res.data.message);
						_this4.getCompanyList();
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			}).catch(function () {
				// 用户点了取消 → 必须写 catch，否则控制台报错
				// this.$message.info('已取消');
			});
		},

		ssbmpchange: function ssbmpchange(e) {
			for (var index = 0; index < this.poptions.length; index++) {
				var element = this.poptions[index];
				if (element.MpValue == e) {
					this.pvalueid = element.Mpid;
					this.pvalue = element.MpValue;
					this.getcitiesbyprovince();
					break;
				}
			}
		},
		ssbmcchange: function ssbmcchange(e) {
			for (var index = 0; index < this.coptions.length; index++) {
				var element = this.coptions[index];
				if (element.MpValue == e) {
					this.cvalueid = element.Mpid;
					this.cvalue = element.MpValue;
					this.getdistrictbycity();
					break;
				}
			}
		},

		//省信息
		getprovinces: function getprovinces() {
			var _this5 = this;

			var para = {
				MpType: "SSCC",
				MpParentId: "0"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this5.poptions = res.data.data;
					_this5.pvalueid = _this5.poptions[0].Mpid;
					_this5.pvalue = _this5.poptions[0].MpValue;
					_this5.getcitiesbyprovince();
				}
			});
		},
		getcitiesbyprovince: function getcitiesbyprovince() {
			var _this6 = this;

			var para = {
				MpType: "SSCC",
				MpParentId: this.pvalueid
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this6.coptions = res.data.data;
					if (_this6.cvalue == '') {
						_this6.cvalue = _this6.coptions[0].MpValue;
						_this6.cvalueid = _this6.coptions[0].Mpid;
					} else {
						for (var index = 0; index < _this6.coptions.length; index++) {
							var element = _this6.coptions[index];
							if (element.MpValue == _this6.cvalue) {
								_this6.cvalueid = element.Mpid;
								break;
							}
						}
					}

					_this6.getdistrictbycity();
				}
			});
		},
		getdistrictbycity: function getdistrictbycity() {
			var _this7 = this;

			var para = {
				MpType: "SSCC",
				MpParentId: this.cvalueid
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this7.doptions = res.data.data;
					_this7.dvalue = _this7.doptions[0].MpValue;
				}
			});
		},
		getKDPPdic: function getKDPPdic() {
			var _this8 = this;

			var para = {
				MpType: "KDPP",
				MpParentId: "179"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this8.ppoptions = res.data.data;
					_this8.ppvalue = _this8.ppoptions[0].MpValue;
				}
			});
		},


		// 协议客户管理
		showGuestcompany: function showGuestcompany(index, row) {
			this.guestcomVisible = true;
			this.curcoId = row.coId;
			this.gpage = 0;
			this.guestCompanyList();
		},
		handlegCurrentChange: function handlegCurrentChange(val) {
			this.gpage = val;
			this.guestCompanyList();
		},

		//获取协议客户列表
		guestCompanyList: function guestCompanyList() {
			var _this9 = this;

			var para = {
				page: this.gpage,
				pageSize: 20,
				coId: this.curcoId,
				objectId: this.objectId,
				guestComName: this.gfilters.guestComName
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["Q" /* companyGuestPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this9.gtotal = res.data.data.total;
					_this9.comguestlist = res.data.data.list;
				}
			});
		},

		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.fileUrl;
			this.pdfFileName = "协议";
			this.pdfVisible = true;
		},
		handleWidNoShow: function handleWidNoShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.widUrl;
			this.pdfFileName = "证件";
			this.pdfVisible = true;
		},
		//导出excel
		handledc: function handledc() {
			var _this10 = this;

			this.$confirm('确认导出企业表吗？', '提示', {}).then(function () {
				var para = {
					objectId: _this10.objectId,
					coName: _this10.filters.companyName
				};

				_this10.dcLoading = true;

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_4" /* companyPageListdc */])(para).then(function (res) {
					_this10.dcLoading = false;

					if (res.data.code == 0) {
						//将data数据赋给exportList这个列表，用于当作导出Excel的数据源
						_this10.exportList = res.data.data;

						//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
						_this10.export2Excel();
					} else {
						_this10.$message.error(res.data.message);
					}
				});
			}).catch(function () {
				// 用户点了取消 → 必须写 catch，否则控制台报错
				// this.$message.info('已取消');
			});
		},

		export2Excel: function export2Excel() {
			var _this11 = this;

			__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
				var _require = __webpack_require__(99),
				    export_json_to_excel = _require.export_json_to_excel;

				var tHeader = ["企业名称", "所属区", "品牌", "法人或负责人姓名", "法人或负责人身份证号", "法人或负责人电话", "企业联系邮箱", "社会信用代码", "经营许可证号或分支机构名录号", "许可证有效期", "企业地址"];

				var filterVal = ["coName", "districtName", "kdppTypeName", "coHeadName", "coHeadWidNo", "coHeadMobile", "coEmail", "socialCreditCode", "businessNumber", "businessNumberEffectDate", "coAddress"];

				var list = _this11.exportList;

				var data = _this11.formatJson(filterVal, list);

				export_json_to_excel(tHeader, data, "企业表_" + moment(new Date()).format("YYYYMMDDHHmmss"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},
		formatJson: function formatJson(filterVal, jsonData) {
			return jsonData.map(function (v) {
				return filterVal.map(function (j) {
					return v[j];
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
		} else {
			this.bquery = true;
			this.bshow = false;
		}
		//默认市局管理员创建自己城市的企业
		if (user.data.roleId == "3") {
			this.cvalue = user.data.cityCode;
			this.cityFix = true;
		} else {
			this.cityFix = false;
		}
		this.getCompanyList();
		this.getprovinces();
		this.getKDPPdic();
	}
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: '',
				carNo: ''
			},
			datalist: [],
			total: 0,
			page: 1,
			listLoading: false,

			driveTypeoptions: [],
			driveTypevalue: '',
			transTypeoptions: [],
			transTypevalue: '',
			energyTypeoptions: [],
			energyTypevalue: '',

			//新增
			labelPosition: 'right',

			fileFormVisible: false,
			fileLoading: false,
			fileFormRules: {
				carNo: [{ required: true, message: "请输入车牌号", trigger: "blur" }],
				carType: [{ required: true, message: "请输入车辆型号", trigger: "blur" }]
			},

			fileForm: {
				createUserId: 0,
				coId: 0,

				carNo: "",
				carType: "",

				driveType: "",
				transType: "",
				energyType: ""
			},

			//要导出的数据list
			exportList: [],
			dcLoading: false
			//end

		};
	},

	methods: {

		handleAddbzhFile: function handleAddbzhFile() {
			this.fileFormVisible = true;

			this.fileForm.createUserId = this.objectId;
			this.fileForm.coId = this.coId;

			this.fileForm.carNo = "";
			this.fileForm.carType = "";
			this.fileForm.driveType = "";
			this.fileForm.transType = "";
			this.fileForm.energyType = "";
		},

		handlefile: function handlefile() {
			var _this = this;

			this.$refs.fileForm.validate(function (valid) {
				if (valid) {
					_this.$confirm('确认保存车辆吗？', '提示', {}).then(function () {
						_this.fileLoading = true;

						_this.fileForm.driveType = _this.driveTypevalue;
						_this.fileForm.transType = _this.transTypevalue;
						_this.fileForm.energyType = _this.energyTypevalue;

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["K" /* addCompanyCar */])(_this.fileForm).then(function (res) {
							_this.fileLoading = false;

							_this.fileFormVisible = false;
							if (res.data.code == 0) {
								_this.$message.success(res.data.message);
								//更新列表
								_this.companyCarList();
							} else {
								_this.$message.error(res.data.message);
							}
						});
					});
				}
			});
		},

		handleCarDel: function handleCarDel(index, row) {
			var _this2 = this;

			this.$confirm('确认删除这个车辆吗？', '提示', {}).then(function () {
				var deleteparam = {
					carId: row.carId
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["L" /* deleteCompanyCar */])(deleteparam).then(function (res) {
					if (res.data.code == 0) {
						_this2.$message.success(res.data.message);
						_this2.companyCarList();
					} else {
						_this2.$message.error(res.data.message);
					}
				});
			});
		},

		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.companyCarList();
		},

		//获取文件列表
		companyCarList: function companyCarList() {
			var _this3 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coName: this.filters.companyName,
				coId: this.coId,
				objectId: this.objectId,
				carNo: this.filters.carNo
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["M" /* companyCarPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this3.total = res.data.data.total;
					_this3.datalist = res.data.data.list;
				}

				_this3.listLoading = false;
			});
		},
		getCLJSLXdic: function getCLJSLXdic() {
			var _this4 = this;

			var para = {
				MpType: "CLJSLX",
				MpParentId: "205"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this4.driveTypeoptions = res.data.data;
					_this4.driveTypevalue = _this4.driveTypeoptions[0].MpValue;
				}
			});
		},
		getCLYSLXdic: function getCLYSLXdic() {
			var _this5 = this;

			var para = {
				MpType: "CLYSLX",
				MpParentId: "208"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this5.transTypeoptions = res.data.data;
					_this5.transTypevalue = _this5.transTypeoptions[0].MpValue;
				}
			});
		},
		getCLDLLXdic: function getCLDLLXdic() {
			var _this6 = this;

			var para = {
				MpType: "CLDLLX",
				MpParentId: "211"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this6.energyTypeoptions = res.data.data;
					_this6.energyTypevalue = _this6.energyTypeoptions[0].MpValue;
				}
			});
		},

		//导出excel
		handledc: function handledc() {
			var _this7 = this;

			this.$confirm('确认导出车辆表吗？', '提示', {}).then(function () {
				var para = {
					coName: _this7.filters.companyName,
					coId: _this7.coId,
					objectId: _this7.objectId,
					carNo: _this7.filters.carNo
				};

				_this7.dcLoading = true;

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["N" /* companyCarPageListdc */])(para).then(function (res) {
					_this7.dcLoading = false;
					if (res.data.code == 0) {

						//将data数据赋给exportList这个列表，用于当作导出Excel的数据源							
						_this7.exportList = res.data.data;

						//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
						_this7.export2Excel();
					} else {
						_this7.$message.error(res.data.message);
					}
				});
			}).catch(function () {
				// 用户点了取消 → 必须写 catch，否则控制台报错
				// this.$message.info('已取消');
			});
		},

		export2Excel: function export2Excel() {
			var _this8 = this;

			__webpack_require__.e/* require.ensure */(0).then((function () {
				var _require = __webpack_require__(99),
				    export_json_to_excel = _require.export_json_to_excel;

				var tHeader = ["所属企业", "车牌号", "车辆型号", "驾驶类型", "运输类型", "动力类型"];

				var filterVal = ["coName", "carNo", "carType", "driveTypeName", "transTypeName", "energyTypeName"];

				var list = _this8.exportList;

				var data = _this8.formatJson(filterVal, list);

				export_json_to_excel(tHeader, data, "车辆表_" + moment(new Date()).format("YYYYMMDDHHmmss"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},
		formatJson: function formatJson(filterVal, jsonData) {
			return jsonData.map(function (v) {
				return filterVal.map(function (j) {
					return v[j];
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));

		this.coId = user.data.coId;
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		this.companyCarList();
		this.getCLJSLXdic();
		this.getCLYSLXdic();
		this.getCLDLLXdic();
	}
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: '',
				fileName: ''
			},
			companyfilelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			fileTypeoptions: [],
			fileTypevalue: '',

			//新增文件
			labelPosition: 'right',

			imageFile: null,

			uploadstart: true,

			fileFormVisible: false,
			fileLoading: false,
			fileFormRules: {
				fileName: [{ required: true, message: "请输入文件名称", trigger: "blur" }],
				fileNf: [{ required: true, message: "请输入年份数字", trigger: "blur" }]
			},

			fileForm: {
				createUserId: 0,
				coId: 0,

				uniqueCode: "",

				fileType: "",
				fileName: "",
				fileNf: "",
				fileUrl: ""
			},

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/",

			//要导出的数据list
			exportList: [],
			dcLoading: false
			//end

		};
	},

	methods: {

		handleAddbzhFile: function handleAddbzhFile() {
			this.fileFormVisible = true;
			this.uploadstart = true;
			this.imageFile = null;

			this.fileForm.uniqueCode = "yhpczl_" + this.objectId;
			this.fileForm.createUserId = this.objectId;
			this.fileForm.coId = this.coId;
			this.fileForm.fileNf = "";
			this.fileForm.fileName = "";
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}
		},
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'pdf') {
				this.fileForm.fileName = filearr[0];
				this.imageFile = event.target.files[0];
			} else {
				this.fileForm.fileName = "";
				this.imageFile = null;
				this.$message.error("请选择pdf格式的文件");
			}
		},
		uploadCompanyFile: function uploadCompanyFile() {
			var _this = this;

			if (this.imageFile != null) {
				var formData = new FormData();
				formData.append('file', this.imageFile);
				formData.append('filetype', "Yhpczl");
				formData.append('secondarydir', this.fileForm.uniqueCode);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this.fileForm.fileUrl = response.data.data.url;
						_this.uploadstart = false;
						_this.$message.success("文件上传成功，请填写其他信息后点击保存");
					} else {
						_this.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		handlefile: function handlefile() {
			var _this2 = this;

			if (this.fileForm.fileUrl != "") {
				this.$refs.fileForm.validate(function (valid) {
					if (valid) {
						_this2.$confirm('确认提交文件吗？', '提示', {}).then(function () {
							_this2.fileLoading = true;

							_this2.fileForm.fileType = _this2.fileTypevalue;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["R" /* addCompanyFile */])(_this2.fileForm).then(function (res) {
								_this2.fileLoading = false;

								_this2.fileFormVisible = false;
								if (res.data.code == 0) {
									_this2.$message.success(res.data.message);
									//更新列表
									_this2.companyFileList();
								} else {
									_this2.$message.error(res.data.message);
								}
							});
						});
					}
				});
			} else {
				this.$message.error("请选择文件后，点击右侧的【上传】按钮，上传文件");
			}
		},
		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.fileUrl;
			this.pdfFileName = row.fileName;
			this.pdfVisible = true;
		},
		handleFileDel: function handleFileDel(index, row) {
			var _this3 = this;

			this.$confirm('确认删除这个文件吗？', '提示', {}).then(function () {
				var deleteparam = {
					fileId: row.fileId
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["S" /* deletecompanyFile */])(deleteparam).then(function (res) {
					if (res.data.code == 0) {
						_this3.$message.success(res.data.message);
						_this3.companyFileList();
					} else {
						_this3.$message.error(res.data.message);
					}
				});
			});
		},

		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.companyFileList();
		},

		//获取文件列表
		companyFileList: function companyFileList() {
			var _this4 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coName: this.filters.companyName,
				coId: this.coId,
				objectId: this.objectId,
				fileName: this.filters.fileName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["T" /* companyFilePageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this4.total = res.data.data.total;
					_this4.companyfilelist = res.data.data.list;
				}

				_this4.listLoading = false;
			});
		},
		getWJLXdic: function getWJLXdic() {
			var _this5 = this;

			var para = {
				MpType: "WJLX",
				MpParentId: "26"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this5.fileTypeoptions = res.data.data;
					_this5.fileTypevalue = _this5.fileTypeoptions[0].MpValue;
				}
			});
		},

		//导出excel
		handledc: function handledc() {
			var _this6 = this;

			this.$confirm('确认导出文件表吗？', '提示', {}).then(function () {
				var para = {
					coName: _this6.filters.companyName,
					coId: _this6.coId,
					objectId: _this6.objectId,
					fileName: _this6.filters.fileName
				};

				_this6.dcLoading = true;

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["U" /* companyFilePageListdc */])(para).then(function (res) {
					_this6.dcLoading = false;
					if (res.data.code == 0) {
						// 循环处理每一项url
						var datalist = res.data.data;
						datalist.forEach(function (item) {
							// 如果 item 本身有 url，就拼接 https
							if (item.fileUrl) {
								item.pdfsrc = _this6.filebaseurl + item.fileUrl;
							}
						});
						//将data数据赋给exportList这个列表，用于当作导出Excel的数据源							
						_this6.exportList = datalist;

						//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
						_this6.export2Excel();
					} else {
						_this6.$message.error(res.data.message);
					}
				});
			}).catch(function () {
				// 用户点了取消 → 必须写 catch，否则控制台报错
				// this.$message.info('已取消');
			});
		},

		export2Excel: function export2Excel() {
			var _this7 = this;

			__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
				var _require = __webpack_require__(99),
				    export_json_to_excel = _require.export_json_to_excel;

				var tHeader = ["所属企业", "文件名称", "文件类型", "提交日期", "文件地址"];

				var filterVal = ["coName", "fileName", "fileTypeName", "createTime", "pdfsrc"];

				var list = _this7.exportList;

				var data = _this7.formatJson(filterVal, list);

				export_json_to_excel(tHeader, data, "资料表_" + moment(new Date()).format("YYYYMMDDHHmmss"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},
		formatJson: function formatJson(filterVal, jsonData) {
			return jsonData.map(function (v) {
				return filterVal.map(function (j) {
					return v[j];
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));

		this.coId = user.data.coId;
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		this.companyFileList();
		this.getWJLXdic();
	}
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限

			filters: {
				guestComName: ''
			},
			comguestlist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//新增文件
			labelPosition: 'right',

			imageFile: null,
			uploadstart: true,

			imageFileWid: null,
			uploadstartWid: true,

			guestFormVisible: false,
			fileLoading: false,
			guestFormRules: {
				guestComName: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
				guestName: [{ required: true, message: "请输入法人或寄件人姓名", trigger: "blur" }],
				guestPhone: [{ required: true, message: "请输入法人或寄件人电话", trigger: "blur" }],
				guestWid: [{ required: true, message: "请输入法人或寄件人身份证号", trigger: "blur" }],
				guestGoods: [{ required: true, message: "请输入物品名称", trigger: "blur" }],
				guestDate: [{ required: true, message: "请选择协议签订时间", trigger: "blur" }]
			},

			guestForm: {
				createUserId: 0,
				coId: 0,
				guestComName: "",
				guestName: "",
				guestPhone: "",
				guestWid: "",
				guestGoods: "",
				guestCode: "",
				fileUrl: "",
				fileName: "",
				widUrl: "",
				widName: "",

				guestDate: '',
				selGuestDate: null
			},

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/",

			//更新用户证件信息
			guestFormUpdateVisible: false,
			fileLoadingUpdate: false,
			guestFormUpdateRules: {
				// guestComName: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
				// guestName: [{ required: true, message: "请输入法人或寄件人姓名", trigger: "blur" }],
				// guestPhone: [{ required: true, message: "请输入法人或寄件人电话", trigger: "blur" }],
				// guestWid: [{ required: true, message: "请输入法人或寄件人身份证号", trigger: "blur" }],
				// guestGoods: [{ required: true, message: "请输入物品名称", trigger: "blur" }],
				// guestDate: [{ required: true, message: "请选择协议签订时间", trigger: "blur" }]
			},
			guestFormUpdate: {
				guestId: 0,
				guestComName: "",
				// guestName:"",
				// guestPhone:"",
				// guestWid:"",
				// guestGoods:"",
				// guestCode:"",
				fileUrl: "",
				fileName: "",
				widUrl: "",
				widName: ""

				// guestDate:'',
				// selGuestDate:null,	
			},

			newimageFile: null,
			newuploadstart: true,

			newimageFileWid: null,
			newuploadstartWid: true
		};
	},

	methods: {

		handleAddbzhFile: function handleAddbzhFile() {
			this.guestFormVisible = true;

			this.guestForm.createUserId = this.objectId;
			this.guestForm.coId = this.coId;

			this.guestForm.guestComName = "";
			this.guestForm.guestName = "";
			this.guestForm.guestPhone = "";
			this.guestForm.guestGoods = "";
			this.guestForm.guestCode = "";

			this.guestForm.guestWid = "";
			this.guestForm.guestDate = '';
			this.guestForm.selGuestDate = null;

			this.uploadstart = true;
			this.imageFile = null;
			this.guestForm.fileName = "";
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}

			this.uploadstartWid = true;
			this.imageFileWid = null;
			this.guestForm.widName = "";
			if (this.$refs.upLoadRefWid) {
				this.$refs.upLoadRefWid.value = ''; // 置空input文件
			}
		},
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'pdf') {
				this.guestForm.fileName = filearr[0];
				this.imageFile = event.target.files[0];
			} else {
				this.guestForm.fileName = "";
				this.imageFile = null;
				this.$message.error("请选择pdf格式的文件");
			}
		},
		uploadXyFile: function uploadXyFile() {
			var _this = this;

			if (this.imageFile != null) {
				var formData = new FormData();
				formData.append('file', this.imageFile);
				formData.append('filetype', "xykh");
				formData.append('secondarydir', this.coId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this.guestForm.fileUrl = response.data.data.url;
						_this.uploadstart = false;
						_this.$message.success("文件上传成功，请确认其他信息后点击保存");
					} else {
						_this.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},
		handleFileUploadWid: function handleFileUploadWid(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'pdf') {
				this.guestForm.widName = filearr[0];
				this.imageFileWid = event.target.files[0];
			} else {
				this.guestForm.widName = "";
				this.imageFileWid = null;
				this.$message.error("请选择pdf格式的文件");
			}
		},
		uploadWidFile: function uploadWidFile() {
			var _this2 = this;

			if (this.imageFileWid != null) {
				var formData = new FormData();
				formData.append('file', this.imageFileWid);
				formData.append('filetype', "xykh");
				formData.append('secondarydir', this.coId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this2.guestForm.widUrl = response.data.data.url;
						_this2.uploadstartWid = false;
						_this2.$message.success("文件上传成功，请确认其他信息后点击保存");
					} else {
						_this2.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		addcomGuest: function addcomGuest() {
			var _this3 = this;

			if (this.guestForm.selGuestDate != null) {
				this.guestForm.guestDate = this.guestForm.selGuestDate.toLocaleString();
			}
			if (this.guestForm.guestDate == "") {
				this.$message.error("请选择协议签订时间");
			} else if (this.guestForm.fileUrl != "" && this.guestForm.widUrl != "") {
				this.$refs.guestForm.validate(function (valid) {
					if (valid) {
						_this3.$confirm('确认提交这个协议客户吗？', '提示', {}).then(function () {
							_this3.fileLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["O" /* addCompanyGuest */])(_this3.guestForm).then(function (res) {
								_this3.fileLoading = false;

								_this3.guestFormVisible = false;
								if (res.data.code == 0) {
									_this3.$message.success(res.data.message);
									//更新列表
									_this3.guestCompanyList();
								} else {
									_this3.$message.error(res.data.message);
								}
							});
						});
					}
				});
			} else {
				this.$message.error("请选择文件后，点击右侧的【上传】按钮，上传文件");
			}
		},
		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.fileUrl;
			this.pdfFileName = "协议";
			this.pdfVisible = true;
		},
		handleWidNoShow: function handleWidNoShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.widUrl;
			this.pdfFileName = "证件";
			this.pdfVisible = true;
		},
		handleGuestDel: function handleGuestDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除这个协议客户吗？', '提示', {}).then(function () {
				var deleteparam = {
					guestId: row.guestId,
					deleteStatus: "1"
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["P" /* updateCompanyGuest */])(deleteparam).then(function (res) {
					if (res.data.code == 0) {
						_this4.$message.success(res.data.message);
						_this4.guestCompanyList();
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			});
		},

		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.guestCompanyList();
		},

		//获取协议客户列表
		guestCompanyList: function guestCompanyList() {
			var _this5 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coId: "",
				objectId: this.objectId,
				guestComName: this.filters.guestComName
			};

			if (!this.bquery) {
				para.coId = this.coId;
			}

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["Q" /* companyGuestPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this5.total = res.data.data.total;
					_this5.comguestlist = res.data.data.list;
				}

				_this5.listLoading = false;
			});
		},

		updateFileShow: function updateFileShow(index, row) {
			this.guestFormUpdateVisible = true;

			this.guestFormUpdate.guestId = row.guestId;
			this.guestFormUpdate.guestComName = row.guestComName;

			this.guestFormUpdate.fileUrl = "", this.guestFormUpdate.widUrl = "", this.newuploadstart = true;
			this.newimageFile = null;
			this.guestFormUpdate.fileName = "";
			if (this.$refs.newupLoadRef) {
				this.$refs.newupLoadRef.value = ''; // 置空input文件
			}

			this.newuploadstartWid = true;
			this.newimageFileWid = null;
			this.guestFormUpdate.widName = "";
			if (this.$refs.newupLoadRefWid) {
				this.$refs.newupLoadRefWid.value = ''; // 置空input文件
			}
		},
		newhandleFileUpload: function newhandleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'pdf') {
				this.guestFormUpdate.fileName = filearr[0];
				this.newimageFile = event.target.files[0];
			} else {
				this.guestFormUpdate.fileName = "";
				this.newimageFile = null;
				this.$message.error("请选择pdf格式的文件");
			}
		},
		newuploadXyFile: function newuploadXyFile() {
			var _this6 = this;

			if (this.newimageFile != null) {
				var formData = new FormData();
				formData.append('file', this.newimageFile);
				formData.append('filetype', "xykh");
				formData.append('secondarydir', this.coId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this6.guestFormUpdate.fileUrl = response.data.data.url;
						_this6.newuploadstart = false;
						_this6.$message.success("文件上传成功，请确认其他信息后点击保存");
					} else {
						_this6.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},
		newhandleFileUploadWid: function newhandleFileUploadWid(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'pdf') {
				this.guestFormUpdate.widName = filearr[0];
				this.newimageFileWid = event.target.files[0];
			} else {
				this.guestFormUpdate.widName = "";
				this.newimageFileWid = null;
				this.$message.error("请选择pdf格式的文件");
			}
		},
		newuploadWidFile: function newuploadWidFile() {
			var _this7 = this;

			if (this.newimageFileWid != null) {
				var formData = new FormData();
				formData.append('file', this.newimageFileWid);
				formData.append('filetype', "xykh");
				formData.append('secondarydir', this.coId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this7.guestFormUpdate.widUrl = response.data.data.url;
						_this7.newuploadstartWid = false;
						_this7.$message.success("文件上传成功，请确认其他信息后点击保存");
					} else {
						_this7.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		updatecomGuest: function updatecomGuest(index, row) {
			var _this8 = this;

			this.$confirm('确认更新协议客户的资料吗？', '提示', {}).then(function () {
				var newparam = {
					guestId: _this8.guestFormUpdate.guestId,
					fileName: _this8.guestFormUpdate.fileName,
					fileUrl: _this8.guestFormUpdate.fileUrl,
					widName: _this8.guestFormUpdate.widName,
					widUrl: _this8.guestFormUpdate.widUrl
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["P" /* updateCompanyGuest */])(newparam).then(function (res) {

					_this8.fileLoadingUpdate = false;

					_this8.guestFormUpdateVisible = false;

					if (res.data.code == 0) {
						_this8.$message.success(res.data.message);
						_this8.guestCompanyList();
					} else {
						_this8.$message.error(res.data.message);
					}
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.coId = user.data.coId;
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.bquery = false;
		} else {
			this.bquery = true;
		}

		this.guestCompanyList();
	}
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: '',
				workerName: "",
				phone: "",
				widNo: "",
				dvalue: ''
			},
			memberlist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//编辑信息
			editFormTitle: '', //编辑的时候，显示人员姓名
			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				phone: [{ required: true, message: "请输入手机号", trigger: "blur" }]
			},

			editForm: {
				workerId: '',

				phone: "",
				workerType: "",
				loginname: "",
				loginpwd: ""
			},

			//新增人员
			addryFormVisible: false,
			addryFormRules: {
				name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
				widNo: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
				phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
				enterDate: [{ required: true, message: "请选择入职时间", trigger: "blur" }]
			},

			addryForm: {
				createUserId: 0,
				coId: 0,

				name: "",
				widNo: "",
				phone: "",
				workerType: "",
				loginname: "",
				loginpwd: "",

				laborContract: '0',
				buyInsurance: '0',
				insurancetype: '',
				enterDate: '',
				selEnterDate: null
			},
			gwoptions: [],
			gwvalue: '',

			labelPosition: 'right',

			//快递人员保险，多选
			bxoptions: [],
			bxselectedValues: [],

			insuranceoptions: [{
				value: '0',
				label: '未购买'
			}, {
				value: '1',
				label: '已购买'
			}],

			laboroptions: [{
				value: '0',
				label: '未签订'
			}, {
				value: '1',
				label: '已签订'
			}],
			//市局管理员支持区查询功能
			doptions: [],
			cvalue: '',
			cvalueid: '',
			cityFix: false,

			//要导出的数据list
			exportList: [],
			dcLoading: false
			//end
		};
	},

	methods: {
		isValidIdCard: function isValidIdCard(idCard) {
			var regex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[\dXx]$/;
			if (!regex.test(idCard)) {
				return false;
			}
			var coefficient = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
			var checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
			var sum = 0;
			for (var i = 0; i < 17; i++) {
				sum += parseInt(idCard[i], 10) * coefficient[i];
			}
			var mod = sum % 11;
			var lastChar = idCard[17].toUpperCase(); // 将最后一位转为大写，以支持大小写混合的X
			return checkCode[mod] === lastChar;
		},
		isValidatePhone: function isValidatePhone(phonenumber) {
			// 手机号正则表达式
			var regphone = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
			// 验证手机号
			if (!regphone.test(phonenumber)) {
				return false;
			} else {
				return true;
			}
		},


		showAddry: function showAddry(index, row) {
			this.addryForm = {
				createUserId: this.objectId,
				coId: this.coId,
				name: "",
				widNo: "",
				phone: "",
				workerType: "",
				loginname: "",
				loginpwd: "",
				laborContract: '0',
				buyInsurance: '0',
				insurancetype: '',
				enterDate: '',
				selEnterDate: null
			}, this.bxselectedValues = [];
			this.gwvalue = this.gwoptions[0].MpValue;
			this.addryFormVisible = true;
		},
		handleAddry: function handleAddry() {
			var _this = this;

			//入职时间
			if (this.addryForm.selEnterDate != null) {
				this.addryForm.enterDate = this.addryForm.selEnterDate.toLocaleString();
			}
			if (this.addryForm.enterDate == "") {
				this.$message.error("请选择人员的入职时间");
			} else if (this.addryForm.buyInsurance == '1' && this.bxselectedValues.length == 0) {
				this.$message.error("请选择人员的保险类别");
			} else {

				//校验身份证是否合法,手机号是否合法
				this.addryForm.workerType = this.gwvalue;
				if (this.bxselectedValues.length > 0) {
					this.addryForm.insurancetype = this.bxselectedValues.join(',');
				}

				this.$refs.addryForm.validate(function (valid) {
					if (valid) {
						if (!_this.isValidIdCard(_this.addryForm.widNo)) {
							_this.$message.error("请输入有效的身份证号");
						} else if (!_this.isValidatePhone(_this.addryForm.phone)) {
							_this.$message.error("请输入有效的手机号");
						} else {
							_this.$confirm('确认新增人员吗？', '提示', {}).then(function () {
								__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["V" /* addMember */])(_this.addryForm).then(function (res) {
									if (res.data.code == 0) {
										_this.addryFormVisible = false;
										_this.$message.success(res.data.message);
										_this.getMemberList();
									} else {
										_this.$message.error(res.data.message);
									}
								});
							});
						}
					}
				});
			}
		},

		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getMemberList();
		},

		//获取用户列表
		getMemberList: function getMemberList() {
			var _this2 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coName: this.filters.companyName,
				coId: this.coId,
				objectId: this.objectId,
				workerName: this.filters.workerName,
				phone: this.filters.phone,
				widNo: this.filters.widNo,
				dvalue: this.filters.dvalue
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["W" /* memberPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.total = res.data.data.total;
					_this2.memberlist = res.data.data.list;
				}

				_this2.listLoading = false;
			});
		},


		handleEdit: function handleEdit(index, row) {
			this.editForm.phone = row.phone;
			this.editForm.workerType = row.workerType;
			this.gwvalue = row.workerType;

			this.editForm.workerId = row.workerId;
			this.editFormVisible = true;

			this.editFormTitle = "编辑【" + row.name + "】人员信息";
		},

		//编辑
		editMember: function editMember() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					if (_this3.isValidatePhone(_this3.editForm.phone)) {
						_this3.$confirm('确认提交吗？', '提示', {}).then(function () {
							_this3.editLoading = true;
							_this3.editForm.workerType = _this3.gwvalue;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["X" /* editMemberInfo */])(_this3.editForm).then(function (res) {
								_this3.editLoading = false;

								if (res.data.code == 0) {
									_this3.$message({
										message: '更新成功',
										type: 'success'
									});
									_this3.$refs['editForm'].resetFields();
									_this3.editFormVisible = false;
									_this3.getMemberList();
								} else {
									_this3.$message.error(res.data.message);
								}
							});
						});
					} else {
						_this3.$message.error("请输入有效的手机号");
					}
				}
			});
		},
		handleDel: function handleDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除这个人员吗？', '提示', {}).then(function () {
				var para = {
					workerId: row.workerId
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["Y" /* deleteMember */])(para).then(function (res) {
					if (res.data.code == 0) {
						_this4.$message({
							message: '删除成功',
							type: 'success'
						});

						_this4.getMemberList();
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			}).catch(function () {
				// 用户点了取消 → 必须写 catch，否则控制台报错
				// this.$message.info('已取消');
			});
		},
		getRYGWdic: function getRYGWdic() {
			var _this5 = this;

			var para = {
				MpType: "RYGW",
				MpParentId: "1"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this5.gwoptions = res.data.data;
					_this5.gwvalue = _this5.gwoptions[0].MpValue;
				}
			});
		},
		getKDRYBXdic: function getKDRYBXdic() {
			var _this6 = this;

			var para = {
				MpType: "KDRYBX",
				MpParentId: "178"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this6.bxoptions = res.data.data;
				}
			});
		},
		getcitiesbyprovince: function getcitiesbyprovince() {
			var _this7 = this;

			var para = {
				MpType: "SSCC",
				MpParentId: 14
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {

					for (var index = 0; index < res.data.data.length; index++) {
						var element = res.data.data[index];
						if (element.MpValue == _this7.cvalue) {
							_this7.cvalueid = element.Mpid;
							break;
						}
					}

					_this7.getdistrictbycity();
				}
			});
		},
		getdistrictbycity: function getdistrictbycity() {
			var _this8 = this;

			var para = {
				MpType: "SSCC",
				MpParentId: this.cvalueid
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this8.doptions = res.data.data;
				}
			});
		},

		//导出excel
		handledc: function handledc() {
			var _this9 = this;

			this.$confirm('确认导出人员表吗？', '提示', {}).then(function () {
				var para = {
					coName: _this9.filters.companyName,
					coId: _this9.coId,
					objectId: _this9.objectId,
					workerName: _this9.filters.workerName,
					phone: _this9.filters.phone,
					widNo: _this9.filters.widNo,
					dvalue: _this9.filters.dvalue
				};

				_this9.dcLoading = true;

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["Z" /* memberPageListdc */])(para).then(function (res) {
					_this9.dcLoading = false;

					if (res.data.code == 0) {
						//将data数据赋给exportList这个列表，用于当作导出Excel的数据源
						_this9.exportList = res.data.data;

						//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
						_this9.export2Excel();
					} else {
						_this9.$message.error(res.data.message);
					}
				});
			}).catch(function () {
				// 用户点了取消 → 必须写 catch，否则控制台报错
				// this.$message.info('已取消');
			});
		},

		export2Excel: function export2Excel() {
			var _this10 = this;

			__webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
				var _require = __webpack_require__(99),
				    export_json_to_excel = _require.export_json_to_excel;

				var tHeader = ["所属企业", "姓名", "性别", "身份证号", "手机号", "合同状态", "保险状态", "岗位", "入职时间"];

				var filterVal = ["coName", "name", "sexName", "widNo", "phone", "laborContractName", "insurancetypeName", "workerTypeName", "enterDate"];

				var list = _this10.exportList;

				var data = _this10.formatJson(filterVal, list);

				export_json_to_excel(tHeader, data, "人员表_" + moment(new Date()).format("YYYYMMDDHHmmss"));
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		},
		formatJson: function formatJson(filterVal, jsonData) {
			return jsonData.map(function (v) {
				return filterVal.map(function (j) {
					return v[j];
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.coId = user.data.coId;
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		//市局管理员支持按区查询
		this.cityFix = false;
		if (user.data.roleId == "3") {
			this.cvalue = user.data.cityCode;
			this.cityFix = true;
			this.getcitiesbyprovince();
		}
		this.getMemberList();
		this.getRYGWdic();
		this.getKDRYBXdic();
	}
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限


			filters: {
				companyName: '',
				trainName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//上传附件
			uploadstart: true,
			fcfile: null,

			//新增
			fileFormVisible: false,
			fileLoading: false,
			fileFormRules: {
				trainName: [{ required: true, message: "请输入培训名称", trigger: "blur" }],
				trainMember: [{ required: true, message: "请输入参训人员", trigger: "blur" }],
				trainContent: [{ required: true, message: "请输入培训内容", trigger: "blur" }],
				trainDate: [{ required: true, message: "请选择培训时间", trigger: "blur" }]
			},

			fileForm: {
				createUserId: 0,
				coId: 0,

				trainName: "",
				trainMember: "",
				trainContent: "",
				trainFileURL: "",

				trainDate: "",
				selTrainDate: null
			}

		};
	},

	methods: {
		handleDownloadFile: function handleDownloadFile(index, row) {
			if (row.correctFileURL != "") {
				var zipurl = "https://aqjg.ycsyzglj.com/" + row.trainFileURL;
				var a = document.createElement("a"); //创建a标签
				a.setAttribute("href", zipurl); //设置文件下载地址
				a.setAttribute('target', '_blank'); //在当前页面创建下载
				document.body.appendChild(a); //添加到body
				a.click(); //触发事件
				document.body.removeChild(a); //移除标签
			}
		},
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'zip') {
				this.fcfile = event.target.files[0];
			} else {
				this.fcfile = null;
				this.$message.error("请选择zip格式的文件");
			}
		},
		uploadTrainFile: function uploadTrainFile() {
			var _this = this;

			if (this.fcfile != null) {
				var formData = new FormData();
				formData.append('file', this.fcfile);
				formData.append('filetype', "Yhpczl");
				formData.append('secondarydir', "train_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this.fileForm.trainFileURL = response.data.data.url;
						_this.uploadstart = false;
						_this.$message.success("文件上传成功，请填写其他信息后点击保存");
					} else {
						_this.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this2 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coName: this.filters.companyName,
				coId: this.coId,
				objectId: this.objectId,
				trainName: this.filters.trainName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["u" /* companyTrainPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.total = res.data.data.total;
					_this2.pagelist = res.data.data.list;
				}

				_this2.listLoading = false;
			});
		},


		showAddRecord: function showAddRecord(index, row) {
			this.fileFormVisible = true;

			this.fileForm.createUserId = this.objectId;
			this.fileForm.coId = this.coId;

			this.fileForm.trainName = "";
			this.fileForm.trainMember = "";
			this.fileForm.trainContent = "";

			this.fileForm.trainDate = "";
			this.fileForm.selTrainDate = null;

			this.fileForm.trainFileURL = "";
			this.fcfile = null;
			this.uploadstart = true;
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}
		},
		handlefile: function handlefile() {
			var _this3 = this;

			if (this.fileForm.trainFileURL != "") {
				if (this.fileForm.selTrainDate != null) {
					this.fileForm.trainDate = this.fileForm.selTrainDate.toLocaleString();
				}
				// if (this.fileForm.trainDate!=null) {
				this.$refs.fileForm.validate(function (valid) {
					if (valid) {
						_this3.$confirm('确认提交培训记录吗？', '提示', {}).then(function () {
							_this3.fileLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["v" /* addCompanyTrain */])(_this3.fileForm).then(function (res) {
								_this3.fileLoading = false;
								_this3.fileFormVisible = false;
								if (res.data.code == 0) {
									_this3.$message.success(res.data.message);
									_this3.getPageList();
								} else {
									_this3.$message.error(res.data.message);
								}
							});
						});
					}
				});
				// } else {
				// 	this.$message.error("请选择培训时间");
				// }
			} else {
				this.$message.error("请上传培训相关的资料（zip格式）");
			}
		},
		handleTrainDel: function handleTrainDel(index, row) {
			var _this4 = this;

			this.$confirm('确认删除这条培训记录吗？', '提示', {}).then(function () {
				var deleteparam = {
					trainId: row.trainId
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["w" /* deleteCompanyTrain */])(deleteparam).then(function (res) {
					if (res.data.code == 0) {
						_this4.$message.success(res.data.message);
						_this4.getPageList();
					} else {
						_this4.$message.error(res.data.message);
					}
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.coId = user.data.coId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bquery = false;
		} else {
			this.bquery = true;
		}

		this.getPageList();
	}
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id
			bquery: false, //管理员权限
			filters: {
				companyName: '',
				checkTitle: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false

		};
	},

	methods: {
		handleDownloadFile: function handleDownloadFile(index, row) {
			if (row.correctURL != "") {
				var zipurl = "https://aqjg.ycsyzglj.com/" + row.correctURL;
				var a = document.createElement("a"); //创建a标签
				a.setAttribute("href", zipurl); //设置文件下载地址
				a.setAttribute('target', '_blank'); //在当前页面创建下载
				document.body.appendChild(a); //添加到body
				a.click(); //触发事件
				document.body.removeChild(a); //移除标签
			}
		},
		handleDownloadCheckFile: function handleDownloadCheckFile(index, row) {
			if (row.checkURL != "") {
				var zipurl = "https://aqjg.ycsyzglj.com/" + row.checkURL;
				var a = document.createElement("a"); //创建a标签
				a.setAttribute("href", zipurl); //设置文件下载地址
				a.setAttribute('target', '_blank'); //在当前页面创建下载
				document.body.appendChild(a); //添加到body
				a.click(); //触发事件
				document.body.removeChild(a); //移除标签
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coName: this.filters.companyName,
				coId: this.coId,
				objectId: this.objectId,
				checkTitle: this.filters.checkTitle,
				checkStatus: "1"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["r" /* govCheckPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.pagelist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.coId = user.data.coId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bquery = false;
		} else {
			this.bquery = true;
		}

		this.getPageList();
	}
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id
			bquery: false, //管理员权限
			filters: {
				companyName: '',
				checkTitle: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,
			labelPosition: 'right',
			enterpriseList: [], // 企业列表（从后端接口获取）

			//上传附件
			uploadstart: true,
			fcfile: null,

			//新增
			fileFormVisible: false,
			fileLoading: false,
			fileFormRules: {
				checkTitle: [{ required: true, message: "请输入检查标题", trigger: "blur" }],
				checkContent: [{ required: true, message: "请输入检查内容", trigger: "blur" }],
				checkDate: [{ required: true, message: "请选择检查时间", trigger: "blur" }]
			},

			fileForm: {
				createUserId: 0,
				enterpriseIds: [], // 存储勾选的企业ID

				checkTitle: "",
				checkContent: "",
				checkDate: "",
				selCheckDate: null,

				checkURL: ""
			},

			uploadstart1: true,
			fcfile1: null,

			//编辑信息
			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				correctContent: [{ required: true, message: "请输入整改说明", trigger: "blur" }],
				correctDate: [{ required: true, message: "请选择整改时间", trigger: "blur" }]
			},

			editForm: {
				govcheckId: '',
				correctContent: '',
				correctDate: "",
				checkStatus: "1",
				selCorrectDate: null,

				correctURL: ""
			}
		};
	},

	methods: {
		handleDownloadFile: function handleDownloadFile(index, row) {
			if (row.checkURL != "") {
				var zipurl = "https://aqjg.ycsyzglj.com/" + row.checkURL;
				var a = document.createElement("a"); //创建a标签
				a.setAttribute("href", zipurl); //设置文件下载地址
				a.setAttribute('target', '_blank'); //在当前页面创建下载
				document.body.appendChild(a); //添加到body
				a.click(); //触发事件
				document.body.removeChild(a); //移除标签
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				coName: this.filters.companyName,
				coId: this.coId,
				objectId: this.objectId,
				checkTitle: this.filters.checkTitle,
				checkStatus: "0"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["r" /* govCheckPageList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.pagelist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},

		//获取全部客户列表
		getAllcompanyList: function getAllcompanyList() {
			var _this2 = this;

			var para = {
				objectId: this.objectId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["o" /* allCompanyList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.enterpriseList = res.data.data;
				}
			});
		},

		// 勾选指定企业：记录企业ID
		handleEnterpriseSelect: function handleEnterpriseSelect(selection) {
			this.fileForm.enterpriseIds = selection.map(function (item) {
				return item.coId;
			});
		},

		showAddRecord: function showAddRecord(index, row) {
			if (this.enterpriseList.length == 0) {
				this.$message.error("请先创建企业");
			} else {
				this.fileFormVisible = true;

				this.fileForm.createUserId = this.objectId;

				this.fileForm.checkTitle = "";
				this.fileForm.checkContent = "";
				this.fileForm.checkDate = "";
				this.fileForm.selCheckDate = null;

				this.fileForm.checkURL = "";
				this.fcfile = null;
				this.uploadstart = true;
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = ''; // 置空input文件
				}
			}
		},
		handlefile: function handlefile() {
			var _this3 = this;

			if (this.fileForm.enterpriseIds.length == 0) {
				this.$message.error("请选择整改企业");
			} else {
				if (this.fileForm.selCheckDate != null) {
					this.fileForm.checkDate = this.fileForm.selCheckDate.toLocaleString();
				}
				this.$refs.fileForm.validate(function (valid) {
					if (valid) {
						_this3.$confirm('确认提交检查记录吗？', '提示', {}).then(function () {
							_this3.fileLoading = true;
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["s" /* addGovCheck */])(_this3.fileForm).then(function (res) {
								_this3.fileLoading = false;

								// 1. 清空选中数组
								_this3.fileForm.enterpriseIds = [];

								// 2. 关键！清空表格勾选状态（必须加）
								_this3.$refs.enterpriseTable.clearSelection();

								_this3.fileFormVisible = false;
								if (res.data.code == 0) {
									_this3.$message.success(res.data.message);
									_this3.getPageList();
								} else {
									_this3.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'zip') {
				this.fcfile = event.target.files[0];
			} else {
				this.fcfile = null;
				this.$message.error("请选择zip格式的文件");
			}
		},
		uploadTrainFile: function uploadTrainFile() {
			var _this4 = this;

			if (this.fcfile != null) {
				var formData = new FormData();
				formData.append('file', this.fcfile);
				formData.append('filetype', "Yhpczl");
				formData.append('secondarydir', "gov_r_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this4.fileForm.checkURL = response.data.data.url;
						_this4.uploadstart = false;
						_this4.$message.success("文件上传成功，请填写其他信息后点击保存");
					} else {
						_this4.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},
		handleFileUpload1: function handleFileUpload1(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'zip') {
				this.fcfile1 = event.target.files[0];
			} else {
				this.fcfile1 = null;
				this.$message.error("请选择zip格式的文件");
			}
		},
		uploadTrainFile1: function uploadTrainFile1() {
			var _this5 = this;

			if (this.fcfile1 != null) {
				var formData = new FormData();
				formData.append('file', this.fcfile1);
				formData.append('filetype', "Yhpczl");
				formData.append('secondarydir', "gov_c_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this5.editForm.correctURL = response.data.data.url;
						_this5.uploadstart1 = false;
						_this5.$message.success("文件上传成功，请填写其他信息后点击保存");
					} else {
						_this5.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		handleEdit: function handleEdit(index, row) {
			this.editForm.govcheckId = row.govcheckId;

			this.editForm.correctContent = "";
			this.editForm.correctDate = "";
			this.editForm.selCorrectDate = null;

			this.editForm.checkStatus = "1";

			this.editForm.correctURL = "";
			this.fcfile1 = null;
			this.uploadstart1 = true;
			if (this.$refs.upLoadRef1) {
				this.$refs.upLoadRef1.value = ''; // 置空input文件
			}
			this.editFormVisible = true;
		},

		//企业编辑整改信息
		editGovCheckRecord: function editGovCheckRecord() {
			var _this6 = this;

			if (this.editForm.selCorrectDate != null) {
				this.editForm.correctDate = this.editForm.selCorrectDate.toLocaleString();
			}

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this6.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this6.editLoading = true;

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api__["t" /* updateGovCheckInfo */])(_this6.editForm).then(function (res) {
							_this6.editLoading = false;
							_this6.editFormVisible = false;
							if (res.data.code == 0) {
								_this6.$message.success(res.data.message);
								_this6.getPageList();
							} else {
								_this6.$message.error(res.data.message);
							}
						});
					});
				}
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.coId = user.data.coId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bquery = false;
		} else {
			this.bquery = true;
			this.getAllcompanyList();
		}

		this.getPageList();
	}
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id

			companylist: [],
			total: 0,
			page: 1,
			listLoading: false
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getListPage();
		},

		//获取列表
		getListPage: function getListPage() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_7" /* getGwCheckItem */])(para).then(function (res) {

				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.companylist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},

		handleClose: function handleClose(index, row) {
			var _this2 = this;

			this.$confirm('确认禁用这个检查栏目吗？', '提示', {}).then(function () {

				var newparam = {
					createUserId: _this2.objectId,
					checkItemId: row.checkItemId,
					isClose: '1'
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_8" /* updateGwCheckItem */])(newparam).then(function (res) {
					if (res.data.code == 0) {
						_this2.$message.success(res.data.message);
						_this2.getListPage();
					} else {
						_this2.$message.error(res.data.message);
					}
				});
			});
		},

		handleOpen: function handleOpen(index, row) {
			var _this3 = this;

			this.$confirm('确认启用这个检查栏目吗？', '提示', {}).then(function () {

				var newparam = {
					createUserId: _this3.objectId,
					checkItemId: row.checkItemId,
					isClose: '0'
				};

				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_8" /* updateGwCheckItem */])(newparam).then(function (res) {
					if (res.data.code == 0) {
						_this3.$message.success(res.data.message);
						_this3.getListPage();
					} else {
						_this3.$message.error(res.data.message);
					}
				});
			});
		}

	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.getListPage();
	}
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js_notificationState__ = __webpack_require__(152);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			comuser: false, //false管局，true企业

			filters: {
				title: ''
			},
			noticelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//新增企业信息
			ntoptions: [{
				value: '0',
				label: '全部企业'
			}, {
				value: '1',
				label: '指定企业'
			}],
			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				title: [{ required: true, message: "请输入通知标题", trigger: "blur" }],
				content: [{ required: true, message: "请输入通知内容", trigger: "blur" }]
			},

			addForm: {
				createUserId: "",
				noticeType: "0",

				content: '',
				title: '',

				enterpriseIds: [], // 存储勾选的企业ID
				fileurls: []
			},

			fileurls: [], // 存储上传成功的附件fileUrl,fileName
			enterpriseList: [], // 企业列表（从后端接口获取）

			//企业提交材料
			editFormVisible: false,
			editLoading: false,
			editFormRules: {},

			editForm: {
				coId: 0,
				noticeId: 0,
				title: "",
				fileurls: []
			},

			//通知详情页面
			detailFormVisible: false,

			detailForm: {
				title: '',
				content: '',
				userName: '',
				createTime: '',
				fileurls: [],
				comfileurls: []
			},
			//企业通知签收详情页面  
			comdetailFormVisible: false,

			comdetailForm: {
				title: '',
				noticeId: 0,
				totalcount: 0,
				readcount: 0,
				nclist: []
			},

			//通知详情页面
			comdetailfileFormVisible: false,

			comdetailfileForm: {
				coName: '',
				comfileurls: []
			},

			// 显示pdf
			pdfVisible: false,
			pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
			pdfFileName: "",
			// 正式地址
			filebaseurl: "https://aqjg.ycsyzglj.com/"
		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getNoticeList();
		},

		//按类型获取通知列表
		getNoticeList: function getNoticeList() {
			var _this = this;

			if (this.comuser) {
				var para = {
					page: this.page,
					pageSize: 20,
					coId: this.coId,
					title: this.filters.title
				};
				this.listLoading = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["h" /* getcompanyNoticeListPage */])(para).then(function (res) {
					if (res.data.code == 0) {
						_this.total = res.data.data.total;
						_this.noticelist = res.data.data.list;
					}
					_this.listLoading = false;
				});
			} else {
				var _para = {
					page: this.page,
					pageSize: 20,
					objectId: this.objectId,
					title: this.filters.title
				};
				this.listLoading = true;
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["i" /* getNoticeListPage */])(_para).then(function (res) {
					if (res.data.code == 0) {
						_this.total = res.data.data.total;
						_this.noticelist = res.data.data.list;
					}
					_this.listLoading = false;
				});
			}
		},


		//新增通知
		handleAdd: function handleAdd() {
			if (this.enterpriseList.length == 0) {
				this.$message.error("请先创建企业");
			} else {
				this.addFormVisible = true, this.addForm.createUserId = this.objectId, this.addForm.noticeType = "0", //默认全部企业
				this.addForm.content = '', this.addForm.title = '', this.addForm.enterpriseIds = []; // 存储勾选的企业ID

				this.addForm.fileurls = [];

				if (this.fileurls.length != 0) {
					// 调用clearFiles()清空文件列表
					this.$refs.upload.clearFiles();
					this.fileurls = [];
				}
			}
		},
		handleNoticeAdd: function handleNoticeAdd() {
			var _this2 = this;

			if (this.addForm.noticeType == "1" && this.addForm.enterpriseIds.length == 0) {
				this.$message.error("请选择接收通知的企业");
			} else {
				this.addForm.fileurls = this.fileurls;
				this.$refs.addForm.validate(function (valid) {
					if (valid) {
						_this2.$confirm('确认发布信息吗？', '提示', {}).then(function () {
							_this2.addLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["j" /* addNotice */])(_this2.addForm).then(function (res) {
								_this2.addLoading = false;
								_this2.addFormVisible = false;
								if (res.data.code == 0) {
									_this2.$message.success(res.data.message);
									_this2.getNoticeList();
								} else {
									_this2.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},


		//企业提交文件
		handleCompanyfileAdd: function handleCompanyfileAdd(index, row) {
			this.editForm.createUserId = this.coId;
			this.editForm.title = row.title, this.editForm.noticeId = row.noticeId, this.editForm.fileurls = [];
			this.editFormVisible = true;
			if (this.fileurls.length != 0) {
				// 调用clearFiles()清空文件列表
				this.$refs.upload.clearFiles();
				this.fileurls = [];
			}
		},
		updateCompanyfile: function updateCompanyfile() {
			var _this3 = this;

			this.editForm.fileurls = this.fileurls;
			if (this.editForm.fileurls.length == 0) {
				//没选择文件直接关闭页面
				this.editFormVisible = false;
			} else {
				this.$confirm('确认提交企业文件吗？', '提示', {}).then(function () {
					_this3.editLoading = true;
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["k" /* addCompanyFiles */])(_this3.editForm).then(function (res) {
						_this3.editLoading = false;
						_this3.editFormVisible = false;
						if (res.data.code == 0) {
							_this3.$message.success(res.data.message);
							_this3.getNoticeList();
						} else {
							_this3.$message.error(res.data.message);
						}
					});
				});
			}
		},
		handleDetail: function handleDetail(index, row) {
			var _this4 = this;

			this.detailForm.title = row.title;
			this.detailForm.content = row.content;
			this.detailForm.userName = row.userName;
			this.detailForm.createTime = row.createTime;
			this.detailForm.fileurls = [];
			this.detailForm.comfileurls = [];
			//获取通知文件列表（文件名称，文件地址）
			var para = {
				createUserId: "",
				fileType: "0",
				noticeId: row.noticeId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["l" /* getNoticeFileList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this4.detailForm.fileurls = res.data.data;

					if (_this4.comuser) {
						var _para2 = {
							createUserId: _this4.coId,
							fileType: "1",
							noticeId: row.noticeId
						};
						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["l" /* getNoticeFileList */])(_para2).then(function (res) {
							if (res.data.code == 0) {
								_this4.detailFormVisible = true;
								_this4.detailForm.comfileurls = res.data.data;

								//企业用户更新通知状态
								if (row.readStatus == '0') {
									var _para3 = {
										coId: _this4.coId,
										noticeId: row.noticeId
									};
									__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["m" /* updateNoticeCompanyStatus */])(_para3).then(function (res) {
										if (res.data.code == 0) {
											__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js_notificationState__["a" /* fetchUnreadCount */])(); //未读通知数
											_this4.getNoticeList();
										}
									});
								}
							}
						});
					} else {
						_this4.detailFormVisible = true;
					}
				}
			});
		},

		handleDelete: function handleDelete(index, row) {
			var _this5 = this;

			this.$confirm('确认删除这个通知吗？', '提示', {}).then(function () {
				var deletecompanyparam = {
					noticeId: row.noticeId,
					updateUserId: _this5.objectId
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["n" /* deleteNotice */])(deletecompanyparam).then(function (res) {
					if (res.data.code == 0) {
						_this5.$message.success(res.data.message);
						_this5.getNoticeList();
					} else {
						_this5.$message.error(res.data.message);
					}
				});
			});
		},

		//获取全部客户列表
		getAllcompanyList: function getAllcompanyList() {
			var _this6 = this;

			var para = {
				objectId: this.objectId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["o" /* allCompanyList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this6.enterpriseList = res.data.data;
				}
			});
		},

		// 勾选指定企业：记录企业ID
		handleEnterpriseSelect: function handleEnterpriseSelect(selection) {
			this.addForm.enterpriseIds = selection.map(function (item) {
				return item.coId;
			});
		},


		handleFileShow: function handleFileShow(index, row) {
			this.pdfSrc = this.filebaseurl + row.fileUrl;
			this.pdfFileName = row.fileName;
			this.pdfVisible = true;
		},
		submitUpload: function submitUpload() {
			this.$refs.upload.submit();
		},
		handleRemove: function handleRemove(file, fileList) {
			this.fileurls = [];
			for (var index = 0; index < fileList.length; index++) {
				var element = fileList[index];
				var curfileName = element.name;
				var curfileUrl = '';
				if (element.status == "success") {
					curfileUrl = element.response.data[0];
				}
				var filedic = {
					"fileName": curfileName,
					"fileUrl": curfileUrl
				};
				this.fileurls.push(filedic);
			}
		},
		handlePreview: function handlePreview(file) {},
		handleAttachmentSuccess: function handleAttachmentSuccess(response, file, fileList) {
			this.fileurls = [];
			for (var index = 0; index < fileList.length; index++) {
				var element = fileList[index];
				var curfileName = element.name;
				var curfileUrl = '';
				if (element.status == "success") {
					curfileUrl = element.response.data[0];
				}
				var filedic = {
					"fileName": curfileName,
					"fileUrl": curfileUrl
				};
				this.fileurls.push(filedic);
			}
		},

		handleCompanyDetail: function handleCompanyDetail(index, row) {
			var _this7 = this;

			this.comdetailForm.title = row.title;
			this.comdetailForm.noticeId = row.noticeId;
			var para = {
				noticeId: row.noticeId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["p" /* noticeCompanyList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this7.comdetailFormVisible = true;
					_this7.comdetailForm.readcount = res.data.data.readcount;
					_this7.comdetailForm.totalcount = res.data.data.totalcount;
					_this7.comdetailForm.nclist = res.data.data.nclist;
				}
			});
		},
		handleShowComfile: function handleShowComfile(index, row) {
			var _this8 = this;

			this.comdetailfileForm.coName = row.coName;
			this.comdetailfileForm.comfileurls = [];
			var para = {
				createUserId: row.coId,
				fileType: "1",
				noticeId: this.comdetailForm.noticeId
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["l" /* getNoticeFileList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this8.comdetailfileFormVisible = true;
					_this8.comdetailfileForm.comfileurls = res.data.data;
				}
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;

		if (user.data.roleId == "4") {
			this.comuser = true;
			this.coId = user.data.coId;
		} else {
			this.comuser = false;
			this.getAllcompanyList();
		}

		this.getNoticeList();
	}
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id
			showcity: true, //是否显示所属城市

			filters: {
				coName: "",
				fileNf: ''
			},
			companylist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//明细
			detailFormVisible: false,
			detailFormTitle: '', //对话框名称
			detailForm: {
				companyName: ""
			},
			qType: "0", //0记录统计1上报统计
			qcoId: 0, //当前查看的企业id
			feedata: [],
			feetotal: 0,
			feepage: 1,
			feelistLoading: false,

			//浮动显示有关
			visibleTooltip: false, // 浮动层显示状态
			currentRow: null, // 当前悬停行数据
			tooltipLeft: 0, // 浮动层左坐标
			tooltipTop: 0, // 浮动层上坐标

			visibleTooltip2: false, // 浮动层显示状态
			currentRow2: null, // 当前悬停行数据
			tooltipLeft2: 0, // 浮动层左坐标
			tooltipTop2: 0 // 浮动层上坐标
			//end
		};
	},

	methods: {
		// 显示浮动层
		showTooltip: function showTooltip(row, e) {
			this.currentRow = row;
			this.visibleTooltip = true;
			// 计算浮动层位置（基于鼠标位置偏移，避免遮挡）
			this.tooltipLeft = e.pageX + 10;
			this.tooltipTop = e.pageY + 10;
		},


		// 隐藏浮动层
		hideTooltip: function hideTooltip() {
			this.visibleTooltip = false;
			this.currentRow = null;
		},
		showTooltip2: function showTooltip2(row, e) {
			this.currentRow2 = row;
			this.visibleTooltip2 = true;
			// 计算浮动层位置（基于鼠标位置偏移，避免遮挡）
			this.tooltipLeft2 = e.pageX + 10;
			this.tooltipTop2 = e.pageY + 10;
		},


		// 隐藏浮动层
		hideTooltip2: function hideTooltip2() {
			this.visibleTooltip2 = false;
			this.currentRow2 = null;
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getSumListPage();
		},

		//获取列表
		getSumListPage: function getSumListPage() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.coName,
				fileNf: this.filters.fileNf
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["g" /* safefilecheckSumPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.companylist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},

		handleReportDetail: function handleReportDetail(index, row) {
			this.detailFormVisible = true;
			this.detailFormTitle = "企业重大隐患上报 按月统计";

			this.detailForm.companyName = row.coName;
			this.qcoId = row.coId;
			this.feepage = 1;
			this.qType = "1";
			this.getReportMonthPage();
		},

		handleRecordDetail: function handleRecordDetail(index, row) {
			this.detailFormVisible = true;
			this.detailFormTitle = "企业隐患排查记录 按月统计";

			this.detailForm.companyName = row.coName;

			this.qcoId = row.coId;
			this.feepage = 1;
			this.qType = "0";
			this.getRecordMonthPage();
		},
		//
		getRecordMonthPage: function getRecordMonthPage() {
			var _this2 = this;

			var para = {
				page: this.feepage,
				pageSize: 5,
				coId: this.qcoId
			};

			this.feelistLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["e" /* recordMonthPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.feetotal = res.data.data.total;
					_this2.feedata = res.data.data.list;
				}

				_this2.feelistLoading = false;
			});
		},
		getReportMonthPage: function getReportMonthPage() {
			var _this3 = this;

			var para = {
				page: this.feepage,
				pageSize: 5,
				coId: this.qcoId
			};

			this.feelistLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["f" /* reportMonthPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this3.feetotal = res.data.data.total;
					_this3.feedata = res.data.data.list;
				}

				_this3.feelistLoading = false;
			});
		},
		handletypeChange: function handletypeChange(val) {
			this.feepage = val;

			if (this.qType == "0") {
				this.getRecordMonthPage();
			} else {
				this.getReportMonthPage();
			}
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.showcity = true;
		if (user.data.roleId == "3") //城市管理员不显示所属城市
			{
				this.showcity = false;
			}

		var currentYear = new Date().getFullYear();
		this.filters.fileNf = currentYear.toString();

		this.getSumListPage();
	}
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id

			filters: {
				coName: ""
			},
			companylist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//明细
			detailFormVisible: false,
			detailFormTitle: '', //对话框名称
			detailForm: {
				companyName: ""
			},
			qType: "0", //0记录统计1上报统计
			qcoId: 0, //当前查看的企业id
			feedata: [],
			feetotal: 0,
			feepage: 1,
			feelistLoading: false

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getSelfCheckSumListPage();
		},

		//获取列表
		getSelfCheckSumListPage: function getSelfCheckSumListPage() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.coName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["d" /* selfcheckSumPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.companylist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},

		handleReportDetail: function handleReportDetail(index, row) {
			this.detailFormVisible = true;
			this.detailFormTitle = "企业重大隐患上报 按月统计";

			this.detailForm.companyName = row.coName;
			this.qcoId = row.coId;
			this.feepage = 1;
			this.qType = "1";
			this.getReportMonthPage();
		},

		handleRecordDetail: function handleRecordDetail(index, row) {
			this.detailFormVisible = true;
			this.detailFormTitle = "企业隐患排查记录 按月统计";

			this.detailForm.companyName = row.coName;

			this.qcoId = row.coId;
			this.feepage = 1;
			this.qType = "0";
			this.getRecordMonthPage();
		},
		//
		getRecordMonthPage: function getRecordMonthPage() {
			var _this2 = this;

			var para = {
				page: this.feepage,
				pageSize: 5,
				coId: this.qcoId
			};

			this.feelistLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["e" /* recordMonthPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.feetotal = res.data.data.total;
					_this2.feedata = res.data.data.list;
				}

				_this2.feelistLoading = false;
			});
		},
		getReportMonthPage: function getReportMonthPage() {
			var _this3 = this;

			var para = {
				page: this.feepage,
				pageSize: 5,
				coId: this.qcoId
			};

			this.feelistLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["f" /* reportMonthPage */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this3.feetotal = res.data.data.total;
					_this3.feedata = res.data.data.list;
				}

				_this3.feelistLoading = false;
			});
		},
		handletypeChange: function handletypeChange(val) {
			this.feepage = val;

			if (this.qType == "0") {
				this.getRecordMonthPage();
			} else {
				this.getReportMonthPage();
			}
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.getSelfCheckSumListPage();
	}
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: '',
				planName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//字典表
			selfCheckPropertyoptions: [],
			selfCheckPropertyvalue: '',

			riskLeveloptions: [],
			riskLevelvalue: '',

			companymemberlist: [],
			workerId: 0,

			//新增
			addyhpcFormVisible: false,
			addyhpcFormRules: {
				planName: [{ required: true, message: "请输入隐患排查计划名称", trigger: "blur" }],
				selfCheckPlanDate: [{ required: true, message: "请选择计划排查日期", trigger: "blur" }],
				selfCheckContent: [{ required: true, message: "请输入检查内容", trigger: "blur" }]
			},

			addyhpcForm: {
				createUserId: 0,
				coId: 0,
				workerId: 0,

				planName: "",
				selfCheckContent: "",
				selfCheckProperty: "",
				riskLevel: "",

				selfCheckPlanDate: "",
				selSelfCheckPlanDate: null
			},
			labelPosition: 'right'

		};
	},

	methods: {
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				planName: this.filters.planName,
				coName: this.filters.companyName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_17" /* selfCheckPlanList */])(para).then(function (res) {

				if (res.data.code == 0) {
					_this.total = res.data.data.total;
					_this.pagelist = res.data.data.list;
				}

				_this.listLoading = false;
			});
		},
		getQYPCXZdic: function getQYPCXZdic() {
			var _this2 = this;

			var para = {
				MpType: "QYPCXZ",
				MpParentId: "51"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.selfCheckPropertyoptions = res.data.data;
					_this2.selfCheckPropertyvalue = _this2.selfCheckPropertyoptions[0].MpValue;
				}
			});
		},
		getFXJBdic: function getFXJBdic() {
			var _this3 = this;

			var para = {
				MpType: "FXJB",
				MpParentId: "9"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this3.riskLeveloptions = res.data.data;
					_this3.riskLevelvalue = _this3.riskLeveloptions[0].MpValue;
				}
			});
		},

		showAddyhpcPlan: function showAddyhpcPlan(index, row) {

			this.addyhpcForm = {
				createUserId: this.objectId,
				coId: this.coId,
				workerId: 0,

				planName: "",
				selfCheckContent: "",
				selfCheckProperty: "",
				riskLevel: "",

				selfCheckPlanDate: "",
				selSelfCheckPlanDate: null
			}, this.addyhpcFormVisible = true;
			//没有人员的时候，不显示备选
			if (this.workerId == 0) {
				this.workerId = '';
			}
		},
		handleAddyhpczl: function handleAddyhpczl() {
			var _this4 = this;

			if (this.workerId == '') {
				this.$message.error("请选择排查人员");
			} else {
				if (this.addyhpcForm.selSelfCheckPlanDate != null) {
					this.addyhpcForm.selfCheckPlanDate = this.addyhpcForm.selSelfCheckPlanDate.toLocaleString();
				}

				this.addyhpcForm.selfCheckProperty = this.selfCheckPropertyvalue;
				this.addyhpcForm.riskLevel = this.riskLevelvalue;
				this.addyhpcForm.workerId = this.workerId;

				this.$refs.addyhpcForm.validate(function (valid) {
					if (valid) {
						_this4.$confirm('确认添加排查计划吗？', '提示', {}).then(function () {
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_18" /* addSelfCheckPlan */])(_this4.addyhpcForm).then(function (res) {
								if (res.data.code == 0) {
									_this4.addyhpcFormVisible = false;
									_this4.$message.success(res.data.message);
									_this4.getPageList();
								} else {
									_this4.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		//获取企业全部人员列表
		getAllWorkerList: function getAllWorkerList() {
			var _this5 = this;

			var para = {
				coId: this.coId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["D" /* allWorkerList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this5.companymemberlist = res.data.data;
					_this5.workerId = _this5.companymemberlist[0].workerId;
				}
			});
		},

		handleDel: function handleDel(index, row) {
			var _this6 = this;

			this.$confirm('确认删除这个计划吗？', '提示', {}).then(function () {
				var para = {
					planId: row.planId
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_api__["_19" /* deleteSelfCheckPlan */])(para).then(function (res) {
					if (res.data.code == 0) {
						_this6.$message({
							message: '删除成功',
							type: 'success'
						});

						_this6.getPageList();
					} else {
						_this6.$message.error(res.data.message);
					}
				});
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.coId = user.data.coId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
			this.getAllWorkerList();
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		this.getPageList();
		this.getQYPCXZdic();
		this.getFXJBdic();
	}
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_big_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 4-1 




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BigImg: __WEBPACK_IMPORTED_MODULE_0__components_big_img___default.a
	},
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//隐患详情
			detailFormVisible: false,

			picList0: [], //隐患照片
			picList1: [], //整改照片
			feedata: [],
			detailForm: {
				coName: "",
				checkNumber: "",
				checkTime: "",
				selfCheckType: '',
				checkStatusName: '',
				checkResult: ''
			},

			//上传
			uploadstart: true,
			imageFile: null,

			picbaseurl: "https://aqjg.ycsyzglj.com/",

			// 4-5
			photoVisible: false,
			bigImgUrl: "",

			//编辑
			editLoading: false,
			zgFormTitle: '', //编辑的时候，显示企业名称
			zgFormVisible: false,
			zgFormRules: {
				correctTime: [{ required: true, message: "请选择整改日期", trigger: "blur" }],
				correctContent: [{ required: true, message: "请输入整改措施", trigger: "blur" }]
			},

			zgForm: {
				checkNumber: "",
				correctUserId: 0,
				correctContent: "",
				correctTime: "",
				selCorrectTime: null
			},

			ysFormTitle: '', //编辑的时候，显示企业名称
			ysFormVisible: false,
			ysFormRules: {
				reviewTime: [{ required: true, message: "请选择验收日期", trigger: "blur" }],
				reviewContent: [{ required: true, message: "请输入验收说明", trigger: "blur" }]
			},

			ysForm: {
				checkNumber: "",
				reviewUserId: 0,
				reviewContent: "",
				reviewTime: "",
				selReviewTime: null
			},

			uploadpicTitle: '', //上传的时候，显示企业名称

			yhpicFormVisible: false,
			yhpicLoading: false,
			yhpicFormRules: {},

			yhpicForm: {
				createUserId: 0,
				checkNumber: "",
				picType: '0',
				picUrl: ''
			},
			companymemberlist: [],
			workerId: 0,

			//新增隐患自我排查记录
			//字典表
			selfCheckLocationoptions: [],
			selfCheckLocationvalue: '',

			selfCheckPropertyoptions: [],
			selfCheckPropertyvalue: '',

			riskLeveloptions: [],
			riskLevelvalue: '',

			qypcztoptions: [],
			qypcztvalue: '',

			labelPosition: 'right',

			addyhpcFormVisible: false,
			addyhpcFormRules: {
				planName: [{ required: true, message: "请输入隐患排查计划名称", trigger: "blur" }],
				selfCheckPlanDate: [{ required: true, message: "请选择计划排查日期", trigger: "blur" }],
				selfCheckContent: [{ required: true, message: "请输入检查内容", trigger: "blur" }],
				checkTime: [{ required: true, message: "请选择实际排查日期", trigger: "blur" }],
				planCorrectTime: [{ required: true, message: "请选择整改计划完成时间", trigger: "blur" }],
				checkResult: [{ required: true, message: "请输入排查结论", trigger: "blur" }]
			},

			addyhpcForm: {
				createUserId: 0,
				coId: 0,

				workerId: 0,

				planName: "",
				selfCheckContent: "",
				selfCheckProperty: "",
				riskLevel: "",
				selfCheckLocation: "",

				selfCheckPlanDate: "",
				selSelfCheckPlanDate: null,

				checkTime: "",
				selCheckTime: null,
				checkStatus: "",
				checkResult: "",

				planCorrectTime: "",
				selPlanCorrectTime: null

			}
		};
	},

	methods: {
		getQYPCCSdic: function getQYPCCSdic() {
			var _this = this;

			var para = {
				MpType: "QYPCCS",
				MpParentId: "201"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.selfCheckLocationoptions = res.data.data;
					_this.selfCheckLocationvalue = _this.selfCheckLocationoptions[0].MpValue;
				}
			});
		},
		getQYPCXZdic: function getQYPCXZdic() {
			var _this2 = this;

			var para = {
				MpType: "QYPCXZ",
				MpParentId: "51"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this2.selfCheckPropertyoptions = res.data.data;
					_this2.selfCheckPropertyvalue = _this2.selfCheckPropertyoptions[0].MpValue;
				}
			});
		},
		getFXJBdic: function getFXJBdic() {
			var _this3 = this;

			var para = {
				MpType: "FXJB",
				MpParentId: "9"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this3.riskLeveloptions = res.data.data;
					_this3.riskLevelvalue = _this3.riskLeveloptions[0].MpValue;
				}
			});
		},
		getQYPCZTdic: function getQYPCZTdic() {
			var _this4 = this;

			var para = {
				MpType: "QYPCZT",
				MpParentId: "46"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this4.qypcztoptions = res.data.data;
					_this4.qypcztvalue = _this4.qypcztoptions[0].MpValue;
				}
			});
		},

		showAddyhpcRecord: function showAddyhpcRecord(index, row) {

			this.addyhpcForm = {
				createUserId: this.objectId,
				coId: this.coId,
				workerId: 0,

				planName: "",
				selfCheckContent: "",
				selfCheckProperty: "",
				riskLevel: "",

				selfCheckPlanDate: "",
				selSelfCheckPlanDate: null,

				checkTime: "",
				selCheckTime: null,

				checkStatus: "",

				checkResult: "",

				planCorrectTime: "",
				selPlanCorrectTime: null
			}, this.addyhpcFormVisible = true;
			//没有人员的时候，不显示备选
			if (this.workerId == 0) {
				this.workerId = '';
			}
		},
		handleAddyhpcRecord: function handleAddyhpcRecord() {
			var _this5 = this;

			if (this.workerId == '') {
				this.$message.error("请选择排查人员");
			} else {
				// if(this.addyhpcForm.selSelfCheckPlanDate!=null){
				// 	this.addyhpcForm.selfCheckPlanDate = this.addyhpcForm.selSelfCheckPlanDate.toLocaleString();
				// }

				if (this.addyhpcForm.selCheckTime != null) {
					this.addyhpcForm.checkTime = this.addyhpcForm.selCheckTime.toLocaleString();
				}

				if (this.addyhpcForm.selPlanCorrectTime != null) {
					this.addyhpcForm.planCorrectTime = this.addyhpcForm.selPlanCorrectTime.toLocaleString();
				}

				// this.addyhpcForm.selfCheckProperty= this.selfCheckPropertyvalue
				this.addyhpcForm.riskLevel = this.riskLevelvalue;
				this.addyhpcForm.workerId = this.workerId;
				// this.addyhpcForm.checkStatus= this.qypcztvalue
				//去掉选项，直接标记不合格
				this.addyhpcForm.selfCheckLocation = this.selfCheckLocationvalue;
				this.addyhpcForm.checkStatus = "BHG";

				this.$refs.addyhpcForm.validate(function (valid) {
					if (valid) {
						_this5.$confirm('确认上传排查记录吗？', '提示', {}).then(function () {
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["E" /* addSelfCheckRecord */])(_this5.addyhpcForm).then(function (res) {
								if (res.data.code == 0) {
									_this5.addyhpcFormVisible = false;
									_this5.$message.success(res.data.message);
									_this5.getPageList();
								} else {
									_this5.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'png' || filearr[1] == 'jpg' || filearr[1] == 'jpeg') {
				this.imageFile = event.target.files[0];
			} else {
				this.imageFile = null;
				this.$message.error("请选择png或jpg格式的文件");
			}
		},
		uploadReportFile: function uploadReportFile() {
			var _this6 = this;

			if (this.imageFile != null) {
				var formData = new FormData();
				formData.append('file', this.imageFile);
				formData.append('filetype', "companyZg");
				formData.append('secondarydir', "yhpczl_com_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this6.yhpicForm.picUrl = response.data.data.url;
						_this6.uploadstart = false;
						_this6.$message.success("文件上传成功，请点击保存");
					} else {
						_this6.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		//4-4点击图片函数，点击后，把photoVisible设置成true
		showBigImage: function showBigImage(e) {
			if (e != "") {
				this.photoVisible = true;
				this.bigImgUrl = e;
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this7 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["F" /* selfCheckRecordList */])(para).then(function (res) {

				if (res.data.code == 0) {
					_this7.total = res.data.data.total;
					_this7.pagelist = res.data.data.list;
				}

				_this7.listLoading = false;
			});
		},


		selfCheckDetail: function selfCheckDetail(index, row) {
			var _this8 = this;

			this.detailForm.coName = row.coName;
			this.detailForm.checkNumber = row.checkNumber;
			this.detailForm.checkTime = row.checkTime;
			this.detailForm.selfCheckType = row.selfCheckType;
			this.detailForm.checkStatusName = row.checkStatusName;
			this.detailForm.checkResult = row.checkResult;

			var para = {
				checkNumber: row.checkNumber,
				selfCheckType: row.selfCheckType
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["G" /* companyCheckDetailList */])(para).then(function (res) {
				_this8.detailFormVisible = true;
				if (res.data.code == 0) {
					_this8.feedata = res.data.data;
				}

				//如果是自定义检查，有抓拍需要区分
				if (_this8.detailForm.selfCheckType == '0') {
					_this8.picList0 = [];
					_this8.picList1 = [];
					for (var _index = 0; _index < _this8.feedata.length; _index++) {
						var element = _this8.feedata[_index];

						if (element.picType == '0') {
							_this8.picList0.push(element);
						} else {
							_this8.picList1.push(element);
						}
					}
				}
			});
		},
		handleZG: function handleZG(index, row) {
			this.zgFormVisible = true;

			this.zgFormTitle = row.coName + " 整改信息";

			this.zgForm = {
				checkNumber: row.checkNumber,
				correctUserId: 0,
				correctContent: "",
				correctTime: "",
				selCorrectTime: null
			};
		},
		updateZgInfo: function updateZgInfo() {
			var _this9 = this;

			if (this.zgForm.selCorrectTime != null) {
				this.zgForm.correctTime = this.zgForm.selCorrectTime.toLocaleString();
			}

			this.$refs.zgForm.validate(function (valid) {
				if (valid) {
					_this9.$confirm('确认完成整改吗？', '提示', {}).then(function () {
						_this9.editLoading = true;
						_this9.zgForm.correctUserId = _this9.workerId;

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["H" /* updateSelfCheckZgInfo */])(_this9.zgForm).then(function (res) {
							_this9.editLoading = false;
							_this9.zgFormVisible = false;
							if (res.data.code == 0) {
								_this9.$message.success(res.data.message);
								_this9.getPageList();
							} else {
								_this9.$message.error(res.data.message);
							}
						});
					});
				}
			});
		},
		handleYS: function handleYS(index, row) {
			this.ysFormVisible = true;

			this.ysFormTitle = row.coName + " 验收信息";

			this.ysForm = {
				checkNumber: row.checkNumber,
				reviewUserId: 0,
				reviewContent: "",
				reviewTime: "",
				selReviewTime: null
			};
		},
		updateYsInfo: function updateYsInfo() {
			var _this10 = this;

			if (this.ysForm.selReviewTime != null) {
				this.ysForm.reviewTime = this.ysForm.selReviewTime.toLocaleString();
			}

			this.$refs.ysForm.validate(function (valid) {
				if (valid) {
					_this10.$confirm('确认验收完成吗？', '提示', {}).then(function () {
						_this10.editLoading = true;
						_this10.ysForm.reviewUserId = _this10.workerId;

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["I" /* updateSelfCheckYsInfo */])(_this10.ysForm).then(function (res) {
							_this10.editLoading = false;
							_this10.ysFormVisible = false;
							if (res.data.code == 0) {
								_this10.$message.success(res.data.message);
								_this10.getPageList();
							} else {
								_this10.$message.error(res.data.message);
							}
						});
					});
				}
			});
		},
		handleUploadPic: function handleUploadPic(index, row) {
			if (row.checkStatusName == '不合格') {
				this.uploadpicTitle = row.coName + ' 隐患照片';

				this.yhpicForm = {
					createUserId: this.objectId,
					checkNumber: row.checkNumber,
					picType: "0",
					picUrl: ''
				};
			} else {
				this.uploadpicTitle = row.coName + ' 整改照片';

				this.yhpicForm = {
					createUserId: this.objectId,
					checkNumber: row.checkNumber,
					picType: "1",
					picUrl: ''
				};
			}
			this.imageFile = null;
			this.uploadstart = true;
			this.yhpicFormVisible = true;
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}
		},
		updateReportPic: function updateReportPic() {
			var _this11 = this;

			if (this.yhpicForm.picUrl == '') {
				this.$message.error("图片不存在，请上传文件后再点击保存");
			} else {
				this.$refs.yhpicForm.validate(function (valid) {
					if (valid) {
						_this11.$confirm('确认提交照片吗？', '提示', {}).then(function () {
							_this11.yhpicLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["J" /* addRecordPic */])(_this11.yhpicForm).then(function (res) {
								_this11.yhpicLoading = false;
								_this11.yhpicFormVisible = false;
								if (res.data.code == 0) {
									_this11.$message.success(res.data.message);
									_this11.getPageList();
								} else {
									_this11.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		//获取企业全部人员列表
		getAllWorkerList: function getAllWorkerList() {
			var _this12 = this;

			var para = {
				coId: this.coId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* allWorkerList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this12.companymemberlist = res.data.data;

					_this12.workerId = _this12.companymemberlist[0].workerId;
				}
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.coId = user.data.coId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
			this.getAllWorkerList();
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		this.getPageList();
		this.getQYPCXZdic();
		this.getQYPCCSdic();
		this.getFXJBdic();
		this.getQYPCZTdic();
	}
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_big_img___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_big_img__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(11);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 4-1 




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		BigImg: __WEBPACK_IMPORTED_MODULE_0__components_big_img___default.a
	},
	data: function data() {
		return {
			objectId: 0, //当前登录的用户id，新增会用到
			coId: 0, //当前登录的用户企业id

			bquery: false, //管理员权限
			bshow: false, //是否显示操作按钮

			filters: {
				companyName: ''
			},
			pagelist: [],
			total: 0,
			page: 1,
			listLoading: false,

			//隐患详情
			detailFormVisible: false,
			picList0: [], //隐患照片
			picList1: [], //整改照片

			detailForm: {
				coName: "",
				findContent: "",
				dangerStatusName: ""
			},

			//编辑
			editLoading: false,
			zgFormTitle: '', //编辑的时候，显示企业名称
			zgFormVisible: false,
			zgFormRules: {
				correctTime: [{ required: true, message: "请选择整改日期", trigger: "blur" }],
				correctContent: [{ required: true, message: "请输入整改措施", trigger: "blur" }]
			},

			zgForm: {
				checkNumber: "",
				correctUserId: 0,
				correctContent: "",
				correctTime: "",
				selCorrectTime: null
			},

			ysFormTitle: '', //编辑的时候，显示企业名称
			ysFormVisible: false,
			ysFormRules: {
				reviewTime: [{ required: true, message: "请选择验收日期", trigger: "blur" }],
				reviewContent: [{ required: true, message: "请输入验收说明", trigger: "blur" }]
			},

			ysForm: {
				checkNumber: "",
				reviewUserId: 0,
				reviewContent: "",
				reviewTime: "",
				selReviewTime: null
			},
			//上传通知书
			uploadstart: true,
			imageFile: null,

			picbaseurl: "https://aqjg.ycsyzglj.com/",

			// 4-5
			photoVisible: false,
			bigImgUrl: "",

			//新增
			selfCheckLocationoptions: [],
			selfCheckLocationvalue: '',

			addyhpcFormVisible: false,
			addyhpcFormRules: {
				findContent: [{ required: true, message: "请输入重大隐患内容", trigger: "blur" }],
				findTime: [{ required: true, message: "请选择重大隐患发现日期", trigger: "blur" }],
				planCorrectTime: [{ required: true, message: "请选择整改计划完成时间", trigger: "blur" }]
			},

			addyhpcForm: {
				createUserId: 0,
				coId: 0,

				findContent: "",
				findTime: "",
				selFindTime: null,

				planCorrectTime: "",
				selPlanCorrectTime: null,

				workerId: 0,
				selfCheckLocation: ''
			},
			labelPosition: 'right',

			uploadpicTitle: '', //上传的时候，显示企业名称

			yhpicFormVisible: false,
			yhpicLoading: false,
			yhpicFormRules: {},

			yhpicForm: {
				createUserId: 0,
				checkNumber: "",
				picType: '0',
				picUrl: ''
			},

			companymemberlist: [],
			workerId: 0
		};
	},

	methods: {
		getQYPCCSdic: function getQYPCCSdic() {
			var _this = this;

			var para = {
				MpType: "QYPCCS",
				MpParentId: "201"
			};
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["x" /* getparamsByType */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this.selfCheckLocationoptions = res.data.data;
					_this.selfCheckLocationvalue = _this.selfCheckLocationoptions[0].MpValue;
				}
			});
		},

		showAddyhpcReport: function showAddyhpcReport(index, row) {

			this.addyhpcForm = {
				createUserId: this.objectId,
				coId: this.coId,
				findContent: "",
				findTime: "",
				selFindTime: null,

				selfCheckLocation: '',
				workerId: 0,
				planCorrectTime: "",
				selPlanCorrectTime: null
			}, this.addyhpcFormVisible = true;
			//没有人员的时候，不显示备选
			if (this.workerId == 0) {
				this.workerId = '';
			}
		},
		handleAddyhpczl: function handleAddyhpczl() {
			var _this2 = this;

			if (this.workerId == '') {
				this.$message.error("请选择发现人员");
			} else {
				if (this.addyhpcForm.selFindTime != null) {
					this.addyhpcForm.findTime = this.addyhpcForm.selFindTime.toLocaleString();
				}

				if (this.addyhpcForm.selPlanCorrectTime != null) {
					this.addyhpcForm.planCorrectTime = this.addyhpcForm.selPlanCorrectTime.toLocaleString();
				}

				this.addyhpcForm.selfCheckLocation = this.selfCheckLocationvalue;
				this.addyhpcForm.workerId = this.workerId;

				this.$refs.addyhpcForm.validate(function (valid) {
					if (valid) {
						_this2.$confirm('确认上报重大隐患吗？', '提示', {}).then(function () {
							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["y" /* addSelfCheckReport */])(_this2.addyhpcForm).then(function (res) {
								if (res.data.code == 0) {
									_this2.addyhpcFormVisible = false;
									_this2.$message.success(res.data.message);
									_this2.getPageList();
								} else {
									_this2.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		handleFileUpload: function handleFileUpload(event) {
			var filearr = event.target.files[0].name.split('.');

			if (filearr[1] == 'png' || filearr[1] == 'jpg' || filearr[1] == 'jpeg') {
				this.imageFile = event.target.files[0];
			} else {
				this.imageFile = null;
				this.$message.error("请选择png或jpg格式的文件");
			}
		},
		uploadReportFile: function uploadReportFile() {
			var _this3 = this;

			if (this.imageFile != null) {
				var formData = new FormData();
				formData.append('file', this.imageFile);
				formData.append('filetype', "companyArchive");
				formData.append('secondarydir', "yhpczl_com_" + this.objectId);
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/yhpczl/mgr/v1/uploadFile', formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function (response) {
					if (response.data.code == 0) {
						_this3.yhpicForm.picUrl = response.data.data.url;
						_this3.uploadstart = false;
						_this3.$message.success("文件上传成功，请点击保存");
					} else {
						_this3.$message.error("文件上传失败，请重新提交");
					}
				});
			} else {
				this.$message.error("请选择文件后再点击【上传】按钮");
			}
		},

		//4-4点击图片函数，点击后，把photoVisible设置成true
		showBigImage: function showBigImage(e) {
			if (e != "") {
				this.photoVisible = true;
				this.bigImgUrl = e;
			}
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getPageList();
		},

		//获取分页列表
		getPageList: function getPageList() {
			var _this4 = this;

			var para = {
				page: this.page,
				pageSize: 20,
				objectId: this.objectId,
				coName: this.filters.companyName,
				checkType: "view"
			};

			this.listLoading = true;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["z" /* selfCheckReportList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this4.total = res.data.data.total;
					_this4.pagelist = res.data.data.list;
				}
				_this4.listLoading = false;
			});
		},

		handleZG: function handleZG(index, row) {
			this.zgFormVisible = true;

			this.zgFormTitle = row.coName + " 整改信息";

			this.zgForm = {
				checkNumber: row.checkNumber,
				correctUserId: 0,
				correctContent: "",
				correctTime: "",
				selCorrectTime: null
				//没有人员的时候，不显示备选
			};if (this.workerId == 0) {
				this.workerId = '';
			}
		},
		updateZgInfo: function updateZgInfo() {
			var _this5 = this;

			if (this.workerId == '') {
				this.$message.error("请选择整改负责人");
			} else {
				if (this.zgForm.selCorrectTime != null) {
					this.zgForm.correctTime = this.zgForm.selCorrectTime.toLocaleString();
				}

				this.$refs.zgForm.validate(function (valid) {
					if (valid) {
						_this5.$confirm('确认完成整改吗？', '提示', {}).then(function () {
							_this5.editLoading = true;
							_this5.zgForm.correctUserId = _this5.workerId;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["A" /* updateZgInfo */])(_this5.zgForm).then(function (res) {
								_this5.editLoading = false;
								_this5.zgFormVisible = false;
								if (res.data.code == 0) {
									_this5.$message.success(res.data.message);
									_this5.getPageList();
								} else {
									_this5.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		handleYS: function handleYS(index, row) {
			this.ysFormVisible = true;
			this.ysFormTitle = row.coName + " 验收信息";
			this.ysForm = {
				checkNumber: row.checkNumber,
				reviewUserId: 0,
				reviewContent: "",
				reviewTime: "",
				selReviewTime: null
			};
		},
		updateYsInfo: function updateYsInfo() {
			var _this6 = this;

			if (this.ysForm.selReviewTime != null) {
				this.ysForm.reviewTime = this.ysForm.selReviewTime.toLocaleString();
			}
			this.$refs.ysForm.validate(function (valid) {
				if (valid) {
					_this6.$confirm('确认验收完成吗？', '提示', {}).then(function () {
						_this6.editLoading = true;
						_this6.ysForm.reviewUserId = _this6.workerId;

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["B" /* updateYsInfo */])(_this6.ysForm).then(function (res) {
							_this6.editLoading = false;
							_this6.ysFormVisible = false;
							if (res.data.code == 0) {
								_this6.$message.success(res.data.message);
								_this6.getPageList();
							} else {
								_this6.$message.error(res.data.message);
							}
						});
					});
				}
			});
		},
		yhDetail: function yhDetail(index, row) {
			this.detailForm.coName = row.coName;

			this.detailForm.findContent = row.findContent;
			this.detailForm.dangerStatusName = row.dangerStatusName;

			this.picList0 = [];
			this.picList1 = [];
			for (var _index = 0; _index < row.picList.length; _index++) {
				var element = row.picList[_index];

				if (element.picType == '0') {
					this.picList0.push(element);
				} else {
					this.picList1.push(element);
				}
			}
			this.detailFormVisible = true;
		},
		handleUploadPic: function handleUploadPic(index, row) {
			if (row.dangerStatusName == '整改中') {
				this.uploadpicTitle = row.coName + ' 隐患照片';

				this.yhpicForm = {
					createUserId: this.objectId,
					checkNumber: row.checkNumber,
					picType: "0",
					picUrl: ''
				};
			} else {
				this.uploadpicTitle = row.coName + ' 整改照片';

				this.yhpicForm = {
					createUserId: this.objectId,
					checkNumber: row.checkNumber,
					picType: "1",
					picUrl: ''
				};
			}
			this.imageFile = null;
			this.yhpicFormVisible = true;
			this.uploadstart = true;
			if (this.$refs.upLoadRef) {
				this.$refs.upLoadRef.value = ''; // 置空input文件
			}
		},
		updateReportPic: function updateReportPic() {
			var _this7 = this;

			if (this.yhpicForm.picUrl == '') {
				this.$message.error("图片不存在，请上传文件后再点击保存");
			} else {
				this.$refs.yhpicForm.validate(function (valid) {
					if (valid) {
						_this7.$confirm('确认提交照片吗？', '提示', {}).then(function () {
							_this7.yhpicLoading = true;

							__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["C" /* addReportPic */])(_this7.yhpicForm).then(function (res) {
								_this7.yhpicLoading = false;
								_this7.yhpicFormVisible = false;
								if (res.data.code == 0) {
									_this7.$message.success(res.data.message);
									_this7.getPageList();
								} else {
									_this7.$message.error(res.data.message);
								}
							});
						});
					}
				});
			}
		},
		//获取企业全部人员列表
		getAllWorkerList: function getAllWorkerList() {
			var _this8 = this;

			var para = {
				coId: this.coId
			};

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api__["D" /* allWorkerList */])(para).then(function (res) {
				if (res.data.code == 0) {
					_this8.companymemberlist = res.data.data;
					_this8.workerId = _this8.companymemberlist[0].workerId;
				}
			});
		}
	},
	mounted: function mounted() {
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.objectId = user.data.userId;
		this.coId = user.data.coId;

		if (user.data.roleId == "4") {
			this.filters.companyName = user.data.userName;
			this.bshow = true;
			this.bquery = false;
			this.getAllWorkerList();
		} else {
			this.bquery = true;
			this.bshow = false;
		}

		this.getPageList();
		this.getQYPCCSdic();
	}
});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_store__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_xlsx__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_xlsx__);




// import './assets/theme/theme-green/index.css'







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.XLSX = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
  //NProgress.start();
  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  var user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

//router.afterEach(transition => {
//NProgress.done();
//});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  //el: '#app',
  //template: '<App/>',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__vuex_store__["a" /* default */],
  //components: { App }
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increment", function() { return increment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrement", function() { return decrement; });
//test
var increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCount", function() { return getCount; });
//test
var getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(777)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  "data-v-624219a5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 761:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 768:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 775:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 778:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 779:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 780:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 781:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 782:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 783:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 223,
	"./af.js": 223,
	"./ar": 230,
	"./ar-dz": 224,
	"./ar-dz.js": 224,
	"./ar-kw": 225,
	"./ar-kw.js": 225,
	"./ar-ly": 226,
	"./ar-ly.js": 226,
	"./ar-ma": 227,
	"./ar-ma.js": 227,
	"./ar-sa": 228,
	"./ar-sa.js": 228,
	"./ar-tn": 229,
	"./ar-tn.js": 229,
	"./ar.js": 230,
	"./az": 231,
	"./az.js": 231,
	"./be": 232,
	"./be.js": 232,
	"./bg": 233,
	"./bg.js": 233,
	"./bm": 234,
	"./bm.js": 234,
	"./bn": 236,
	"./bn-bd": 235,
	"./bn-bd.js": 235,
	"./bn.js": 236,
	"./bo": 237,
	"./bo.js": 237,
	"./br": 238,
	"./br.js": 238,
	"./bs": 239,
	"./bs.js": 239,
	"./ca": 240,
	"./ca.js": 240,
	"./cs": 241,
	"./cs.js": 241,
	"./cv": 242,
	"./cv.js": 242,
	"./cy": 243,
	"./cy.js": 243,
	"./da": 244,
	"./da.js": 244,
	"./de": 247,
	"./de-at": 245,
	"./de-at.js": 245,
	"./de-ch": 246,
	"./de-ch.js": 246,
	"./de.js": 247,
	"./dv": 248,
	"./dv.js": 248,
	"./el": 249,
	"./el.js": 249,
	"./en-au": 250,
	"./en-au.js": 250,
	"./en-ca": 251,
	"./en-ca.js": 251,
	"./en-gb": 252,
	"./en-gb.js": 252,
	"./en-ie": 253,
	"./en-ie.js": 253,
	"./en-il": 254,
	"./en-il.js": 254,
	"./en-in": 255,
	"./en-in.js": 255,
	"./en-nz": 256,
	"./en-nz.js": 256,
	"./en-sg": 257,
	"./en-sg.js": 257,
	"./eo": 258,
	"./eo.js": 258,
	"./es": 262,
	"./es-do": 259,
	"./es-do.js": 259,
	"./es-mx": 260,
	"./es-mx.js": 260,
	"./es-us": 261,
	"./es-us.js": 261,
	"./es.js": 262,
	"./et": 263,
	"./et.js": 263,
	"./eu": 264,
	"./eu.js": 264,
	"./fa": 265,
	"./fa.js": 265,
	"./fi": 266,
	"./fi.js": 266,
	"./fil": 267,
	"./fil.js": 267,
	"./fo": 268,
	"./fo.js": 268,
	"./fr": 271,
	"./fr-ca": 269,
	"./fr-ca.js": 269,
	"./fr-ch": 270,
	"./fr-ch.js": 270,
	"./fr.js": 271,
	"./fy": 272,
	"./fy.js": 272,
	"./ga": 273,
	"./ga.js": 273,
	"./gd": 274,
	"./gd.js": 274,
	"./gl": 275,
	"./gl.js": 275,
	"./gom-deva": 276,
	"./gom-deva.js": 276,
	"./gom-latn": 277,
	"./gom-latn.js": 277,
	"./gu": 278,
	"./gu.js": 278,
	"./he": 279,
	"./he.js": 279,
	"./hi": 280,
	"./hi.js": 280,
	"./hr": 281,
	"./hr.js": 281,
	"./hu": 282,
	"./hu.js": 282,
	"./hy-am": 283,
	"./hy-am.js": 283,
	"./id": 284,
	"./id.js": 284,
	"./is": 285,
	"./is.js": 285,
	"./it": 287,
	"./it-ch": 286,
	"./it-ch.js": 286,
	"./it.js": 287,
	"./ja": 288,
	"./ja.js": 288,
	"./jv": 289,
	"./jv.js": 289,
	"./ka": 290,
	"./ka.js": 290,
	"./kk": 291,
	"./kk.js": 291,
	"./km": 292,
	"./km.js": 292,
	"./kn": 293,
	"./kn.js": 293,
	"./ko": 294,
	"./ko.js": 294,
	"./ku": 295,
	"./ku.js": 295,
	"./ky": 296,
	"./ky.js": 296,
	"./lb": 297,
	"./lb.js": 297,
	"./lo": 298,
	"./lo.js": 298,
	"./lt": 299,
	"./lt.js": 299,
	"./lv": 300,
	"./lv.js": 300,
	"./me": 301,
	"./me.js": 301,
	"./mi": 302,
	"./mi.js": 302,
	"./mk": 303,
	"./mk.js": 303,
	"./ml": 304,
	"./ml.js": 304,
	"./mn": 305,
	"./mn.js": 305,
	"./mr": 306,
	"./mr.js": 306,
	"./ms": 308,
	"./ms-my": 307,
	"./ms-my.js": 307,
	"./ms.js": 308,
	"./mt": 309,
	"./mt.js": 309,
	"./my": 310,
	"./my.js": 310,
	"./nb": 311,
	"./nb.js": 311,
	"./ne": 312,
	"./ne.js": 312,
	"./nl": 314,
	"./nl-be": 313,
	"./nl-be.js": 313,
	"./nl.js": 314,
	"./nn": 315,
	"./nn.js": 315,
	"./oc-lnc": 316,
	"./oc-lnc.js": 316,
	"./pa-in": 317,
	"./pa-in.js": 317,
	"./pl": 318,
	"./pl.js": 318,
	"./pt": 320,
	"./pt-br": 319,
	"./pt-br.js": 319,
	"./pt.js": 320,
	"./ro": 321,
	"./ro.js": 321,
	"./ru": 322,
	"./ru.js": 322,
	"./sd": 323,
	"./sd.js": 323,
	"./se": 324,
	"./se.js": 324,
	"./si": 325,
	"./si.js": 325,
	"./sk": 326,
	"./sk.js": 326,
	"./sl": 327,
	"./sl.js": 327,
	"./sq": 328,
	"./sq.js": 328,
	"./sr": 330,
	"./sr-cyrl": 329,
	"./sr-cyrl.js": 329,
	"./sr.js": 330,
	"./ss": 331,
	"./ss.js": 331,
	"./sv": 332,
	"./sv.js": 332,
	"./sw": 333,
	"./sw.js": 333,
	"./ta": 334,
	"./ta.js": 334,
	"./te": 335,
	"./te.js": 335,
	"./tet": 336,
	"./tet.js": 336,
	"./tg": 337,
	"./tg.js": 337,
	"./th": 338,
	"./th.js": 338,
	"./tk": 339,
	"./tk.js": 339,
	"./tl-ph": 340,
	"./tl-ph.js": 340,
	"./tlh": 341,
	"./tlh.js": 341,
	"./tr": 342,
	"./tr.js": 342,
	"./tzl": 343,
	"./tzl.js": 343,
	"./tzm": 345,
	"./tzm-latn": 344,
	"./tzm-latn.js": 344,
	"./tzm.js": 345,
	"./ug-cn": 346,
	"./ug-cn.js": 346,
	"./uk": 347,
	"./uk.js": 347,
	"./ur": 348,
	"./ur.js": 348,
	"./uz": 350,
	"./uz-latn": 349,
	"./uz-latn.js": 349,
	"./uz.js": 350,
	"./vi": 351,
	"./vi.js": 351,
	"./x-pseudo": 352,
	"./x-pseudo.js": 352,
	"./yo": 353,
	"./yo.js": 353,
	"./zh-cn": 354,
	"./zh-cn.js": 354,
	"./zh-hk": 355,
	"./zh-hk.js": 355,
	"./zh-mo": 356,
	"./zh-mo.js": 356,
	"./zh-tw": 357,
	"./zh-tw.js": 357
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 790;

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(780)

var Component = __webpack_require__(8)(
  /* script */
  null,
  /* template */
  __webpack_require__(837),
  /* scopeId */
  "data-v-6dfc7d1f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(774)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  "data-v-50045eb0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(771)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  "data-v-45a12af0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(764)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  "data-v-171036fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(773)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  "data-v-4d698695",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(786)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  "data-v-eff7fb52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(776)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(833),
  /* scopeId */
  "data-v-61d78db2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(779)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-6b937918",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(767)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  "data-v-2d63f2fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(763)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  "data-v-0bc0e2f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(781)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  "data-v-755de736",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(772)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  "data-v-4d68deee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(769)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  "data-v-3731a3d2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(778)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  "data-v-69b15b1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(783)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  "data-v-960dfb20",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(768)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  "data-v-35ff7ea2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(766)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(823),
  /* scopeId */
  "data-v-2bae5e2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(765)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  "data-v-17b35260",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(787)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  "data-v-fc7917b4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(762)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(819),
  /* scopeId */
  "data-v-091aaef0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(761)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  "data-v-060cd3c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(775)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  "data-v-58ea9bdb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(784)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  "data-v-a7e14080",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(770)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  "data-v-37fec928",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(782)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  "data-v-7f4f888b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 818:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.coName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "coName", $$v)
      },
      expression: "filters.coName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "年份"
    },
    model: {
      value: (_vm.filters.fileNf),
      callback: function($$v) {
        _vm.$set(_vm.filters, "fileNf", $$v)
      },
      expression: "filters.fileNf"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getSumListPage
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), (_vm.showcity) ? _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "align": "center",
      "min-width": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coHeadName",
      "label": "法人姓名",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coHeadMobile",
      "label": "联系电话",
      "align": "center",
      "min-width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "一报告双签字",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.signAct))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.signActDesc))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "五个一活动",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "hover-trigger",
          on: {
            "mouseover": function($event) {
              return _vm.showTooltip(scope.row, $event)
            },
            "mouseout": function($event) {
              return _vm.hideTooltip()
            }
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.fiveAct))])]), _vm._v(" "), (_vm.visibleTooltip) ? _c('div', {
          staticClass: "custom-tooltip",
          style: ({
            left: _vm.tooltipLeft + 'px',
            top: _vm.tooltipTop + 'px'
          })
        }, [_c('h4', [_vm._v("缺少的报告清单")]), _vm._v(" "), _c('span', {
          staticClass: "wrap-span"
        }, [_vm._v(_vm._s(_vm.currentRow.fiveActDesc))])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "企业主要负责人达标情况",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "年度六类报告",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "hover-trigger",
          on: {
            "mouseover": function($event) {
              return _vm.showTooltip2(scope.row, $event)
            },
            "mouseout": function($event) {
              return _vm.hideTooltip2()
            }
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.yearAct))])]), _vm._v(" "), (_vm.visibleTooltip2) ? _c('div', {
          staticClass: "custom-tooltip",
          style: ({
            left: _vm.tooltipLeft2 + 'px',
            top: _vm.tooltipTop2 + 'px'
          })
        }, [_c('h4', [_vm._v("缺少的报告清单")]), _vm._v(" "), _c('span', {
          staticClass: "wrap-span"
        }, [_vm._v(_vm._s(_vm.currentRow2.yearActDesc))])]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lessonAct",
      "label": "半年度辅导课报告",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "searchAct",
      "label": "季度研究报告",
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "monthCheck",
      "label": "月度检查报告",
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "talkCheck",
      "label": "月度讲评会报告",
      "align": "center",
      "min-width": "100"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.detailFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('el-row', [_c('el-col', [_c('div', [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.companyName))])])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.feelistLoading),
      expression: "feelistLoading"
    }],
    attrs: {
      "data": _vm.feedata,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "月份",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mcount",
      "label": "记录数量",
      "align": "center",
      "min-width": "120"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 5,
      "total": _vm.feetotal
    },
    on: {
      "current-change": _vm.handletypeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "通知标题"
    },
    model: {
      value: (_vm.filters.title),
      callback: function($$v) {
        _vm.$set(_vm.filters, "title", $$v)
      },
      expression: "filters.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getNoticeList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (!_vm.comuser) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("发布通知")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.noticelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "发布人",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "发布时间",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), (!_vm.comuser) ? _c('el-table-column', {
    attrs: {
      "label": "通知类型",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.noticeType === '0' ? '全部企业' : "指定企业"))])]
      }
    }], null, false, 4292219793)
  }) : _vm._e(), _vm._v(" "), (_vm.comuser) ? _c('el-table-column', {
    attrs: {
      "label": "通知状态",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.readStatus === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未读")])]) : _c('div', [_c('span', [_vm._v("已读")])])]
      }
    }], null, false, 1992527554)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("通知详情")]) : _vm._e(), _vm._v(" "), (!_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleCompanyDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("签收详情")]) : _vm._e(), _vm._v(" "), (!_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看通知")]) : _vm._e(), _vm._v(" "), (_vm.comuser) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleCompanyfileAdd(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传附件")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增通知信息",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.title),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "title", $$v)
      },
      expression: "addForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.content),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "content", $$v)
      },
      expression: "addForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通知类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.noticeType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "noticeType", $$v)
      },
      expression: "addForm.noticeType"
    }
  }, _vm._l((_vm.ntoptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.addForm.noticeType == '1') ? _c('el-form-item', {
    attrs: {
      "label": "接收企业"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.enterpriseList,
      "border": "",
      "max-height": "250"
    },
    on: {
      "selection-change": _vm.handleEnterpriseSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "通知附件"
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "/yhpczl/mgr/v1/notice/upload",
      "multiple": true,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "auto-upload": false,
      "accept": '.pdf',
      "on-success": _vm.handleAttachmentSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("点击上传")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleNoticeAdd.apply(null, arguments)
      }
    }
  }, [_vm._v("发布通知")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业提交材料",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "通知标题",
      "prop": "title"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.title))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业材料"
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "/yhpczl/mgr/v1/notice/upload",
      "multiple": true,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "auto-upload": false,
      "accept": '.pdf',
      "on-success": _vm.handleAttachmentSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("点击上传")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCompanyfile.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "通知详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('h2', {
    staticClass: "base-name"
  }, [_vm._v(_vm._s(_vm.detailForm.title))]), _vm._v(" "), _c('div', {
    staticClass: "base-info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发布人：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.userName))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发布时间：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.createTime))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("通知内容：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.content))])])]), _vm._v(" "), (_vm.detailForm.fileurls.length > 0) ? _c('div', [_c('h3', [_vm._v("通知附件")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailForm.fileurls,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")])]
      }
    }], null, false, 2718897294)
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.comuser && _vm.detailForm.comfileurls.length > 0) ? _c('div', [_c('h3', [_vm._v("企业资料")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailForm.comfileurls,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")])]
      }
    }], null, false, 2718897294)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "通知签收详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.comdetailFormVisible),
      callback: function($$v) {
        _vm.comdetailFormVisible = $$v
      },
      expression: "comdetailFormVisible"
    }
  }, [_c('h2', {
    staticClass: "base-name"
  }, [_vm._v(_vm._s(_vm.comdetailForm.title))]), _vm._v(" "), _c('div', {
    staticClass: "base-info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("应签收企业数：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.comdetailForm.totalcount))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("已签收企业数：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.comdetailForm.readcount))])])]), _vm._v(" "), _c('h3', [_vm._v("企业签收情况表")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comdetailForm.nclist,
      "border": "",
      "max-height": "250"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.readStatus === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未读")])]) : _c('div', [_c('span', [_vm._v("已读")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "企业材料",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.readStatus === "1") ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleShowComfile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看材料")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.comdetailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业资料",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.comdetailfileFormVisible),
      callback: function($$v) {
        _vm.comdetailfileFormVisible = $$v
      },
      expression: "comdetailfileFormVisible"
    }
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("企业名称：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.comdetailfileForm.coName))])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comdetailfileForm.comfileurls,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.comdetailfileFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 820:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "checkNumber",
      "label": "检查编号",
      "align": "center",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTime",
      "label": "检查时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yhStatusName",
      "label": "隐患状态",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.yhDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("隐患详情")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleZG(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下发整改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleyhStatus(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查验合格")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "200px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传责令整改通知书"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadGjFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改截止日期",
      "prop": "correctDeadTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm.selCorrectDeadTime),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "selCorrectDeadTime", $$v)
      },
      expression: "editForm.selCorrectDeadTime"
    }
  })], 1), _vm._v("\n\t\t\t\t请提前准备好“责令整改通知书”扫描件，上传文件成功后，再设置整改截止日期。\n      \t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCDTime.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("检查编号:  " + _vm._s(_vm.detailForm.checkNumber) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content"
  }, [_c('label', [_vm._v("检查时间:  " + _vm._s(_vm.detailForm.checkTime) + " ")])]), _vm._v(" "), _vm._l((_vm.feedata), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('label', [_vm._v("【" + _vm._s(item.checkType) + "】" + _vm._s(item.checkContent))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content bg-purple-light"
    }, [_c('label', [_vm._v("检查结果:  " + _vm._s(item.checkResult == '1' ? '合格' : '不合格') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content"
    }, [_c('label', [_vm._v("检查备注:  " + _vm._s(item.checkDesc) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-container"
    }, _vm._l((item.picList), function(picurl) {
      return _c('div', {
        key: picurl,
        staticClass: "image-item"
      }, [_c('img', {
        attrs: {
          "src": _vm.picbaseurl + picurl,
          "alt": "Image"
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showBigImage(_vm.picbaseurl + picurl)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 2), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "stats-col",
    attrs: {
      "span": 6
    }
  }, _vm._l((_vm.statsData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "stats-card"
    }, [_c('div', {
      staticClass: "stats-item"
    }, [_c('span', {
      staticClass: "stats-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "stats-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', {
      staticClass: "stats-unit"
    }, [_vm._v(_vm._s(item.unit))])])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "map-col",
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "map-card"
  }, [_c('div', {
    staticClass: "map-title"
  }, [_vm._v("宜春市企业分布地图")]), _vm._v(" "), _c('div', {
    staticClass: "map-container",
    attrs: {
      "id": "jiangxi-map"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "stats-col",
    attrs: {
      "span": 6
    }
  }, _vm._l((_vm.extraStatsData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "stats-card"
    }, [_c('div', {
      staticClass: "stats-item"
    }, [_c('span', {
      staticClass: "stats-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "stats-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', {
      staticClass: "stats-unit"
    }, [_vm._v(_vm._s(item.unit))])])])
  }), 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "检查标题"
    },
    model: {
      value: (_vm.filters.checkTitle),
      callback: function($$v) {
        _vm.$set(_vm.filters, "checkTitle", $$v)
      },
      expression: "filters.checkTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showAddRecord
    }
  }, [_vm._v("新增检查记录")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTitle",
      "label": "检查标题",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkDate",
      "label": "检查时间",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkContent",
      "label": "检查内容",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检查状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.checkStatus === '0' ? '未整改' : "已整改"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.bquery) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改")]) : _vm._e(), _vm._v(" "), (scope.row.checkURL != '') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownloadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载检查材料")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增检查记录",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.fileFormVisible),
      callback: function($$v) {
        _vm.fileFormVisible = $$v
      },
      expression: "fileFormVisible"
    }
  }, [_c('el-form', {
    ref: "fileForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.fileForm,
      "label-width": "120px",
      "rules": _vm.fileFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "检查标题",
      "prop": "checkTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入检查标题",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fileForm.checkTitle),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "checkTitle", $$v)
      },
      expression: "fileForm.checkTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检查时间",
      "prop": "checkDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.fileForm.selCheckDate),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "selCheckDate", $$v)
      },
      expression: "fileForm.selCheckDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检查内容",
      "prop": "checkContent"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入检查内容",
      "auto-complete": "off",
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.fileForm.checkContent),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "checkContent", $$v)
      },
      expression: "fileForm.checkContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接收企业"
    }
  }, [_c('el-table', {
    ref: "enterpriseTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.enterpriseList,
      "border": "",
      "max-height": "250"
    },
    on: {
      "selection-change": _vm.handleEnterpriseSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检查附件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadTrainFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v("\n\t\t\t\t如果有检查相关的文件或照片，请提前准备好并压缩成zip格式，再上传。\n\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fileFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handlefile.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "整改信息",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "整改时间",
      "prop": "correctDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm.selCorrectDate),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "selCorrectDate", $$v)
      },
      expression: "editForm.selCorrectDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改说明",
      "prop": "correctContent"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入整改说明",
      "auto-complete": "off",
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.editForm.correctContent),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "correctContent", $$v)
      },
      expression: "editForm.correctContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检查附件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef1",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload1.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart1),
      expression: "uploadstart1"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadTrainFile1.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v("\n\t\t\t\t如果有整改相关的文件或照片，请提前准备好并压缩成zip格式，再上传。\n\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editGovCheckRecord.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "检查标题"
    },
    model: {
      value: (_vm.filters.checkTitle),
      callback: function($$v) {
        _vm.$set(_vm.filters, "checkTitle", $$v)
      },
      expression: "filters.checkTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "150",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTitle",
      "label": "检查标题",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkDate",
      "label": "检查时间",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkContent",
      "label": "检查内容",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "检查状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.checkStatus === '0' ? '未整改' : "已整改"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctDate",
      "label": "整改时间",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctContent",
      "label": "整改说明",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.correctURL != '') ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownloadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载整改材料")]) : _vm._e(), _vm._v(" "), (scope.row.checkURL != '') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownloadCheckFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载检查材料")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 824:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "checkNumber",
      "label": "检查编号",
      "align": "center",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTime",
      "label": "检查时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yhStatusName",
      "label": "隐患状态",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctDeadTime",
      "label": "整改期限",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctTime",
      "label": "整改完成时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctContent",
      "label": "整改措施",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.yhDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("隐患详情")]), _vm._v(" "), (scope.row.correctNoticeURL != '') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改通知书")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownloadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载整改材料")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleZGFC(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改复查")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("检查编号:  " + _vm._s(_vm.detailForm.checkNumber) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content"
  }, [_c('label', [_vm._v("检查时间:  " + _vm._s(_vm.detailForm.checkTime) + " ")])]), _vm._v(" "), _vm._l((_vm.feedata), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('label', [_vm._v("【" + _vm._s(item.checkType) + "】" + _vm._s(item.checkContent))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content bg-purple-light"
    }, [_c('label', [_vm._v("检查结果:  " + _vm._s(item.checkResult == '1' ? '合格' : '不合格') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content"
    }, [_c('label', [_vm._v("检查备注:  " + _vm._s(item.checkDesc) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-container"
    }, _vm._l((item.picList), function(picurl) {
      return _c('div', {
        key: picurl,
        staticClass: "image-item"
      }, [_c('img', {
        attrs: {
          "src": _vm.picbaseurl + picurl,
          "alt": "Image"
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showBigImage(_vm.picbaseurl + picurl)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 2), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "复查结果"
    }
  }, [_c('div', [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.reviewradio),
      callback: function($$v) {
        _vm.reviewradio = $$v
      },
      expression: "reviewradio"
    }
  }, [_vm._v("不合格")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.reviewradio),
      callback: function($$v) {
        _vm.reviewradio = $$v
      },
      expression: "reviewradio"
    }
  }, [_vm._v("合格")])], 1)]), _vm._v(" "), (_vm.reviewradio == '1') ? _c('el-form-item', {
    attrs: {
      "label": "复查日期",
      "prop": "reviewTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm.selReviewTime),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "selReviewTime", $$v)
      },
      expression: "editForm.selReviewTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reviewradio == '1') ? _c('el-form-item', {
    attrs: {
      "label": "复查说明",
      "prop": "reviewContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.reviewContent),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "reviewContent", $$v)
      },
      expression: "editForm.reviewContent"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReview.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 825:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "培训名称"
    },
    model: {
      value: (_vm.filters.trainName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "trainName", $$v)
      },
      expression: "filters.trainName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (!_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showAddRecord
    }
  }, [_vm._v("上传培训记录")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [(_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trainName",
      "label": "培训名称",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trainDate",
      "label": "培训时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trainMember",
      "label": "参训人员",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trainContent",
      "label": "培训内容",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.bquery) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleTrainDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownloadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载培训附件")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增培训记录",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.fileFormVisible),
      callback: function($$v) {
        _vm.fileFormVisible = $$v
      },
      expression: "fileFormVisible"
    }
  }, [_c('el-form', {
    ref: "fileForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.fileForm,
      "label-width": "120px",
      "rules": _vm.fileFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训名称",
      "prop": "trainName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入培训名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fileForm.trainName),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "trainName", $$v)
      },
      expression: "fileForm.trainName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "培训时间",
      "prop": "trainDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.fileForm.selTrainDate),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "selTrainDate", $$v)
      },
      expression: "fileForm.selTrainDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "参训人员",
      "prop": "trainMember"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入参加培训的人员名单",
      "auto-complete": "off",
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.fileForm.trainMember),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "trainMember", $$v)
      },
      expression: "fileForm.trainMember"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "培训内容",
      "prop": "trainContent"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入培训内容",
      "auto-complete": "off",
      "type": "textarea",
      "rows": 2
    },
    model: {
      value: (_vm.fileForm.trainContent),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "trainContent", $$v)
      },
      expression: "fileForm.trainContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "培训附件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadTrainFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v("\n\t\t\t\t请提前准备好培训有关的文件，照片压缩成zip格式，压缩文件上传成功后，补充其他信息后点击保存。\n\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fileFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handlefile.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 826:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "文件名称"
    },
    model: {
      value: (_vm.filters.fileName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "fileName", $$v)
      },
      expression: "filters.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.companyFileList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddbzhFile
    }
  }, [_vm._v("新增文件")])], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.dcLoading
    },
    on: {
      "click": _vm.handledc
    }
  }, [_vm._v("导出")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companyfilelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件名称",
      "min-width": "220",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileTypeName",
      "label": "文件类型",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "提交日期",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "所属企业",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看文件")]), _vm._v(" "), (_vm.bshow) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增文件",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.fileFormVisible),
      callback: function($$v) {
        _vm.fileFormVisible = $$v
      },
      expression: "fileFormVisible"
    }
  }, [_c('el-form', {
    ref: "fileForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.fileForm,
      "label-width": "150px",
      "rules": _vm.fileFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件类型"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "440px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.fileTypevalue),
      callback: function($$v) {
        _vm.fileTypevalue = $$v
      },
      expression: "fileTypevalue"
    }
  }, _vm._l((_vm.fileTypeoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传文件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadCompanyFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件名称",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入文件名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fileForm.fileName),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "fileName", $$v)
      },
      expression: "fileForm.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年份",
      "prop": "fileNf"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入年份，比如2026年，就输入2026",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fileForm.fileNf),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "fileNf", $$v)
      },
      expression: "fileForm.fileNf"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fileFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handlefile.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 827:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1) : _vm._e(), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddyhpcRecord
    }
  }, [_vm._v("上传排查记录")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [(_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTime",
      "label": "实际排查日期",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "selfCheckLocationName",
      "label": "排查场所",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "riskLevelName",
      "label": "风险等级",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerName",
      "label": "排查人",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkStatusName",
      "label": "排查状态",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkResult",
      "label": "排查结果",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planCorrectTime",
      "label": "整改计划完成时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctUserName",
      "label": "整改负责人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctContent",
      "label": "整改措施",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctTime",
      "label": "整改完成时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewUserName",
      "label": "验收人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewContent",
      "label": "验收内容",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewTime",
      "label": "验收时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.selfCheckDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("排查详情")]), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '不合格')) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleUploadPic(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传隐患照片")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '已整改')) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleUploadPic(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传整改照片")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '不合格')) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleZG(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改完成")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '已整改')) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleYS(scope.$index, scope.row)
            }
          }
        }, [_vm._v("验收完成")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患排查详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content"
  }, [_c('label', [_vm._v("排查日期:  " + _vm._s(_vm.detailForm.checkTime) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("检查状态:  " + _vm._s(_vm.detailForm.checkStatusName) + " ")])]), _vm._v(" "), (_vm.detailForm.selfCheckType == '0') ? _c('div', [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("排查结果:  " + _vm._s(_vm.detailForm.checkResult) + " ")])]), _vm._v(" "), (_vm.picList0.length != 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("隐患照片")])]) : _vm._e(), _vm._v(" "), (_vm.picList0.length != 0) ? _c('div', [_c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.picList0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.picbaseurl + item.picUrl,
        "alt": "Image"
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showBigImage(_vm.picbaseurl + item.picUrl)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.picList0.length != 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.picList1.length != 0) ? _c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("整改照片")])]) : _vm._e(), _vm._v(" "), (_vm.picList1.length != 0) ? _c('div', [_c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.picList1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.picbaseurl + item.picUrl,
        "alt": "Image"
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showBigImage(_vm.picbaseurl + item.picUrl)
        }
      }
    })])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.detailForm.selfCheckType == '1') ? _c('div', [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("问题描述:  " + _vm._s(_vm.detailForm.checkResult) + " ")])]), _vm._v(" "), _vm._l((_vm.feedata), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('label', [_vm._v(_vm._s(item.checkContent))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content bg-purple-light"
    }, [_c('label', [_vm._v("检查结果:  " + _vm._s(item.checkResult == '1' ? '合格' : '不合格') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-container"
    }, _vm._l((item.picList), function(picUrl) {
      return _c('div', {
        key: picUrl,
        staticClass: "image-item"
      }, [_c('img', {
        attrs: {
          "src": _vm.picbaseurl + picUrl,
          "alt": "Image"
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showBigImage(_vm.picbaseurl + picUrl)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('hr')])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.zgFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.zgFormVisible),
      callback: function($$v) {
        _vm.zgFormVisible = $$v
      },
      expression: "zgFormVisible"
    }
  }, [_c('el-form', {
    ref: "zgForm",
    attrs: {
      "model": _vm.zgForm,
      "label-width": "200px",
      "rules": _vm.zgFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "整改负责人"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改完成日期",
      "prop": "correctTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.zgForm.selCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.zgForm, "selCorrectTime", $$v)
      },
      expression: "zgForm.selCorrectTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改措施",
      "prop": "correctContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.zgForm.correctContent),
      callback: function($$v) {
        _vm.$set(_vm.zgForm, "correctContent", $$v)
      },
      expression: "zgForm.correctContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.zgFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateZgInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.ysFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.ysFormVisible),
      callback: function($$v) {
        _vm.ysFormVisible = $$v
      },
      expression: "ysFormVisible"
    }
  }, [_c('el-form', {
    ref: "ysForm",
    attrs: {
      "model": _vm.ysForm,
      "label-width": "200px",
      "rules": _vm.ysFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "验收人"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验收日期",
      "prop": "reviewTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ysForm.selReviewTime),
      callback: function($$v) {
        _vm.$set(_vm.ysForm, "selReviewTime", $$v)
      },
      expression: "ysForm.selReviewTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验收内容",
      "prop": "reviewContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ysForm.reviewContent),
      callback: function($$v) {
        _vm.$set(_vm.ysForm, "reviewContent", $$v)
      },
      expression: "ysForm.reviewContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.ysFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateYsInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.uploadpicTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.yhpicFormVisible),
      callback: function($$v) {
        _vm.yhpicFormVisible = $$v
      },
      expression: "yhpicFormVisible"
    }
  }, [_c('el-form', {
    ref: "yhpicForm",
    attrs: {
      "model": _vm.yhpicForm,
      "label-width": "100px",
      "rules": _vm.yhpicFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传照片"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadReportFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v("\n\t\t\t\t请提前准备好照片，上传文件成功后，再点击保存。\n      \t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.yhpicFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.yhpicLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReportPic.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "上传隐患排查记录",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addyhpcFormVisible),
      callback: function($$v) {
        _vm.addyhpcFormVisible = $$v
      },
      expression: "addyhpcFormVisible"
    }
  }, [_c('el-form', {
    ref: "addyhpcForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addyhpcForm,
      "label-width": "140px",
      "rules": _vm.addyhpcFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排查场所"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selfCheckLocationvalue),
      callback: function($$v) {
        _vm.selfCheckLocationvalue = $$v
      },
      expression: "selfCheckLocationvalue"
    }
  }, _vm._l((_vm.selfCheckLocationoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排查人员"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "实际排查日期",
      "prop": "checkTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selCheckTime),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selCheckTime", $$v)
      },
      expression: "addyhpcForm.selCheckTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "排查结果",
      "prop": "checkResult"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addyhpcForm.checkResult),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "checkResult", $$v)
      },
      expression: "addyhpcForm.checkResult"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "风险级别"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.riskLevelvalue),
      callback: function($$v) {
        _vm.riskLevelvalue = $$v
      },
      expression: "riskLevelvalue"
    }
  }, _vm._l((_vm.riskLeveloptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "整改计划完成时间",
      "prop": "planCorrectTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selPlanCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selPlanCorrectTime", $$v)
      },
      expression: "addyhpcForm.selPlanCorrectTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addyhpcFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddyhpcRecord.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 828:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-form', {
    ref: "loginForm",
    staticClass: "login-container",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("宜春邮政快递业安全监管系统")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "loginName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.loginForm.loginName),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "loginName", $$v)
      },
      expression: "loginForm.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myfoot"
    }
  }, [_vm._v("\n    ©2026 宜春市邮政管理局 版权所有"), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#333"
    },
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("赣ICP备2026000945号-1")])])
}]}

/***/ }),

/***/ 829:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "车牌号"
    },
    model: {
      value: (_vm.filters.carNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "carNo", $$v)
      },
      expression: "filters.carNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.companyCarList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddbzhFile
    }
  }, [_vm._v("新增车辆")])], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.dcLoading
    },
    on: {
      "click": _vm.handledc
    }
  }, [_vm._v("导出")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "carNo",
      "label": "车牌号",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "carType",
      "label": "车辆型号",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "driveTypeName",
      "label": "驾驶类型",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "transTypeName",
      "label": "运输类型",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "energyTypeName",
      "label": "动力类型",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "所属企业",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), (_vm.bshow) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleCarDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 827636794)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增车辆",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.fileFormVisible),
      callback: function($$v) {
        _vm.fileFormVisible = $$v
      },
      expression: "fileFormVisible"
    }
  }, [_c('el-form', {
    ref: "fileForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.fileForm,
      "label-width": "120px",
      "rules": _vm.fileFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车辆型号",
      "prop": "carType"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入车辆型号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fileForm.carType),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "carType", $$v)
      },
      expression: "fileForm.carType"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "车牌号",
      "prop": "carNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入车牌号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.fileForm.carNo),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "carNo", $$v)
      },
      expression: "fileForm.carNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "驾驶类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.driveTypevalue),
      callback: function($$v) {
        _vm.driveTypevalue = $$v
      },
      expression: "driveTypevalue"
    }
  }, _vm._l((_vm.driveTypeoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "运输类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.transTypevalue),
      callback: function($$v) {
        _vm.transTypevalue = $$v
      },
      expression: "transTypevalue"
    }
  }, _vm._l((_vm.transTypeoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "动力类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.energyTypevalue),
      callback: function($$v) {
        _vm.energyTypevalue = $$v
      },
      expression: "energyTypevalue"
    }
  }, _vm._l((_vm.energyTypeoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.fileFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handlefile.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 830:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.coName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "coName", $$v)
      },
      expression: "filters.coName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getListPage
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "企业名称",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "locked",
      "label": "用户状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.locked === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("正常")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("禁用")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.locked == '0') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClose(scope.$index, scope.row)
            }
          }
        }, [_vm._v("禁用")]) : _vm._e(), _vm._v(" "), (scope.row.locked == '1') ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen(scope.$index, scope.row)
            }
          }
        }, [_vm._v("启用")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleresetpwd(scope.$index, scope.row)
            }
          }
        }, [_vm._v("重置密码")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 831:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 10
    }
  }, [(_vm.unreadCount != 0) ? _c('span', {
    staticStyle: {
      "margin-right": "10px",
      "color": "white"
    }
  }, [_vm._v("未读通知"), _c('el-badge', {
    attrs: {
      "max": 99,
      "value": _vm.unreadCount
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleModify.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.changeFormVisible),
      callback: function($$v) {
        _vm.changeFormVisible = $$v
      },
      expression: "changeFormVisible"
    }
  }, [_c('el-form', {
    ref: "changeForm",
    attrs: {
      "model": _vm.changeForm,
      "label-width": "100px",
      "rules": _vm.changeFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原密码",
      "prop": "oldpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changeForm.oldpassword),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "oldpassword", $$v)
      },
      expression: "changeForm.oldpassword"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "changeForm",
    attrs: {
      "model": _vm.changeForm,
      "label-width": "100px",
      "rules": _vm.changeFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newpassword"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changeForm.newpassword),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newpassword", $$v)
      },
      expression: "changeForm.newpassword"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "changeForm",
    attrs: {
      "model": _vm.changeForm,
      "label-width": "100px",
      "rules": _vm.changeFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "newpassword2"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changeForm.newpassword2),
      callback: function($$v) {
        _vm.$set(_vm.changeForm, "newpassword2", $$v)
      },
      expression: "changeForm.newpassword2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.changeFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.changeLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePwd.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 832:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.coName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "coName", $$v)
      },
      expression: "filters.coName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getSelfCheckSumListPage
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "recordcount",
      "label": "隐患排查记录数量",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reportcount",
      "label": "重大隐患上报数量",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleRecordDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("排查统计")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleReportDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上报统计")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.detailFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('el-row', [_c('el-col', [_c('div', [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.companyName))])])])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.feelistLoading),
      expression: "feelistLoading"
    }],
    attrs: {
      "data": _vm.feedata,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "月份",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mcount",
      "label": "记录数量",
      "align": "center",
      "min-width": "120"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 5,
      "total": _vm.feetotal
    },
    on: {
      "current-change": _vm.handletypeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 833:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "MpCn",
      "label": "所属城市",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ZGZcount",
      "label": "未整改企业数",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CXZGZcount",
      "label": "重新整改企业数",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FCZcount",
      "label": "未复查企业数",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ZGWCcount",
      "label": "已整改企业数",
      "align": "center",
      "min-width": "100"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "showPhoto",
    on: {
      "click": _vm.closeClick
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.url,
      "alt": "图片加载失败"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 835:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "客户名称"
    },
    model: {
      value: (_vm.filters.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "guestComName", $$v)
      },
      expression: "filters.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.guestCompanyList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (!_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAddbzhFile
    }
  }, [_vm._v("新增协议客户")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comguestlist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "guestComName",
      "label": "客户名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestDate",
      "label": "协议签订时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestGoods",
      "label": "物品名称",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestCode",
      "label": "信用代码",
      "align": "center",
      "min-width": "150"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "法人或寄件人姓名",
      "align": "center",
      "min-width": "120"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestWid",
      "label": "法人或寄件人身份证号",
      "align": "center",
      "min-width": "150"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "guestPhone",
      "label": "法人或寄件人电话",
      "align": "center",
      "min-width": "120"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看协议")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleWidNoShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看证件")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.updateFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("更新附件")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleGuestDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2303127837)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增协议客户",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.guestFormVisible),
      callback: function($$v) {
        _vm.guestFormVisible = $$v
      },
      expression: "guestFormVisible"
    }
  }, [_c('el-form', {
    ref: "guestForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.guestForm,
      "label-width": "210px",
      "rules": _vm.guestFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "guestComName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestComName", $$v)
      },
      expression: "guestForm.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信用代码",
      "prop": "guestCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入信用代码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestCode),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestCode", $$v)
      },
      expression: "guestForm.guestCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人或寄件人姓名",
      "prop": "guestName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法人或寄件人姓名",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestName),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestName", $$v)
      },
      expression: "guestForm.guestName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人或寄件人身份证号",
      "prop": "guestWid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法人或寄件人身份证号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestWid),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestWid", $$v)
      },
      expression: "guestForm.guestWid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人或寄件人电话",
      "prop": "guestPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入法人或寄件人电话",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestPhone),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestPhone", $$v)
      },
      expression: "guestForm.guestPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物品名称",
      "prop": "guestGoods"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入物品名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.guestForm.guestGoods),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "guestGoods", $$v)
      },
      expression: "guestForm.guestGoods"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "协议签订时间",
      "prop": "guestDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.guestForm.selGuestDate),
      callback: function($$v) {
        _vm.$set(_vm.guestForm, "selGuestDate", $$v)
      },
      expression: "guestForm.selGuestDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传协议文件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadXyFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上传寄件人或法人有效身份证件"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRefWid",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUploadWid.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstartWid),
      expression: "uploadstartWid"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadWidFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.guestFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addcomGuest.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新协议客户附件",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.guestFormUpdateVisible),
      callback: function($$v) {
        _vm.guestFormUpdateVisible = $$v
      },
      expression: "guestFormUpdateVisible"
    }
  }, [_c('el-form', {
    ref: "guestFormUpdate",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.guestFormUpdate,
      "label-width": "210px",
      "rules": _vm.guestFormUpdateRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "guestComName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入客户名称",
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.guestFormUpdate.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.guestFormUpdate, "guestComName", $$v)
      },
      expression: "guestFormUpdate.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新协议文件"
    }
  }, [_c('div', [_c('input', {
    ref: "newupLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.newhandleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newuploadstart),
      expression: "newuploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.newuploadXyFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新寄件人或法人有效身份证件"
    }
  }, [_c('div', [_c('input', {
    ref: "newupLoadRefWid",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.newhandleFileUploadWid.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newuploadstartWid),
      expression: "newuploadstartWid"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.newuploadWidFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.guestFormUpdateVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fileLoadingUpdate
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updatecomGuest.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "checkNumber",
      "label": "检查编号",
      "align": "center",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTime",
      "label": "检查时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yhStatusName",
      "label": "隐患状态",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctDeadTime",
      "label": "整改期限",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctTime",
      "label": "整改完成日期",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctContent",
      "label": "整改措施",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewTime",
      "label": "复查日期",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewContent",
      "label": "复查说明",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.yhDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("隐患详情")]), _vm._v(" "), (scope.row.correctNoticeURL != '') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改通知书")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDownloadFile(scope.$index, scope.row)
            }
          }
        }, [_vm._v("下载整改材料")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("检查编号:  " + _vm._s(_vm.detailForm.checkNumber) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content"
  }, [_c('label', [_vm._v("检查时间:  " + _vm._s(_vm.detailForm.checkTime) + " ")])]), _vm._v(" "), _vm._l((_vm.feedata), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('label', [_vm._v("【" + _vm._s(item.checkType) + "】" + _vm._s(item.checkContent))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content bg-purple-light"
    }, [_c('label', [_vm._v("检查结果:  " + _vm._s(item.checkResult == '1' ? '合格' : '不合格') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content"
    }, [_c('label', [_vm._v("检查备注:  " + _vm._s(item.checkDesc) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-container"
    }, _vm._l((item.picList), function(picurl) {
      return _c('div', {
        key: picurl,
        staticClass: "image-item"
      }, [_c('img', {
        attrs: {
          "src": _vm.picbaseurl + picurl,
          "alt": "Image"
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showBigImage(_vm.picbaseurl + picurl)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 2), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 837:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 838:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.bquery) ? _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getCompanyList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增企业")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.dcLoading
    },
    on: {
      "click": _vm.handledc
    }
  }, [_vm._v("导出")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), (!_vm.cityFix && _vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "min-width": "100",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "districtName",
      "label": "所属区",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kdppTypeName",
      "label": "品牌",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coHeadName",
      "label": "法人或负责人姓名",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coHeadMobile",
      "label": "法人或负责人电话",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.bquery) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showGuestcompany(scope.$index, scope.row)
            }
          }
        }, [_vm._v("协议客户")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")]), _vm._v(" "), (_vm.bshow) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增企业信息",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "prop": "coName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.coName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "coName", $$v)
      },
      expression: "addForm.coName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人或负责人姓名",
      "prop": "coHeadName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.coHeadName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "coHeadName", $$v)
      },
      expression: "addForm.coHeadName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人或负责人身份证号",
      "prop": "coHeadWidNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.coHeadWidNo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "coHeadWidNo", $$v)
      },
      expression: "addForm.coHeadWidNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人或负责人电话",
      "prop": "coHeadMobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.coHeadMobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "coHeadMobile", $$v)
      },
      expression: "addForm.coHeadMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系邮箱",
      "prop": "coEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.coEmail),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "coEmail", $$v)
      },
      expression: "addForm.coEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经营许可证号或分支机构名录号",
      "prop": "businessNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.businessNumber),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "businessNumber", $$v)
      },
      expression: "addForm.businessNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "许可证有效期止",
      "prop": "businessNumberEffectDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addForm.selBusinessNumberEffectDate),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "selBusinessNumberEffectDate", $$v)
      },
      expression: "addForm.selBusinessNumberEffectDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "社会信用代码",
      "prop": "socialCreditCode"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.socialCreditCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "socialCreditCode", $$v)
      },
      expression: "addForm.socialCreditCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "企业地址",
      "prop": "coAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.coAddress),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "coAddress", $$v)
      },
      expression: "addForm.coAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ppvalue),
      callback: function($$v) {
        _vm.ppvalue = $$v
      },
      expression: "ppvalue"
    }
  }, _vm._l((_vm.ppoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "区"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.dvalue),
      callback: function($$v) {
        _vm.dvalue = $$v
      },
      expression: "dvalue"
    }
  }, _vm._l((_vm.doptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": true
    },
    on: {
      "change": _vm.ssbmpchange
    },
    model: {
      value: (_vm.pvalue),
      callback: function($$v) {
        _vm.pvalue = $$v
      },
      expression: "pvalue"
    }
  }, _vm._l((_vm.poptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "市"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.cityFix
    },
    on: {
      "change": _vm.ssbmcchange
    },
    model: {
      value: (_vm.cvalue),
      callback: function($$v) {
        _vm.cvalue = $$v
      },
      expression: "cvalue"
    }
  }, _vm._l((_vm.coptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addCompany.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人或负责人电话",
      "prop": "coHeadMobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.coHeadMobile),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "coHeadMobile", $$v)
      },
      expression: "editForm.coHeadMobile"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业联系邮箱",
      "prop": "coEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.coEmail),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "coEmail", $$v)
      },
      expression: "editForm.coEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经营许可证号或分支机构名录号",
      "prop": "businessNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.businessNumber),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "businessNumber", $$v)
      },
      expression: "editForm.businessNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "许可证有效期止",
      "prop": "businessNumberEffectDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm.selBusinessNumberEffectDate),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "selBusinessNumberEffectDate", $$v)
      },
      expression: "editForm.selBusinessNumberEffectDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业地址",
      "prop": "coAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.coAddress),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "coAddress", $$v)
      },
      expression: "editForm.coAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('h2', {
    staticClass: "base-name"
  }, [_vm._v(_vm._s(_vm.detailForm.coName))]), _vm._v(" "), _c('div', {
    staticClass: "base-info-row"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("法人或负责人姓名：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.coHeadName))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("法人或负责人电话：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.coHeadMobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("法人或负责人身份证号：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.coHeadWidNo))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("社会信用代码：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.socialCreditCode))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("企业联系邮箱：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.coEmail))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("经营许可证号或分支机构名录号：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.businessNumber))])]), _vm._v(" "), (new Date(_vm.detailForm.businessNumberEffectDate) < new Date()) ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("许可证有效期止：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.detailForm.businessNumberEffectDate))])]) : _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("许可证有效期止：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v(_vm._s(_vm.detailForm.businessNumberEffectDate))])]), _vm._v(" "), _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("企业地址：")]), _vm._v(" "), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.detailForm.coAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业协议客户",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.guestcomVisible),
      callback: function($$v) {
        _vm.guestcomVisible = $$v
      },
      expression: "guestcomVisible"
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.gfilters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "客户名称"
    },
    model: {
      value: (_vm.gfilters.guestComName),
      callback: function($$v) {
        _vm.$set(_vm.gfilters, "guestComName", $$v)
      },
      expression: "gfilters.guestComName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.guestCompanyList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.comguestlist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "guestComName",
      "label": "客户名称",
      "min-width": "140",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestName",
      "label": "法人或寄件人姓名",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestPhone",
      "label": "法人或寄件人电话",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestWid",
      "label": "法人或寄件人身份证号",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestDate",
      "label": "协议签订日期",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "guestGoods",
      "label": "物品名称",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看协议")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleWidNoShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看证件")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.gtotal
    },
    on: {
      "current-change": _vm.handlegCurrentChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.guestcomVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 839:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1) : _vm._e(), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddyhpcReport
    }
  }, [_vm._v("上报重大隐患")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "findTime",
      "label": "隐患发现时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "selfCheckLocationName",
      "label": "发现场所",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerName",
      "label": "发现人员",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "findContent",
      "label": "隐患内容",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planCorrectTime",
      "label": "整改计划完成时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dangerStatusName",
      "label": "隐患状态",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctUserName",
      "label": "整改负责人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctContent",
      "label": "整改措施",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctTime",
      "label": "整改完成时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewUserName",
      "label": "验收人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewContent",
      "label": "验收内容",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewTime",
      "label": "验收时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.yhDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("隐患详情")]), _vm._v(" "), (_vm.bshow && (scope.row.dangerStatusName == '整改中')) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleUploadPic(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传隐患照片")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.dangerStatusName == '验收中')) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleUploadPic(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传整改照片")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.dangerStatusName == '整改中')) ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleZG(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改完成")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.dangerStatusName == '验收中')) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleYS(scope.$index, scope.row)
            }
          }
        }, [_vm._v("验收完成")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.zgFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.zgFormVisible),
      callback: function($$v) {
        _vm.zgFormVisible = $$v
      },
      expression: "zgFormVisible"
    }
  }, [_c('el-form', {
    ref: "zgForm",
    attrs: {
      "model": _vm.zgForm,
      "label-width": "200px",
      "rules": _vm.zgFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "整改负责人"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改完成日期",
      "prop": "correctTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.zgForm.selCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.zgForm, "selCorrectTime", $$v)
      },
      expression: "zgForm.selCorrectTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改措施",
      "prop": "correctContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.zgForm.correctContent),
      callback: function($$v) {
        _vm.$set(_vm.zgForm, "correctContent", $$v)
      },
      expression: "zgForm.correctContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.zgFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateZgInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.ysFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.ysFormVisible),
      callback: function($$v) {
        _vm.ysFormVisible = $$v
      },
      expression: "ysFormVisible"
    }
  }, [_c('el-form', {
    ref: "ysForm",
    attrs: {
      "model": _vm.ysForm,
      "label-width": "200px",
      "rules": _vm.ysFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "验收人"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验收日期",
      "prop": "reviewTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ysForm.selReviewTime),
      callback: function($$v) {
        _vm.$set(_vm.ysForm, "selReviewTime", $$v)
      },
      expression: "ysForm.selReviewTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验收内容",
      "prop": "reviewContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ysForm.reviewContent),
      callback: function($$v) {
        _vm.$set(_vm.ysForm, "reviewContent", $$v)
      },
      expression: "ysForm.reviewContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.ysFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateYsInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("隐患状态:  " + _vm._s(_vm.detailForm.dangerStatusName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("隐患内容:  " + _vm._s(_vm.detailForm.findContent))])]), _vm._v(" "), (_vm.picList0.length != 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("隐患照片")])]) : _vm._e(), _vm._v(" "), (_vm.picList0.length != 0) ? _c('div', [_c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.picList0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.picbaseurl + item.picUrl,
        "alt": "Image"
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showBigImage(_vm.picbaseurl + item.picUrl)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.picList0.length != 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.picList1.length != 0) ? _c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("整改照片")])]) : _vm._e(), _vm._v(" "), (_vm.picList1.length != 0) ? _c('div', [_c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.picList1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.picbaseurl + item.picUrl,
        "alt": "Image"
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showBigImage(_vm.picbaseurl + item.picUrl)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "上报重大隐患",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addyhpcFormVisible),
      callback: function($$v) {
        _vm.addyhpcFormVisible = $$v
      },
      expression: "addyhpcFormVisible"
    }
  }, [_c('el-form', {
    ref: "addyhpcForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addyhpcForm,
      "label-width": "140px",
      "rules": _vm.addyhpcFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发现场所"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selfCheckLocationvalue),
      callback: function($$v) {
        _vm.selfCheckLocationvalue = $$v
      },
      expression: "selfCheckLocationvalue"
    }
  }, _vm._l((_vm.selfCheckLocationoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发现人员"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "隐患发现时间",
      "prop": "findTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selFindTime),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selFindTime", $$v)
      },
      expression: "addyhpcForm.selFindTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "隐患内容",
      "prop": "findContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addyhpcForm.findContent),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "findContent", $$v)
      },
      expression: "addyhpcForm.findContent"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "整改计划完成时间",
      "prop": "planCorrectTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selPlanCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selPlanCorrectTime", $$v)
      },
      expression: "addyhpcForm.selPlanCorrectTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addyhpcFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddyhpczl.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.uploadpicTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.yhpicFormVisible),
      callback: function($$v) {
        _vm.yhpicFormVisible = $$v
      },
      expression: "yhpicFormVisible"
    }
  }, [_c('el-form', {
    ref: "yhpicForm",
    attrs: {
      "model": _vm.yhpicForm,
      "label-width": "100px",
      "rules": _vm.yhpicFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传照片"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadReportFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v("\n\t\t\t\t请提前准备好照片，上传文件成功后，再点击保存。\n      \t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.yhpicFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.yhpicLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReportPic.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 840:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery && _vm.cityFix) ? _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择区"
    },
    model: {
      value: (_vm.filters.dvalue),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dvalue", $$v)
      },
      expression: "filters.dvalue"
    }
  }, _vm._l((_vm.doptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.workerName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "workerName", $$v)
      },
      expression: "filters.workerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone", $$v)
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "身份证号"
    },
    model: {
      value: (_vm.filters.widNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "widNo", $$v)
      },
      expression: "filters.widNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getMemberList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showAddry
    }
  }, [_vm._v("新增人员")])], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.dcLoading
    },
    on: {
      "click": _vm.handledc
    }
  }, [_vm._v("导出")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.memberlist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.sex === '0' ? '女' : "男"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "widNo",
      "label": "身份证号",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合同状态",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.laborContract === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未签订")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("已签订")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保险状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.buyInsurance === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("未购买")])]) : _c('div', [_c('span', [_vm._v(_vm._s(scope.row.insurancetypeName))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerTypeName",
      "label": "岗位",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enterDate",
      "label": "入职日期",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "所属企业",
      "align": "center",
      "min-width": "180"
    }
  }), _vm._v(" "), (_vm.bshow) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2974640243)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "phone", $$v)
      },
      expression: "editForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "岗位"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.gwvalue),
      callback: function($$v) {
        _vm.gwvalue = $$v
      },
      expression: "gwvalue"
    }
  }, _vm._l((_vm.gwoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editMember.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增人员",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addryFormVisible),
      callback: function($$v) {
        _vm.addryFormVisible = $$v
      },
      expression: "addryFormVisible"
    }
  }, [_c('el-form', {
    ref: "addryForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addryForm,
      "label-width": "120px",
      "rules": _vm.addryFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addryForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "name", $$v)
      },
      expression: "addryForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "widNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addryForm.widNo),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "widNo", $$v)
      },
      expression: "addryForm.widNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addryForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "phone", $$v)
      },
      expression: "addryForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员岗位"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.gwvalue),
      callback: function($$v) {
        _vm.gwvalue = $$v
      },
      expression: "gwvalue"
    }
  }, _vm._l((_vm.gwoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "劳动合同"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addryForm.laborContract),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "laborContract", $$v)
      },
      expression: "addryForm.laborContract"
    }
  }, _vm._l((_vm.laboroptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入职日期",
      "prop": "enterDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addryForm.selEnterDate),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "selEnterDate", $$v)
      },
      expression: "addryForm.selEnterDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人员保险"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addryForm.buyInsurance),
      callback: function($$v) {
        _vm.$set(_vm.addryForm, "buyInsurance", $$v)
      },
      expression: "addryForm.buyInsurance"
    }
  }, _vm._l((_vm.insuranceoptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addryForm.buyInsurance == '1') ? _c('el-row', [_c('div', {
    staticClass: "checkbox-wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "label": "保险类别"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.bxselectedValues),
      callback: function($$v) {
        _vm.bxselectedValues = $$v
      },
      expression: "bxselectedValues"
    }
  }, _vm._l((_vm.bxoptions), function(item) {
    return _c('el-checkbox', {
      key: item.Mpid,
      staticClass: "checkbox-item",
      attrs: {
        "label": item.MpValue
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.MpCn) + "\n\t\t\t\t\t\t\t")])
  }), 1)], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addryFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddry.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 841:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "排查计划名称"
    },
    model: {
      value: (_vm.filters.planName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "planName", $$v)
      },
      expression: "filters.planName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddyhpcPlan
    }
  }, [_vm._v("制定隐患排查计划")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planName",
      "label": "排查计划名称",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "selfCheckPropertyName",
      "label": "排查性质",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "selfCheckContent",
      "label": "排查内容",
      "align": "center",
      "min-width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "riskLevelName",
      "label": "风险级别",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerName",
      "label": "排查人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "selfCheckPlanDate",
      "label": "计划排查日期",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建日期",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), (_vm.bshow) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 3231634506)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "制定隐患排查计划",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addyhpcFormVisible),
      callback: function($$v) {
        _vm.addyhpcFormVisible = $$v
      },
      expression: "addyhpcFormVisible"
    }
  }, [_c('el-form', {
    ref: "addyhpcForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addyhpcForm,
      "label-width": "120px",
      "rules": _vm.addyhpcFormRules
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "排查计划名称",
      "prop": "planName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addyhpcForm.planName),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "planName", $$v)
      },
      expression: "addyhpcForm.planName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "排查内容",
      "prop": "selfCheckContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addyhpcForm.selfCheckContent),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selfCheckContent", $$v)
      },
      expression: "addyhpcForm.selfCheckContent"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排查性质"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selfCheckPropertyvalue),
      callback: function($$v) {
        _vm.selfCheckPropertyvalue = $$v
      },
      expression: "selfCheckPropertyvalue"
    }
  }, _vm._l((_vm.selfCheckPropertyoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "风险级别"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.riskLevelvalue),
      callback: function($$v) {
        _vm.riskLevelvalue = $$v
      },
      expression: "riskLevelvalue"
    }
  }, _vm._l((_vm.riskLeveloptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计划排查日期",
      "prop": "selfCheckPlanDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selSelfCheckPlanDate),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selSelfCheckPlanDate", $$v)
      },
      expression: "addyhpcForm.selSelfCheckPlanDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排查人员"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addyhpcFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddyhpczl.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 842:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 843:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.bquery) ? _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "checkNumber",
      "label": "检查编号",
      "align": "center",
      "min-width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTime",
      "label": "检查时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yhStatusName",
      "label": "隐患状态",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctDeadTime",
      "label": "整改期限",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.yhDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("隐患详情")]), _vm._v(" "), (scope.row.correctNoticeURL != '') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleFileShow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改通知书")]) : _vm._e(), _vm._v(" "), (_vm.bshow) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleSQFC(scope.$index, scope.row)
            }
          }
        }, [_vm._v("申请复查")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.pdfFileName,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.pdfVisible),
      callback: function($$v) {
        _vm.pdfVisible = $$v
      },
      expression: "pdfVisible"
    }
  }, [_c('el-form', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "src": _vm.pdfSrc,
      "frameborder": "0"
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("检查编号:  " + _vm._s(_vm.detailForm.checkNumber) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content"
  }, [_c('label', [_vm._v("检查时间:  " + _vm._s(_vm.detailForm.checkTime) + " ")])]), _vm._v(" "), _vm._l((_vm.feedata), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('label', [_vm._v("【" + _vm._s(item.checkType) + "】" + _vm._s(item.checkContent))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content bg-purple-light"
    }, [_c('label', [_vm._v("检查结果:  " + _vm._s(item.checkResult == '1' ? '合格' : '不合格') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content"
    }, [_c('label', [_vm._v("检查备注:  " + _vm._s(item.checkDesc) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-container"
    }, _vm._l((item.picList), function(picurl) {
      return _c('div', {
        key: picurl,
        staticClass: "image-item"
      }, [_c('img', {
        attrs: {
          "src": _vm.picbaseurl + picurl,
          "alt": "Image"
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showBigImage(_vm.picbaseurl + picurl)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 2), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请复查资料"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadGjfcFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改完成日期",
      "prop": "correctTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.editForm.selCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "selCorrectTime", $$v)
      },
      expression: "editForm.selCorrectTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改措施",
      "prop": "correctContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.correctContent),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "correctContent", $$v)
      },
      expression: "editForm.correctContent"
    }
  })], 1), _vm._v("\n\t\t\t\t请提前准备好申请复查相关的资料，压缩成zip格式提交，上传文件成功后，完善其他信息后点击提交。\n      \t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCorrect.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 844:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerTypeName",
      "label": "岗位名称",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "riskLevelName",
      "label": "风险级别",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkContent",
      "label": "检查内容",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isClose",
      "label": "状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isClose === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("启用")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("禁用")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isClose == '0') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClose(scope.$index, scope.row)
            }
          }
        }, [_vm._v("禁用")]) : _vm._e(), _vm._v(" "), (scope.row.isClose == '1') ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen(scope.$index, scope.row)
            }
          }
        }, [_vm._v("启用")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

module.exports = {"type":"FeatureCollection","features":[{"type":"Feature","properties":{"adcode":360902,"name":"袁州区","center":[114.387379,27.800117],"centroid":[114.283623,27.833932],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":0,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.045395,28.053625],[114.045711,28.052892],[114.037258,28.051303],[114.034252,28.049589],[114.032986,28.04616],[114.029731,28.042311],[114.027561,28.041797],[114.027832,28.036218],[114.026838,28.031807],[114.019605,28.033459],[114.014994,28.036358],[114.01018,28.038072],[114.004845,28.038213],[114.000573,28.040441],[113.989249,28.038727],[113.976095,28.040987],[113.968839,28.041143],[113.96181,28.038852],[113.957945,28.034815],[113.956227,28.030607],[113.956973,28.02841],[113.964929,28.021256],[113.96633,28.019276],[113.965562,28.01686],[113.961923,28.015177],[113.957334,28.014241],[113.951164,28.013774],[113.944067,28.014195],[113.937489,28.018278],[113.935523,28.018918],[113.930663,28.015348],[113.929804,28.010921],[113.925284,28.004171],[113.921034,28.002659],[113.918435,28.000741],[113.91631,27.996501],[113.915813,27.993507],[113.921419,27.992915],[113.922323,27.99067],[113.922594,27.985072],[113.925781,27.984028],[113.933036,27.984948],[113.938077,27.988004],[113.942236,27.989812],[113.947027,27.989703],[113.951503,27.9883],[113.950305,27.979256],[113.951955,27.975389],[113.955526,27.971444],[113.961764,27.967405],[113.969811,27.966049],[113.975394,27.967764],[113.975846,27.971101],[113.974535,27.973627],[113.977134,27.975577],[113.981587,27.975078],[113.983667,27.97408],[113.986831,27.974579],[113.992143,27.972863],[113.996528,27.965877],[113.998178,27.960996],[114.001839,27.958001],[114.002969,27.95535],[114.000528,27.945945],[113.999036,27.942248],[113.997658,27.941078],[113.991442,27.94072],[113.984503,27.934605],[113.981474,27.929223],[113.976976,27.928365],[113.974332,27.925775],[113.974038,27.92381],[113.976569,27.922889],[113.976208,27.918583],[113.972297,27.918068],[113.968568,27.92033],[113.963437,27.918739],[113.959572,27.916773],[113.956295,27.913918],[113.955232,27.911234],[113.95478,27.906866],[113.952045,27.905727],[113.950079,27.902762],[113.947095,27.899984],[113.94158,27.899032],[113.940201,27.900421],[113.939569,27.903573],[113.942371,27.909081],[113.940676,27.91267],[113.938823,27.913356],[113.935568,27.911937],[113.922865,27.902481],[113.910524,27.892619],[113.90684,27.889045],[113.905687,27.882428],[113.902568,27.878651],[113.895267,27.874094],[113.891176,27.870988],[113.892645,27.868912],[113.897437,27.868662],[113.904647,27.867007],[113.910773,27.863979],[113.911518,27.861731],[113.910456,27.860077],[113.906749,27.857938],[113.906523,27.856596],[113.910999,27.849102],[113.910908,27.843232],[113.906704,27.841062],[113.901641,27.844403],[113.898025,27.845121],[113.896555,27.843263],[113.898477,27.837971],[113.899788,27.836628],[113.904218,27.834988],[113.903065,27.83288],[113.899855,27.831709],[113.900172,27.829961],[113.906184,27.832256],[113.914366,27.832646],[113.917599,27.829164],[113.920288,27.828305],[113.922142,27.829071],[113.924538,27.831897],[113.927747,27.833286],[113.930708,27.832974],[113.933805,27.830257],[113.936133,27.819061],[113.936653,27.81372],[113.933556,27.808879],[113.933669,27.806224],[113.936291,27.803835],[113.939388,27.802804],[113.942823,27.804834],[113.944338,27.810144],[113.950893,27.810066],[113.958306,27.814689],[113.961855,27.812877],[113.967144,27.808317],[113.967528,27.803647],[113.966036,27.800695],[113.962171,27.796181],[113.960137,27.79198],[113.959482,27.784701],[113.961855,27.779827],[113.966782,27.776624],[113.973541,27.775421],[113.97449,27.772844],[113.972252,27.765423],[113.973767,27.761095],[113.978739,27.760095],[113.984435,27.762157],[113.993793,27.757892],[113.996844,27.752923],[114.001003,27.752017],[114.00706,27.755001],[114.013163,27.757376],[114.016531,27.761767],[114.020396,27.761813],[114.028149,27.755392],[114.033054,27.755907],[114.037326,27.754235],[114.039744,27.751251],[114.040241,27.748954],[114.043654,27.743219],[114.047723,27.742469],[114.060765,27.745766],[114.062573,27.745907],[114.069693,27.743766],[114.081039,27.747657],[114.086215,27.750345],[114.092409,27.755032],[114.096319,27.756392],[114.106151,27.752251],[114.115622,27.756423],[114.116096,27.75847],[114.111824,27.761517],[114.111214,27.764282],[114.114582,27.769657],[114.1163,27.770891],[114.121227,27.770203],[114.12351,27.767766],[114.129093,27.768375],[114.129477,27.763813],[114.131579,27.761189],[114.139242,27.762829],[114.14227,27.761251],[114.149232,27.751767],[114.154476,27.751579],[114.157821,27.748704],[114.157798,27.746235],[114.160036,27.741578],[114.158748,27.739156],[114.154227,27.736171],[114.153255,27.732545],[114.15703,27.732858],[114.162884,27.737484],[114.167043,27.737328],[114.17344,27.735452],[114.178096,27.733124],[114.179339,27.729654],[114.176717,27.724762],[114.176672,27.722668],[114.181192,27.719542],[114.18777,27.711523],[114.190233,27.709475],[114.19489,27.699674],[114.192313,27.694499],[114.194664,27.690638],[114.200879,27.686666],[114.20271,27.683993],[114.202281,27.680381],[114.206033,27.677035],[114.212904,27.672047],[114.217086,27.665213],[114.216973,27.662351],[114.214554,27.655986],[114.205694,27.644819],[114.198958,27.64363],[114.195862,27.641378],[114.197941,27.639047],[114.206869,27.637452],[114.210576,27.633354],[114.213605,27.630913],[114.21313,27.6273],[114.217786,27.624077],[114.224341,27.617772],[114.225629,27.615723],[114.231077,27.611186],[114.232591,27.608401],[114.236479,27.604427],[114.239372,27.603347],[114.241587,27.599936],[114.245927,27.59665],[114.252323,27.594131],[114.25551,27.589749],[114.260912,27.588654],[114.265252,27.587136],[114.266518,27.583082],[114.270812,27.583114],[114.267919,27.57989],[114.273231,27.576587],[114.278543,27.578293],[114.279017,27.580109],[114.280351,27.577855],[114.283425,27.577761],[114.283967,27.578982],[114.299993,27.578168],[114.308762,27.575742],[114.315295,27.572033],[114.322505,27.566367],[114.333513,27.559558],[114.334778,27.557335],[114.337468,27.558353],[114.34834,27.564207],[114.352228,27.559903],[114.355302,27.559762],[114.358602,27.553297],[114.365111,27.546737],[114.367937,27.545501],[114.372796,27.546644],[114.375147,27.555723],[114.378899,27.557727],[114.381882,27.557555],[114.385137,27.555958],[114.386945,27.549446],[114.391489,27.549806],[114.402496,27.54979],[114.405638,27.550557],[114.411311,27.548929],[114.416962,27.548178],[114.421121,27.550776],[114.422274,27.555238],[114.424692,27.559151],[114.429484,27.561875],[114.434095,27.563268],[114.440966,27.564097],[114.446029,27.567322],[114.44951,27.568339],[114.453578,27.567197],[114.456404,27.562188],[114.46219,27.561859],[114.464586,27.557852],[114.467163,27.563331],[114.471932,27.564364],[114.47417,27.56776],[114.47921,27.57028],[114.483911,27.575742],[114.491303,27.579264],[114.493789,27.580938],[114.499824,27.580203],[114.502355,27.582441],[114.503757,27.585539],[114.503892,27.592284],[114.502807,27.595539],[114.505904,27.599545],[114.51759,27.607431],[114.520008,27.607712],[114.524642,27.606101],[114.529049,27.601579],[114.530925,27.601172],[114.532236,27.603269],[114.538542,27.608041],[114.538723,27.609981],[114.53644,27.613533],[114.535627,27.618555],[114.532281,27.619916],[114.528122,27.627237],[114.532214,27.63606],[114.533412,27.641096],[114.534609,27.642363],[114.541752,27.646852],[114.542882,27.649668],[114.542588,27.653656],[114.54087,27.659098],[114.541436,27.662586],[114.543922,27.665807],[114.544826,27.670889],[114.549098,27.674752],[114.550974,27.68024],[114.556625,27.689418],[114.557868,27.693952],[114.560218,27.696016],[114.565281,27.698611],[114.569576,27.699783],[114.571362,27.701456],[114.574142,27.706271],[114.57821,27.711664],[114.576764,27.717385],[114.579227,27.720198],[114.58264,27.721886],[114.584155,27.723652],[114.584381,27.729904],[114.583386,27.734468],[114.579408,27.738562],[114.578278,27.741594],[114.583205,27.75336],[114.582889,27.756001],[114.580606,27.761751],[114.577803,27.765563],[114.575543,27.767079],[114.575362,27.768954],[114.578233,27.774312],[114.575498,27.775234],[114.57039,27.773469],[114.567723,27.771734],[114.569418,27.768375],[114.569712,27.765438],[114.565417,27.762954],[114.562976,27.763392],[114.560196,27.766719],[114.559292,27.771047],[114.563292,27.773765],[114.567519,27.778421],[114.568265,27.780358],[114.567406,27.782998],[114.564942,27.784404],[114.566479,27.79023],[114.571678,27.794666],[114.575091,27.796494],[114.582821,27.801695],[114.584923,27.805349],[114.585127,27.808004],[114.583748,27.817437],[114.581962,27.825432],[114.581465,27.830007],[114.578323,27.833536],[114.573509,27.840297],[114.568853,27.843357],[114.563179,27.841811],[114.555268,27.834988],[114.55129,27.832912],[114.550793,27.830445],[114.551901,27.828493],[114.551471,27.825635],[114.549821,27.82398],[114.550228,27.821341],[114.548329,27.817671],[114.545775,27.816578],[114.539492,27.821419],[114.532146,27.824886],[114.52584,27.827259],[114.515849,27.826479],[114.513001,27.82779],[114.508277,27.832631],[114.505158,27.83669],[114.499281,27.849602],[114.496976,27.856049],[114.492794,27.863995],[114.490534,27.866898],[114.487799,27.876606],[114.485833,27.888109],[114.485584,27.895194],[114.487279,27.899438],[114.488477,27.908613],[114.492184,27.917319],[114.494557,27.919535],[114.498581,27.921282],[114.506876,27.923466],[114.509611,27.922686],[114.511622,27.920252],[114.514832,27.921079],[114.51664,27.9242],[114.521477,27.925182],[114.521952,27.923934],[114.520212,27.921438],[114.522833,27.919535],[114.525388,27.926103],[114.524755,27.928661],[114.520257,27.928646],[114.518426,27.932296],[114.520731,27.932889],[114.520754,27.934433],[114.516798,27.936321],[114.514561,27.939394],[114.513114,27.944822],[114.51386,27.947489],[114.515962,27.950172],[114.520483,27.954102],[114.523692,27.955116],[114.53262,27.955241],[114.539085,27.957034],[114.545029,27.957845],[114.549143,27.955256],[114.556399,27.958032],[114.559111,27.957346],[114.565982,27.95312],[114.570571,27.954149],[114.571271,27.958921],[114.573441,27.957549],[114.577238,27.957565],[114.581149,27.95992],[114.585579,27.963444],[114.591139,27.966158],[114.592744,27.968622],[114.592473,27.970852],[114.594642,27.972629],[114.59896,27.973752],[114.600293,27.975062],[114.599886,27.977978],[114.600768,27.980114],[114.603277,27.98172],[114.61112,27.984511],[114.61164,27.986413],[114.609086,27.988783],[114.60348,27.986024],[114.600361,27.985493],[114.598711,27.990701],[114.601559,27.992494],[114.602056,27.994193],[114.600519,27.996548],[114.59462,28.001942],[114.592518,28.006338],[114.59236,28.008567],[114.590303,28.014444],[114.591049,28.018123],[114.587206,28.021006],[114.584629,28.021801],[114.588585,28.026009],[114.587703,28.0312],[114.583432,28.03907],[114.582211,28.045194],[114.580448,28.046908],[114.57439,28.04789],[114.569689,28.052783],[114.567723,28.056149],[114.561281,28.051879],[114.55728,28.052144],[114.553505,28.055323],[114.551381,28.05618],[114.544148,28.052066],[114.533818,28.048981],[114.530179,28.046223],[114.529253,28.042903],[114.527648,28.041407],[114.523579,28.042296],[114.522065,28.041252],[114.518539,28.034317],[114.511216,28.032213],[114.508752,28.029454],[114.503779,28.029953],[114.496433,28.031511],[114.49519,28.034426],[114.491958,28.03653],[114.481764,28.039802],[114.479074,28.04133],[114.476249,28.040691],[114.460472,28.04161],[114.458551,28.0408],[114.448063,28.032337],[114.440514,28.027147],[114.438954,28.027475],[114.437395,28.03067],[114.435112,28.031698],[114.432535,28.03134],[114.430569,28.029672],[114.426907,28.029251],[114.419765,28.026352],[114.417708,28.026041],[114.412916,28.028254],[114.410588,28.028004],[114.406113,28.024248],[114.401615,28.028456],[114.398315,28.030373],[114.391692,28.027584],[114.387872,28.026976],[114.380843,28.027895],[114.373971,28.029329],[114.369903,28.029189],[114.366874,28.027895],[114.365541,28.025028],[114.356839,28.022315],[114.353674,28.023656],[114.351572,28.027023],[114.34504,28.026913],[114.343277,28.029516],[114.335095,28.032929],[114.332473,28.035844],[114.328269,28.037402],[114.323997,28.038041],[114.318821,28.037885],[114.310367,28.035641],[114.305779,28.035813],[114.297122,28.041174],[114.29007,28.037106],[114.28564,28.040628],[114.283832,28.040722],[114.282769,28.036078],[114.281232,28.035828],[114.277774,28.03974],[114.27348,28.041065],[114.270179,28.042498],[114.265523,28.042966],[114.256866,28.045537],[114.254177,28.044477],[114.253951,28.038758],[114.252052,28.0372],[114.244887,28.036171],[114.23944,28.034862],[114.234784,28.036327],[114.230082,28.03508],[114.220725,28.036452],[114.209875,28.03935],[114.205671,28.036233],[114.20097,28.029392],[114.198348,28.027319],[114.192629,28.026758],[114.191567,28.024809],[114.19611,28.019619],[114.1955,28.01739],[114.191838,28.010843],[114.187499,28.008411],[114.182164,28.007694],[114.174321,28.004888],[114.167337,28.004265],[114.160601,28.00085],[114.156374,28.000258],[114.143875,28.000102],[114.140372,27.998418],[114.140756,27.995706],[114.137546,27.994817],[114.13445,27.995706],[114.134314,27.997608],[114.132054,27.999026],[114.13063,27.994646],[114.125929,27.991262],[114.124798,27.993164],[114.120798,27.993757],[114.120956,28.001038],[114.124618,28.004218],[114.124753,28.007367],[114.11691,28.010656],[114.111711,28.013883],[114.099144,28.018918],[114.095957,28.021069],[114.094262,28.023843],[114.096093,28.028441],[114.104252,28.034363],[114.107688,28.039148],[114.113294,28.045599],[114.113633,28.048747],[114.111282,28.052783],[114.10866,28.054824],[114.106355,28.05847],[114.106581,28.062194],[114.105202,28.064064],[114.098218,28.065497],[114.094488,28.070094],[114.088046,28.075749],[114.083141,28.074393],[114.079389,28.075842],[114.076813,28.069969],[114.073784,28.067819],[114.070416,28.064235],[114.067862,28.060029],[114.062482,28.057754],[114.057691,28.057411],[114.048966,28.057769],[114.046774,28.056881],[114.045395,28.053625]]],[[[114.273027,28.052144],[114.275197,28.052799],[114.276192,28.056429],[114.275423,28.057894],[114.271829,28.058283],[114.260076,28.057208],[114.257974,28.058424],[114.255601,28.05805],[114.254561,28.059779],[114.252843,28.059265],[114.253205,28.05604],[114.251103,28.0547],[114.252775,28.053936],[114.257386,28.05512],[114.264258,28.055494],[114.267219,28.052549],[114.273027,28.052144]]]]}},{"type":"Feature","properties":{"adcode":360921,"name":"奉新县","center":[115.389899,28.700672],"centroid":[115.172488,28.709015],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":1,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[115.521402,28.597036],[115.523414,28.595595],[115.525154,28.59668],[115.52486,28.602183],[115.528251,28.602199],[115.524453,28.604446],[115.525877,28.608446],[115.529155,28.609515],[115.529968,28.61215],[115.532432,28.612848],[115.535099,28.610988],[115.537472,28.61153],[115.538716,28.614429],[115.54197,28.615948],[115.542603,28.617529],[115.547056,28.621202],[115.541722,28.6272],[115.542988,28.628394],[115.542016,28.631664],[115.547056,28.632346],[115.545632,28.635197],[115.541767,28.638188],[115.539778,28.642775],[115.543733,28.649314],[115.544163,28.658394],[115.546559,28.67195],[115.548209,28.676241],[115.553701,28.683676],[115.554492,28.686573],[115.554289,28.693682],[115.553159,28.696408],[115.549655,28.699583],[115.548548,28.705127],[115.546084,28.706784],[115.546084,28.708209],[115.55013,28.716122],[115.553927,28.718987],[115.554718,28.721821],[115.55664,28.724112],[115.557431,28.726838],[115.560188,28.728231],[115.559488,28.729423],[115.55352,28.731374],[115.550921,28.732922],[115.547779,28.733464],[115.540795,28.732628],[115.535596,28.733015],[115.532884,28.734486],[115.526646,28.739487],[115.521018,28.738666],[115.51817,28.73396],[115.514802,28.731777],[115.511728,28.731421],[115.505783,28.73221],[115.49794,28.734842],[115.494595,28.735276],[115.489057,28.73478],[115.483407,28.729021],[115.477033,28.73156],[115.474727,28.730228],[115.473394,28.724592],[115.468511,28.72261],[115.46598,28.72309],[115.463697,28.724902],[115.461663,28.728092],[115.460194,28.733294],[115.453164,28.732334],[115.446926,28.735043],[115.449118,28.737784],[115.44835,28.741747],[115.44575,28.745989],[115.441953,28.754983],[115.438698,28.759967],[115.444869,28.760602],[115.442383,28.766468],[115.440891,28.767257],[115.4401,28.771204],[115.442948,28.774175],[115.447107,28.771715],[115.45113,28.774005],[115.453187,28.773216],[115.453028,28.771126],[115.450949,28.768217],[115.451672,28.766267],[115.453729,28.766096],[115.457504,28.771993],[115.459696,28.774067],[115.461437,28.779205],[115.464149,28.783337],[115.458566,28.785178],[115.459855,28.787299],[115.466477,28.787453],[115.466861,28.789186],[115.465686,28.793194],[115.467946,28.79502],[115.477281,28.796846],[115.481621,28.797062],[115.484266,28.801751],[115.484785,28.804783],[115.482118,28.810879],[115.484898,28.818723],[115.48969,28.823069],[115.48734,28.829427],[115.491611,28.837455],[115.493759,28.844136],[115.491544,28.845915],[115.484107,28.847663],[115.482005,28.849611],[115.474908,28.851993],[115.471924,28.855024],[115.464081,28.858704],[115.461278,28.861287],[115.457911,28.858472],[115.4533,28.858318],[115.450972,28.85705],[115.451876,28.852302],[115.443513,28.850292],[115.440665,28.850756],[115.437794,28.852519],[115.43533,28.851946],[115.428753,28.853833],[115.428504,28.856199],[115.425363,28.85739],[115.420752,28.85722],[115.416661,28.859338],[115.411191,28.860127],[115.406309,28.862524],[115.404161,28.86138],[115.40163,28.856787],[115.401381,28.851745],[115.39833,28.849843],[115.398126,28.848482],[115.39998,28.843843],[115.405766,28.837888],[115.409156,28.835026],[115.411259,28.830386],[115.415824,28.825065],[115.420571,28.826736],[115.418808,28.824322],[115.419735,28.822311],[115.414536,28.81945],[115.409857,28.818521],[115.4111,28.816],[115.416887,28.811653],[115.4104,28.806083],[115.409111,28.803963],[115.409767,28.796923],[115.409337,28.793411],[115.406557,28.783956],[115.404545,28.783616],[115.398804,28.787206],[115.396205,28.786339],[115.393561,28.776946],[115.393651,28.773448],[115.391617,28.771606],[115.390871,28.766499],[115.388656,28.766158],[115.381355,28.770151],[115.376767,28.776265],[115.376518,28.777982],[115.373241,28.782037],[115.363996,28.781495],[115.354865,28.783585],[115.353418,28.786958],[115.351542,28.787825],[115.348626,28.785503],[115.34345,28.788985],[115.335878,28.792854],[115.331245,28.796165],[115.329075,28.801364],[115.329459,28.807444],[115.330544,28.810647],[115.327854,28.815799],[115.324735,28.817671],[115.324577,28.823131],[115.323582,28.825761],[115.324622,28.828406],[115.317118,28.833294],[115.30923,28.832119],[115.304212,28.830726],[115.297634,28.830402],[115.292187,28.82621],[115.289656,28.825684],[115.275936,28.832907],[115.267731,28.83283],[115.262849,28.83464],[115.259458,28.835042],[115.254147,28.834686],[115.251389,28.835924],[115.245671,28.836032],[115.241647,28.833959],[115.239703,28.834129],[115.236426,28.837269],[115.232674,28.837501],[115.227611,28.835351],[115.22126,28.83116],[115.217733,28.829613],[115.21579,28.832242],[115.212015,28.835506],[115.206093,28.836419],[115.19929,28.835429],[115.18731,28.837996],[115.178811,28.841755],[115.171398,28.842667],[115.168595,28.843982],[115.163442,28.85108],[115.162764,28.858411],[115.160797,28.858689],[115.155824,28.854452],[115.151598,28.854792],[115.145043,28.852194],[115.139121,28.854699],[115.135098,28.854684],[115.12791,28.850369],[115.123435,28.849441],[115.107477,28.842064],[115.100696,28.841229],[115.094028,28.839079],[115.088626,28.835398],[115.085846,28.832737],[115.081009,28.826194],[115.079382,28.825606],[115.076443,28.827246],[115.074341,28.827292],[115.07459,28.820997],[115.073437,28.81699],[115.07129,28.815876],[115.061254,28.815242],[115.057095,28.811668],[115.052552,28.81043],[115.048371,28.811668],[115.046156,28.811482],[115.040234,28.806222],[115.033476,28.804288],[115.023824,28.8037],[115.021677,28.80237],[115.015958,28.80107],[115.012274,28.801333],[115.005403,28.798981],[114.996339,28.806826],[114.99331,28.808636],[114.98723,28.811049],[114.983478,28.807878],[114.979613,28.807723],[114.968967,28.811823],[114.964967,28.814963],[114.963972,28.817191],[114.960943,28.819233],[114.955202,28.821708],[114.949077,28.822234],[114.934159,28.822946],[114.926361,28.820084],[114.915308,28.816866],[114.91124,28.816402],[114.914608,28.814221],[114.918382,28.805186],[114.917184,28.800946],[114.911443,28.794324],[114.900775,28.784761],[114.898017,28.780737],[114.896073,28.774918],[114.896367,28.772566],[114.892208,28.769764],[114.888592,28.770275],[114.885156,28.769795],[114.8805,28.773866],[114.877991,28.77433],[114.87659,28.770058],[114.872838,28.770306],[114.869922,28.76817],[114.869741,28.764146],[114.872589,28.761824],[114.873719,28.75828],[114.87121,28.752521],[114.866486,28.755772],[114.863051,28.75441],[114.859773,28.754503],[114.856044,28.750973],[114.855524,28.746608],[114.85028,28.745401],[114.848178,28.74424],[114.843544,28.743961],[114.84212,28.741855],[114.840086,28.741283],[114.836673,28.745524],[114.834187,28.746995],[114.832695,28.749998],[114.828875,28.753559],[114.827519,28.756794],[114.827293,28.759828],[114.824513,28.762242],[114.822524,28.76588],[114.818026,28.769114],[114.813799,28.770074],[114.810567,28.767938],[114.807312,28.762474],[114.803447,28.758218],[114.796598,28.755261],[114.795898,28.753435],[114.797209,28.750633],[114.801481,28.744224],[114.803899,28.735585],[114.803492,28.729857],[114.799107,28.725707],[114.791535,28.72419],[114.788484,28.722967],[114.780098,28.717144],[114.774945,28.713103],[114.769814,28.712096],[114.764276,28.71414],[114.762604,28.71366],[114.759982,28.709742],[114.756433,28.705716],[114.747143,28.700388],[114.741741,28.699893],[114.741719,28.695076],[114.743572,28.688664],[114.746533,28.684435],[114.751822,28.67937],[114.753676,28.675528],[114.754263,28.671702],[114.762672,28.659308],[114.757496,28.653606],[114.757902,28.650399],[114.771645,28.645301],[114.779963,28.641024],[114.782313,28.638064],[114.785772,28.636018],[114.792959,28.634717],[114.794112,28.629742],[114.795807,28.627448],[114.799446,28.624535],[114.800916,28.61756],[114.804668,28.616351],[114.808826,28.613964],[114.812262,28.614134],[114.812827,28.607035],[114.813867,28.605098],[114.817822,28.603098],[114.820557,28.603098],[114.827338,28.607299],[114.832582,28.608275],[114.837238,28.609841],[114.84029,28.608818],[114.847432,28.603904],[114.860768,28.604849],[114.865288,28.606183],[114.868792,28.609562],[114.870645,28.614894],[114.874194,28.617203],[114.87729,28.62207],[114.879935,28.623791],[114.889925,28.623713],[114.896864,28.62269],[114.904685,28.618536],[114.907149,28.618552],[114.921863,28.623822],[114.923762,28.625139],[114.925366,28.628874],[114.937436,28.631958],[114.940103,28.630765],[114.94155,28.626766],[114.943584,28.625108],[114.948399,28.624674],[114.95197,28.625557],[114.954253,28.625],[114.958163,28.622551],[114.961101,28.619699],[114.96248,28.617188],[114.962887,28.613576],[114.966029,28.612507],[114.9696,28.613204],[114.974934,28.612894],[114.977624,28.610445],[114.980879,28.609035],[114.983885,28.609732],[114.986281,28.61353],[114.987954,28.614739],[114.992452,28.615622],[114.999571,28.614692],[115.004838,28.611747],[115.006556,28.606663],[115.006149,28.595936],[115.008771,28.590169],[115.012952,28.588013],[115.021948,28.585657],[115.02509,28.583207],[115.028141,28.583657],[115.034583,28.582726],[115.041997,28.583982],[115.045274,28.580277],[115.052123,28.57975],[115.055536,28.583905],[115.062339,28.591037],[115.066679,28.592153],[115.0686,28.59823],[115.065526,28.600338],[115.068126,28.602586],[115.072398,28.604911],[115.076489,28.60516],[115.079856,28.608151],[115.084739,28.606338],[115.089689,28.606477],[115.092785,28.60826],[115.096334,28.612755],[115.098956,28.619807],[115.103228,28.621946],[115.108246,28.620024],[115.11367,28.625821],[115.113128,28.62937],[115.1181,28.63357],[115.117965,28.635523],[115.126599,28.632501],[115.130261,28.628626],[115.133244,28.62782],[115.141426,28.627092],[115.147235,28.627975],[115.153316,28.630904],[115.16317,28.63154],[115.170539,28.634546],[115.178382,28.636204],[115.184733,28.636452],[115.191333,28.638343],[115.198905,28.6367],[115.203403,28.63481],[115.207924,28.635848],[115.218751,28.636049],[115.222254,28.633585],[115.226797,28.63216],[115.232968,28.632981],[115.238234,28.630067],[115.242393,28.629386],[115.248428,28.627107],[115.250146,28.624302],[115.251005,28.616103],[115.254599,28.61153],[115.252519,28.60781],[115.253581,28.604539],[115.257108,28.600881],[115.266646,28.597641],[115.270421,28.599083],[115.276795,28.596866],[115.285406,28.600742],[115.289588,28.59978],[115.291532,28.596525],[115.294018,28.596013],[115.296662,28.599346],[115.296143,28.603764],[115.297363,28.608244],[115.30055,28.609453],[115.30211,28.607686],[115.304958,28.609918],[115.307376,28.610399],[115.310427,28.608337],[115.313614,28.603082],[115.317028,28.599935],[115.318271,28.594913],[115.320441,28.59068],[115.323108,28.588277],[115.326114,28.581254],[115.33016,28.575532],[115.33129,28.569624],[115.336511,28.567019],[115.336308,28.564445],[115.341778,28.563669],[115.352559,28.5724],[115.356266,28.57288],[115.363521,28.575827],[115.372359,28.578323],[115.382033,28.583734],[115.383977,28.585858],[115.383254,28.587409],[115.379999,28.589796],[115.376541,28.596726],[115.376676,28.5993],[115.384203,28.60099],[115.385876,28.602416],[115.390487,28.603873],[115.396589,28.601641],[115.39894,28.603547],[115.404839,28.603377],[115.40667,28.600462],[115.412502,28.596742],[115.413564,28.591641],[115.416231,28.59068],[115.418288,28.593827],[115.420051,28.593378],[115.420074,28.584773],[115.416638,28.57561],[115.416661,28.570679],[115.418424,28.569423],[115.420435,28.564491],[115.425815,28.564336],[115.430742,28.563189],[115.432686,28.564553],[115.436302,28.569438],[115.438947,28.569267],[115.442315,28.576307],[115.444824,28.580029],[115.450203,28.580478],[115.455447,28.57916],[115.456035,28.582416],[115.460962,28.579377],[115.46485,28.57961],[115.466251,28.581378],[115.465799,28.583223],[115.468715,28.589006],[115.476016,28.594153],[115.477552,28.596385],[115.480468,28.603532],[115.482322,28.604105],[115.488673,28.601796],[115.49464,28.603346],[115.498573,28.608663],[115.502642,28.611065],[115.507818,28.61122],[115.509716,28.610182],[115.509129,28.604756],[115.512745,28.603377],[115.515503,28.599563],[115.516316,28.596773],[115.521402,28.597036]]]]}},{"type":"Feature","properties":{"adcode":360922,"name":"万载县","center":[114.449012,28.104528],"centroid":[114.329814,28.203587],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":2,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.045395,28.053625],[114.046774,28.056881],[114.048966,28.057769],[114.057691,28.057411],[114.062482,28.057754],[114.067862,28.060029],[114.070416,28.064235],[114.073784,28.067819],[114.076813,28.069969],[114.079389,28.075842],[114.083141,28.074393],[114.088046,28.075749],[114.094488,28.070094],[114.098218,28.065497],[114.105202,28.064064],[114.106581,28.062194],[114.106355,28.05847],[114.10866,28.054824],[114.111282,28.052783],[114.113633,28.048747],[114.113294,28.045599],[114.107688,28.039148],[114.104252,28.034363],[114.096093,28.028441],[114.094262,28.023843],[114.095957,28.021069],[114.099144,28.018918],[114.111711,28.013883],[114.11691,28.010656],[114.124753,28.007367],[114.124618,28.004218],[114.120956,28.001038],[114.120798,27.993757],[114.124798,27.993164],[114.125929,27.991262],[114.13063,27.994646],[114.132054,27.999026],[114.134314,27.997608],[114.13445,27.995706],[114.137546,27.994817],[114.140756,27.995706],[114.140372,27.998418],[114.143875,28.000102],[114.156374,28.000258],[114.160601,28.00085],[114.167337,28.004265],[114.174321,28.004888],[114.182164,28.007694],[114.187499,28.008411],[114.191838,28.010843],[114.1955,28.01739],[114.19611,28.019619],[114.191567,28.024809],[114.192629,28.026758],[114.198348,28.027319],[114.20097,28.029392],[114.205671,28.036233],[114.209875,28.03935],[114.220725,28.036452],[114.230082,28.03508],[114.234784,28.036327],[114.23944,28.034862],[114.244887,28.036171],[114.252052,28.0372],[114.253951,28.038758],[114.254177,28.044477],[114.256866,28.045537],[114.257386,28.05512],[114.252775,28.053936],[114.251103,28.0547],[114.253205,28.05604],[114.252843,28.059265],[114.254561,28.059779],[114.255601,28.05805],[114.257974,28.058424],[114.260076,28.057208],[114.271829,28.058283],[114.275423,28.057894],[114.276192,28.056429],[114.275197,28.052799],[114.273027,28.052144],[114.27348,28.041065],[114.277774,28.03974],[114.281232,28.035828],[114.282769,28.036078],[114.283832,28.040722],[114.28564,28.040628],[114.29007,28.037106],[114.297122,28.041174],[114.305779,28.035813],[114.310367,28.035641],[114.318821,28.037885],[114.323997,28.038041],[114.328269,28.037402],[114.332473,28.035844],[114.335095,28.032929],[114.343277,28.029516],[114.34504,28.026913],[114.351572,28.027023],[114.353674,28.023656],[114.356839,28.022315],[114.365541,28.025028],[114.366874,28.027895],[114.369903,28.029189],[114.373971,28.029329],[114.380843,28.027895],[114.387872,28.026976],[114.391692,28.027584],[114.398315,28.030373],[114.401615,28.028456],[114.406113,28.024248],[114.410588,28.028004],[114.412916,28.028254],[114.417708,28.026041],[114.419765,28.026352],[114.426907,28.029251],[114.430569,28.029672],[114.432535,28.03134],[114.435112,28.031698],[114.437395,28.03067],[114.438954,28.027475],[114.440514,28.027147],[114.448063,28.032337],[114.458551,28.0408],[114.460472,28.04161],[114.476249,28.040691],[114.479074,28.04133],[114.480024,28.042763],[114.478329,28.046534],[114.482397,28.050679],[114.482849,28.052503],[114.482284,28.059374],[114.486805,28.063114],[114.492026,28.062958],[114.504322,28.068832],[114.511103,28.075157],[114.512007,28.080158],[114.51438,28.080313],[114.516844,28.083149],[114.515668,28.085828],[114.516324,28.08857],[114.519059,28.090096],[114.526179,28.096031],[114.527196,28.099006],[114.529614,28.102463],[114.530315,28.104862],[114.526879,28.108008],[114.524845,28.111839],[114.524235,28.114814],[114.526405,28.118427],[114.525184,28.124998],[114.525207,28.131647],[114.528529,28.13417],[114.526111,28.138918],[114.526608,28.140818],[114.529501,28.141845],[114.530586,28.144087],[114.529863,28.14608],[114.531445,28.149754],[114.531558,28.158348],[114.533457,28.164356],[114.531445,28.166816],[114.530857,28.169244],[114.531536,28.173727],[114.537887,28.177135],[114.544148,28.175408],[114.547335,28.175999],[114.545662,28.180279],[114.540418,28.184046],[114.541209,28.187843],[114.547109,28.191251],[114.547583,28.19357],[114.54304,28.200572],[114.54512,28.205241],[114.547787,28.207232],[114.551968,28.206563],[114.553867,28.208601],[114.552692,28.214825],[114.548352,28.219524],[114.550838,28.224253],[114.558342,28.224362],[114.56214,28.223444],[114.562953,28.226898],[114.56553,28.228516],[114.565824,28.231021],[114.56831,28.231829],[114.570073,28.238238],[114.574074,28.23757],[114.580064,28.238658],[114.583409,28.237756],[114.589105,28.241412],[114.592879,28.245285],[114.601423,28.247307],[114.607639,28.250231],[114.605966,28.251848],[114.608927,28.256856],[114.6073,28.259998],[114.605695,28.266405],[114.602486,28.270791],[114.602915,28.275953],[114.601401,28.278519],[114.597626,28.282624],[114.599389,28.289496],[114.603345,28.289823],[114.605966,28.293772],[114.606419,28.300535],[114.604316,28.306256],[114.599186,28.308168],[114.596767,28.312334],[114.591591,28.314432],[114.590777,28.316204],[114.593219,28.320106],[114.591975,28.322157],[114.587636,28.32466],[114.581465,28.3248],[114.577645,28.326913],[114.574842,28.331187],[114.568672,28.33557],[114.565055,28.342657],[114.559744,28.345671],[114.554703,28.345702],[114.547696,28.349867],[114.539333,28.356362],[114.537638,28.357154],[114.534293,28.35543],[114.529004,28.356673],[114.527083,28.361427],[114.523625,28.367471],[114.517183,28.373188],[114.510334,28.374245],[114.50891,28.375783],[114.508413,28.379402],[114.509724,28.386781],[114.508119,28.388008],[114.501519,28.386533],[114.494761,28.38588],[114.489766,28.388381],[114.488409,28.38981],[114.484974,28.396613],[114.481809,28.399922],[114.477763,28.403059],[114.472068,28.404581],[114.46601,28.404612],[114.462371,28.406088],[114.460133,28.410094],[114.456246,28.413278],[114.449194,28.414909],[114.447091,28.418154],[114.445306,28.423822],[114.444063,28.425406],[114.440491,28.427285],[114.427857,28.430189],[114.426026,28.430934],[114.423811,28.434179],[114.423155,28.440762],[114.422093,28.444923],[114.423788,28.450388],[114.42311,28.453182],[114.413481,28.459531],[114.40765,28.458351],[114.403106,28.4518],[114.398224,28.447112],[114.394291,28.445715],[114.388776,28.445202],[114.385341,28.440607],[114.383352,28.436058],[114.377882,28.432921],[114.359054,28.427906],[114.352363,28.428915],[114.347255,28.426648],[114.34504,28.426571],[114.338982,28.42904],[114.335298,28.428931],[114.329941,28.426027],[114.323748,28.421322],[114.317419,28.417952],[114.306683,28.415266],[114.303971,28.413356],[114.303496,28.411523],[114.304807,28.408262],[114.308423,28.404348],[114.308514,28.40149],[114.30544,28.396986],[114.307768,28.391923],[114.306118,28.387434],[114.30336,28.386269],[114.298365,28.385818],[114.294048,28.384234],[114.276712,28.379449],[114.271016,28.380148],[114.265388,28.379402],[114.259466,28.376668],[114.258064,28.372924],[114.250628,28.368124],[114.24986,28.365995],[114.251577,28.362453],[114.256211,28.359687],[114.260121,28.355709],[114.261274,28.352229],[114.259737,28.3501],[114.255646,28.350644],[114.253725,28.349758],[114.252188,28.346728],[114.248503,28.342392],[114.247125,28.338088],[114.253024,28.329447],[114.25551,28.326587],[114.255669,28.323618],[114.254086,28.320914],[114.250628,28.318194],[114.242581,28.314759],[114.23996,28.311929],[114.235123,28.310919],[114.232975,28.307188],[114.229042,28.305385],[114.228568,28.302571],[114.22477,28.300317],[114.219007,28.295855],[114.215662,28.294005],[114.21044,28.29472],[114.208112,28.29413],[114.202032,28.291113],[114.199953,28.291891],[114.198144,28.29074],[114.196155,28.284428],[114.196449,28.281971],[114.198393,28.280152],[114.197851,28.276824],[114.199139,28.27247],[114.198393,28.26978],[114.196268,28.268287],[114.188674,28.266856],[114.184673,28.267634],[114.183317,28.261382],[114.183701,28.25681],[114.182119,28.252782],[114.182142,28.250044],[114.180537,28.249795],[114.173666,28.252735],[114.170705,28.253513],[114.165868,28.253015],[114.15599,28.248909],[114.152103,28.249547],[114.148757,28.249235],[114.145028,28.247789],[114.143966,28.245207],[114.144892,28.242003],[114.143785,28.238161],[114.13732,28.232389],[114.129635,28.228158],[114.128663,28.223382],[114.126245,28.220224],[114.122922,28.21733],[114.121227,28.213129],[114.117181,28.210702],[114.111621,28.205956],[114.109451,28.204914],[114.106626,28.201631],[114.106287,28.19967],[114.107937,28.195048],[114.106671,28.189026],[114.107801,28.185898],[114.107259,28.182972],[114.105315,28.181524],[114.100613,28.180964],[114.095505,28.181493],[114.092024,28.180139],[114.083774,28.179205],[114.080407,28.175283],[114.068676,28.171657],[114.060335,28.170987],[114.053464,28.171081],[114.048017,28.176684],[114.043406,28.173991],[114.04101,28.1734],[114.031811,28.173976],[114.02729,28.172092],[114.02503,28.17217],[114.01235,28.175096],[114.007354,28.166567],[114.000212,28.164434],[113.995623,28.164792],[113.99264,28.16143],[113.994674,28.154876],[113.999895,28.147232],[114.005976,28.14485],[114.006721,28.140475],[114.008213,28.137579],[114.007264,28.131943],[114.007196,28.125434],[114.009208,28.123752],[114.013434,28.123986],[114.017074,28.120171],[114.015672,28.117508],[114.017345,28.102775],[114.018339,28.100485],[114.022476,28.099084],[114.024352,28.093694],[114.027019,28.092386],[114.028262,28.08776],[114.028352,28.084223],[114.023221,28.08603],[114.022453,28.0848],[114.019085,28.085439],[114.02182,28.082525],[114.025346,28.080516],[114.028239,28.081575],[114.029234,28.080064],[114.036308,28.078148],[114.037868,28.076154],[114.037439,28.072617],[114.041236,28.068567],[114.042954,28.067741],[114.044626,28.062849],[114.047113,28.057582],[114.04553,28.056741],[114.045395,28.053625]]],[[[114.27348,28.041065],[114.273027,28.052144],[114.267219,28.052549],[114.264258,28.055494],[114.257386,28.05512],[114.256866,28.045537],[114.265523,28.042966],[114.270179,28.042498],[114.27348,28.041065]]]]}},{"type":"Feature","properties":{"adcode":360923,"name":"上高县","center":[114.932653,28.234789],"centroid":[114.854614,28.192959],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":3,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[115.089417,28.420608],[115.081755,28.418403],[115.077732,28.419428],[115.073889,28.423481],[115.068126,28.422828],[115.064984,28.424319],[115.063176,28.427689],[115.060893,28.428931],[115.057322,28.428403],[115.052598,28.424195],[115.051513,28.419723],[115.045342,28.417347],[115.042675,28.415514],[115.041906,28.411539],[115.042562,28.408122],[115.041206,28.406041],[115.036097,28.401661],[115.031102,28.399067],[115.031238,28.392824],[115.023395,28.38981],[115.021903,28.3831],[115.020366,28.379993],[115.021564,28.37468],[115.020592,28.371681],[115.017405,28.369553],[115.009743,28.369615],[115.007143,28.370578],[115.003097,28.37353],[115.00321,28.375829],[115.001131,28.375938],[114.992316,28.37033],[114.989129,28.369677],[114.985671,28.370811],[114.982122,28.365917],[114.977647,28.364799],[114.97446,28.362328],[114.969713,28.363509],[114.968289,28.362872],[114.964876,28.355166],[114.965238,28.349851],[114.962571,28.346697],[114.949597,28.346402],[114.943743,28.350318],[114.941618,28.349043],[114.939403,28.345827],[114.935583,28.34707],[114.930836,28.347054],[114.928621,28.349572],[114.922948,28.343698],[114.919897,28.343169],[114.918201,28.350271],[114.912347,28.349976],[114.906923,28.347148],[114.905838,28.344848],[114.90082,28.338538],[114.90082,28.337093],[114.904346,28.330239],[114.906471,28.321302],[114.903171,28.318256],[114.897475,28.318753],[114.89257,28.316733],[114.88997,28.319546],[114.887688,28.319701],[114.884614,28.316158],[114.884116,28.312707],[114.881743,28.30823],[114.874488,28.3068],[114.869312,28.309862],[114.864,28.311012],[114.857287,28.310297],[114.855818,28.308976],[114.851478,28.308572],[114.845488,28.306442],[114.846618,28.302556],[114.843092,28.297286],[114.846392,28.292761],[114.847319,28.287615],[114.848766,28.284397],[114.848268,28.279934],[114.839069,28.277835],[114.836718,28.277695],[114.832446,28.272719],[114.829711,28.270853],[114.825417,28.269935],[114.820851,28.270573],[114.814342,28.268209],[114.810409,28.26527],[114.808894,28.262564],[114.809437,28.25793],[114.810816,28.253233],[114.808691,28.250837],[114.808713,28.247105],[114.806973,28.245845],[114.802091,28.244569],[114.798859,28.241178],[114.798045,28.238083],[114.799492,28.233401],[114.797955,28.228749],[114.792937,28.227769],[114.792168,28.226509],[114.792326,28.221297],[114.790767,28.220831],[114.788055,28.223911],[114.785907,28.224891],[114.784189,28.222122],[114.784257,28.218404],[114.779217,28.219197],[114.777544,28.217641],[114.778607,28.213114],[114.775329,28.210189],[114.768164,28.208679],[114.766017,28.209473],[114.760886,28.214265],[114.752613,28.213083],[114.747279,28.209971],[114.73869,28.207341],[114.734735,28.208882],[114.730237,28.214172],[114.730915,28.218015],[114.726032,28.223086],[114.726168,28.230352],[114.725693,28.234194],[114.720653,28.236107],[114.719455,28.238161],[114.720088,28.242407],[114.714098,28.246825],[114.709668,28.245191],[114.703791,28.247369],[114.699813,28.247929],[114.689981,28.251102],[114.686297,28.250775],[114.680827,28.248364],[114.674385,28.244771],[114.670656,28.245331],[114.666406,28.246996],[114.661366,28.247385],[114.648279,28.245331],[114.644482,28.243154],[114.64421,28.239903],[114.642108,28.236061],[114.639193,28.236045],[114.634966,28.238021],[114.633406,28.237943],[114.621088,28.22934],[114.61772,28.232576],[114.612951,28.238161],[114.60904,28.241567],[114.608543,28.248209],[114.607639,28.250231],[114.601423,28.247307],[114.592879,28.245285],[114.589105,28.241412],[114.583409,28.237756],[114.580064,28.238658],[114.574074,28.23757],[114.570073,28.238238],[114.56831,28.231829],[114.565824,28.231021],[114.56553,28.228516],[114.562953,28.226898],[114.56214,28.223444],[114.558342,28.224362],[114.550838,28.224253],[114.548352,28.219524],[114.552692,28.214825],[114.553867,28.208601],[114.551968,28.206563],[114.547787,28.207232],[114.54512,28.205241],[114.54304,28.200572],[114.547583,28.19357],[114.547109,28.191251],[114.541209,28.187843],[114.540418,28.184046],[114.545662,28.180279],[114.547335,28.175999],[114.544148,28.175408],[114.537887,28.177135],[114.531536,28.173727],[114.530857,28.169244],[114.531445,28.166816],[114.533457,28.164356],[114.531558,28.158348],[114.531445,28.149754],[114.529863,28.14608],[114.530586,28.144087],[114.529501,28.141845],[114.526608,28.140818],[114.526111,28.138918],[114.528529,28.13417],[114.525207,28.131647],[114.525184,28.124998],[114.526405,28.118427],[114.524235,28.114814],[114.524845,28.111839],[114.526879,28.108008],[114.530315,28.104862],[114.529614,28.102463],[114.527196,28.099006],[114.526179,28.096031],[114.519059,28.090096],[114.516324,28.08857],[114.515668,28.085828],[114.516844,28.083149],[114.51438,28.080313],[114.512007,28.080158],[114.511103,28.075157],[114.504322,28.068832],[114.492026,28.062958],[114.486805,28.063114],[114.482284,28.059374],[114.482849,28.052503],[114.482397,28.050679],[114.478329,28.046534],[114.480024,28.042763],[114.479074,28.04133],[114.481764,28.039802],[114.491958,28.03653],[114.49519,28.034426],[114.496433,28.031511],[114.503779,28.029953],[114.508752,28.029454],[114.511216,28.032213],[114.518539,28.034317],[114.522065,28.041252],[114.523579,28.042296],[114.527648,28.041407],[114.529253,28.042903],[114.530179,28.046223],[114.533818,28.048981],[114.544148,28.052066],[114.551381,28.05618],[114.553505,28.055323],[114.55728,28.052144],[114.561281,28.051879],[114.567723,28.056149],[114.570435,28.057769],[114.575091,28.062257],[114.580538,28.064126],[114.585262,28.070281],[114.587681,28.072368],[114.592021,28.071714],[114.593151,28.075313],[114.588698,28.075531],[114.587455,28.077525],[114.588901,28.079815],[114.594936,28.081809],[114.600203,28.079145],[114.606396,28.079768],[114.615392,28.07807],[114.620794,28.079815],[114.627032,28.083195],[114.629338,28.086249],[114.632886,28.087012],[114.63648,28.089161],[114.638695,28.093819],[114.644617,28.096965],[114.654969,28.096763],[114.660462,28.098694],[114.666949,28.10413],[114.672012,28.104239],[114.674272,28.102946],[114.679629,28.105391],[114.682997,28.10318],[114.68485,28.10033],[114.686545,28.099551],[114.691292,28.101934],[114.693824,28.101326],[114.701328,28.094053],[114.703271,28.09385],[114.706684,28.096],[114.712493,28.097183],[114.716946,28.098756],[114.718913,28.102557],[114.720856,28.103211],[114.729739,28.100112],[114.734124,28.10209],[114.737447,28.106186],[114.740928,28.10765],[114.744612,28.106918],[114.746443,28.105096],[114.748432,28.105049],[114.751212,28.107136],[114.759891,28.101576],[114.761451,28.1017],[114.764593,28.104582],[114.769498,28.106092],[114.772798,28.103304],[114.775329,28.10304],[114.778787,28.104317],[114.782698,28.107603],[114.784257,28.107089],[114.78532,28.103367],[114.784777,28.099816],[114.778787,28.096296],[114.77664,28.091654],[114.778335,28.088118],[114.785071,28.084753],[114.787535,28.085127],[114.789117,28.080376],[114.786947,28.077213],[114.784958,28.066557],[114.783127,28.062942],[114.777725,28.06154],[114.775352,28.059187],[114.775962,28.055229],[114.775397,28.051272],[114.776278,28.048981],[114.779805,28.044836],[114.785659,28.045257],[114.787557,28.038743],[114.791332,28.034472],[114.791671,28.032976],[114.796259,28.030077],[114.804781,28.031496],[114.814794,28.034052],[114.81563,28.036171],[114.821326,28.040254],[114.82449,28.045709],[114.828174,28.046815],[114.833464,28.045225],[114.841646,28.044228],[114.846347,28.046067],[114.852744,28.043916],[114.854778,28.044213],[114.861649,28.047734],[114.865808,28.045568],[114.873131,28.047999],[114.879212,28.045911],[114.878714,28.042981],[114.881268,28.038415],[114.880997,28.0312],[114.882783,28.022269],[114.887213,28.026134],[114.889722,28.026945],[114.894875,28.026804],[114.900029,28.027849],[114.903758,28.031418],[114.90534,28.034924],[114.90846,28.032135],[114.909409,28.026913],[114.912189,28.025105],[114.913545,28.026945],[114.913251,28.031807],[114.913749,28.035641],[114.915014,28.038633],[114.910584,28.042903],[114.916031,28.049916],[114.918586,28.054856],[114.920891,28.057894],[114.923852,28.059296],[114.932893,28.060371],[114.938499,28.062631],[114.947608,28.064703],[114.950388,28.06609],[114.953575,28.076076],[114.957282,28.081201],[114.959858,28.083445],[114.963113,28.090517],[114.967317,28.091685],[114.97116,28.09114],[114.973284,28.092246],[114.979952,28.093834],[114.9828,28.093056],[114.98549,28.088149],[114.99096,28.083787],[114.991457,28.076512],[114.995232,28.073739],[115.001967,28.073443],[115.007595,28.074518],[115.01241,28.074721],[115.013495,28.076279],[115.013404,28.079425],[115.018264,28.081528],[115.024028,28.081731],[115.027802,28.080843],[115.031554,28.077836],[115.034244,28.074082],[115.038132,28.073038],[115.045139,28.074082],[115.047512,28.075297],[115.051603,28.080796],[115.052643,28.085174],[115.047489,28.089566],[115.04498,28.090003],[115.0389,28.088071],[115.036934,28.090236],[115.036143,28.094302],[115.036437,28.100719],[115.038109,28.102448],[115.035035,28.105968],[115.03508,28.108615],[115.039601,28.111901],[115.040754,28.116028],[115.045206,28.118395],[115.044867,28.122647],[115.050563,28.123363],[115.05644,28.1226],[115.05748,28.124889],[115.05653,28.131709],[115.057163,28.133484],[115.062091,28.133967],[115.068442,28.132628],[115.070182,28.136303],[115.064848,28.141487],[115.06973,28.148089],[115.076556,28.154829],[115.077574,28.159251],[115.074997,28.166971],[115.073822,28.169135],[115.073754,28.172404],[115.0778,28.179859],[115.078365,28.181882],[115.076963,28.18845],[115.078704,28.190815],[115.093486,28.196604],[115.093328,28.202891],[115.098933,28.207855],[115.101171,28.212211],[115.100945,28.216677],[115.099521,28.220395],[115.097961,28.221764],[115.087654,28.222853],[115.082524,28.22696],[115.081393,28.230616],[115.082614,28.234007],[115.081959,28.236512],[115.074816,28.239918],[115.075404,28.247011],[115.078026,28.250869],[115.082162,28.251366],[115.087903,28.251164],[115.101985,28.256779],[115.106234,28.258769],[115.110461,28.259687],[115.118869,28.254057],[115.123502,28.255021],[115.131798,28.260309],[115.135392,28.259547],[115.139347,28.255472],[115.145721,28.253839],[115.161792,28.259703],[115.165521,28.263917],[115.166312,28.272159],[115.166109,28.277244],[115.167668,28.283666],[115.166968,28.285532],[115.157429,28.287771],[115.154649,28.290569],[115.152434,28.291315],[115.147665,28.290616],[115.143212,28.28861],[115.138352,28.290491],[115.132205,28.294083],[115.131662,28.300612],[115.128972,28.306955],[115.126689,28.308836],[115.121197,28.310779],[115.111274,28.315893],[115.106912,28.319841],[115.101826,28.326463],[115.088785,28.329229],[115.086208,28.330302],[115.084829,28.333146],[115.081461,28.334575],[115.080648,28.336736],[115.082388,28.339735],[115.07893,28.346588],[115.083812,28.355368],[115.085349,28.35675],[115.085982,28.360821],[115.087587,28.362437],[115.085349,28.369755],[115.085191,28.374959],[115.082795,28.384684],[115.080241,28.390696],[115.083292,28.393165],[115.083857,28.396613],[115.083021,28.405715],[115.083337,28.408417],[115.089417,28.420608]]]]}},{"type":"Feature","properties":{"adcode":360924,"name":"宜丰县","center":[114.787381,28.388289],"centroid":[114.767853,28.448926],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":4,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.741719,28.695076],[114.740001,28.6917],[114.738125,28.691142],[114.738509,28.689392],[114.737085,28.687022],[114.734192,28.68253],[114.727547,28.674878],[114.726145,28.672244],[114.729106,28.666636],[114.73148,28.660578],[114.732723,28.658982],[114.730779,28.655713],[114.729265,28.649221],[114.723411,28.64764],[114.71403,28.643116],[114.711815,28.634856],[114.709555,28.631183],[114.70847,28.627448],[114.707928,28.619311],[114.70291,28.611251],[114.699813,28.60826],[114.698728,28.605904],[114.699158,28.598695],[114.698389,28.596385],[114.69423,28.59544],[114.685845,28.596075],[114.682477,28.594851],[114.679945,28.592603],[114.675899,28.594168],[114.670769,28.595161],[114.661592,28.594354],[114.639532,28.589285],[114.634604,28.587641],[114.6304,28.584246],[114.62866,28.581362],[114.626286,28.579858],[114.62206,28.579036],[114.615821,28.579905],[114.613764,28.577207],[114.609696,28.574369],[114.603729,28.573888],[114.57812,28.583486],[114.572175,28.582246],[114.568921,28.582866],[114.564558,28.585595],[114.557755,28.586541],[114.55285,28.586417],[114.548081,28.580556],[114.542498,28.576292],[114.541842,28.569764],[114.539673,28.565809],[114.535107,28.563437],[114.532643,28.563437],[114.532417,28.559017],[114.530451,28.555171],[114.526653,28.551495],[114.521251,28.548672],[114.518562,28.546253],[114.513725,28.545214],[114.509159,28.542282],[114.506492,28.537055],[114.507351,28.533611],[114.501858,28.52753],[114.497292,28.52615],[114.487777,28.525995],[114.480137,28.527344],[114.477583,28.515709],[114.476611,28.508541],[114.477266,28.499712],[114.476792,28.495197],[114.478103,28.486444],[114.477673,28.484318],[114.470757,28.482394],[114.467027,28.480842],[114.451838,28.480143],[114.449035,28.47825],[114.444289,28.472895],[114.435338,28.467401],[114.431066,28.467323],[114.423585,28.464296],[114.416826,28.460757],[114.413481,28.459531],[114.42311,28.453182],[114.423788,28.450388],[114.422093,28.444923],[114.423155,28.440762],[114.423811,28.434179],[114.426026,28.430934],[114.427857,28.430189],[114.440491,28.427285],[114.444063,28.425406],[114.445306,28.423822],[114.447091,28.418154],[114.449194,28.414909],[114.456246,28.413278],[114.460133,28.410094],[114.462371,28.406088],[114.46601,28.404612],[114.472068,28.404581],[114.477763,28.403059],[114.481809,28.399922],[114.484974,28.396613],[114.488409,28.38981],[114.489766,28.388381],[114.494761,28.38588],[114.501519,28.386533],[114.508119,28.388008],[114.509724,28.386781],[114.508413,28.379402],[114.50891,28.375783],[114.510334,28.374245],[114.517183,28.373188],[114.523625,28.367471],[114.527083,28.361427],[114.529004,28.356673],[114.534293,28.35543],[114.537638,28.357154],[114.539333,28.356362],[114.547696,28.349867],[114.554703,28.345702],[114.559744,28.345671],[114.565055,28.342657],[114.568672,28.33557],[114.574842,28.331187],[114.577645,28.326913],[114.581465,28.3248],[114.587636,28.32466],[114.591975,28.322157],[114.593219,28.320106],[114.590777,28.316204],[114.591591,28.314432],[114.596767,28.312334],[114.599186,28.308168],[114.604316,28.306256],[114.606419,28.300535],[114.605966,28.293772],[114.603345,28.289823],[114.599389,28.289496],[114.597626,28.282624],[114.601401,28.278519],[114.602915,28.275953],[114.602486,28.270791],[114.605695,28.266405],[114.6073,28.259998],[114.608927,28.256856],[114.605966,28.251848],[114.607639,28.250231],[114.608543,28.248209],[114.60904,28.241567],[114.612951,28.238161],[114.61772,28.232576],[114.621088,28.22934],[114.633406,28.237943],[114.634966,28.238021],[114.639193,28.236045],[114.642108,28.236061],[114.64421,28.239903],[114.644482,28.243154],[114.648279,28.245331],[114.661366,28.247385],[114.666406,28.246996],[114.670656,28.245331],[114.674385,28.244771],[114.680827,28.248364],[114.686297,28.250775],[114.689981,28.251102],[114.699813,28.247929],[114.703791,28.247369],[114.709668,28.245191],[114.714098,28.246825],[114.720088,28.242407],[114.719455,28.238161],[114.720653,28.236107],[114.725693,28.234194],[114.726168,28.230352],[114.726032,28.223086],[114.730915,28.218015],[114.730237,28.214172],[114.734735,28.208882],[114.73869,28.207341],[114.747279,28.209971],[114.752613,28.213083],[114.760886,28.214265],[114.766017,28.209473],[114.768164,28.208679],[114.775329,28.210189],[114.778607,28.213114],[114.777544,28.217641],[114.779217,28.219197],[114.784257,28.218404],[114.784189,28.222122],[114.785907,28.224891],[114.788055,28.223911],[114.790767,28.220831],[114.792326,28.221297],[114.792168,28.226509],[114.792937,28.227769],[114.797955,28.228749],[114.799492,28.233401],[114.798045,28.238083],[114.798859,28.241178],[114.802091,28.244569],[114.806973,28.245845],[114.808713,28.247105],[114.808691,28.250837],[114.810816,28.253233],[114.809437,28.25793],[114.808894,28.262564],[114.810409,28.26527],[114.814342,28.268209],[114.820851,28.270573],[114.825417,28.269935],[114.829711,28.270853],[114.832446,28.272719],[114.836718,28.277695],[114.839069,28.277835],[114.848268,28.279934],[114.848766,28.284397],[114.847319,28.287615],[114.846392,28.292761],[114.843092,28.297286],[114.846618,28.302556],[114.845488,28.306442],[114.851478,28.308572],[114.855818,28.308976],[114.857287,28.310297],[114.864,28.311012],[114.869312,28.309862],[114.874488,28.3068],[114.881743,28.30823],[114.884116,28.312707],[114.884614,28.316158],[114.887688,28.319701],[114.88997,28.319546],[114.89257,28.316733],[114.897475,28.318753],[114.903171,28.318256],[114.906471,28.321302],[114.904346,28.330239],[114.90082,28.337093],[114.90082,28.338538],[114.905838,28.344848],[114.906923,28.347148],[114.912347,28.349976],[114.918201,28.350271],[114.919897,28.343169],[114.922948,28.343698],[114.928621,28.349572],[114.930836,28.347054],[114.935583,28.34707],[114.939403,28.345827],[114.941618,28.349043],[114.943743,28.350318],[114.949597,28.346402],[114.962571,28.346697],[114.965238,28.349851],[114.964876,28.355166],[114.968289,28.362872],[114.969713,28.363509],[114.97446,28.362328],[114.977647,28.364799],[114.982122,28.365917],[114.985671,28.370811],[114.989129,28.369677],[114.992316,28.37033],[115.001131,28.375938],[115.00321,28.375829],[115.003097,28.37353],[115.007143,28.370578],[115.009743,28.369615],[115.017405,28.369553],[115.020592,28.371681],[115.021564,28.37468],[115.020366,28.379993],[115.021903,28.3831],[115.023395,28.38981],[115.031238,28.392824],[115.031102,28.399067],[115.036097,28.401661],[115.041206,28.406041],[115.042562,28.408122],[115.041906,28.411539],[115.042675,28.415514],[115.045342,28.417347],[115.051513,28.419723],[115.052598,28.424195],[115.057322,28.428403],[115.060893,28.428931],[115.063176,28.427689],[115.064984,28.424319],[115.068126,28.422828],[115.073889,28.423481],[115.077732,28.419428],[115.081755,28.418403],[115.089417,28.420608],[115.089915,28.424599],[115.093283,28.428217],[115.096311,28.432471],[115.100764,28.433403],[115.107748,28.438821],[115.119479,28.439536],[115.12678,28.440358],[115.132159,28.43997],[115.13512,28.441694],[115.133877,28.44736],[115.130487,28.45062],[115.130668,28.452576],[115.133448,28.453772],[115.13512,28.456644],[115.135934,28.460602],[115.133335,28.461347],[115.131956,28.46501],[115.133063,28.46678],[115.1313,28.470676],[115.125446,28.471576],[115.123751,28.475643],[115.12192,28.476776],[115.121649,28.4805],[115.11966,28.489145],[115.120428,28.49276],[115.118801,28.494933],[115.112902,28.494622],[115.106211,28.495507],[115.104855,28.494591],[115.096628,28.494498],[115.093576,28.496609],[115.086163,28.499216],[115.084852,28.5019],[115.081981,28.503902],[115.079495,28.504228],[115.072714,28.510093],[115.068759,28.511566],[115.064984,28.510853],[115.062204,28.511349],[115.058474,28.514825],[115.056395,28.514297],[115.045523,28.515088],[115.044325,28.518517],[115.038629,28.518253],[115.027079,28.519432],[115.025452,28.52148],[115.02613,28.526476],[115.030017,28.530555],[115.029791,28.536062],[115.027825,28.539258],[115.028164,28.54585],[115.023146,28.549588],[115.023576,28.552581],[115.026808,28.555807],[115.026876,28.558211],[115.023327,28.562088],[115.019801,28.563545],[115.015371,28.562537],[115.009471,28.569655],[115.010624,28.573795],[115.010353,28.577455],[115.02509,28.583207],[115.021948,28.585657],[115.012952,28.588013],[115.008771,28.590169],[115.006149,28.595936],[115.006556,28.606663],[115.004838,28.611747],[114.999571,28.614692],[114.992452,28.615622],[114.987954,28.614739],[114.986281,28.61353],[114.983885,28.609732],[114.980879,28.609035],[114.977624,28.610445],[114.974934,28.612894],[114.9696,28.613204],[114.966029,28.612507],[114.962887,28.613576],[114.96248,28.617188],[114.961101,28.619699],[114.958163,28.622551],[114.954253,28.625],[114.95197,28.625557],[114.948399,28.624674],[114.943584,28.625108],[114.94155,28.626766],[114.940103,28.630765],[114.937436,28.631958],[114.925366,28.628874],[114.923762,28.625139],[114.921863,28.623822],[114.907149,28.618552],[114.904685,28.618536],[114.896864,28.62269],[114.889925,28.623713],[114.879935,28.623791],[114.87729,28.62207],[114.874194,28.617203],[114.870645,28.614894],[114.868792,28.609562],[114.865288,28.606183],[114.860768,28.604849],[114.847432,28.603904],[114.84029,28.608818],[114.837238,28.609841],[114.832582,28.608275],[114.827338,28.607299],[114.820557,28.603098],[114.817822,28.603098],[114.813867,28.605098],[114.812827,28.607035],[114.812262,28.614134],[114.808826,28.613964],[114.804668,28.616351],[114.800916,28.61756],[114.799446,28.624535],[114.795807,28.627448],[114.794112,28.629742],[114.792959,28.634717],[114.785772,28.636018],[114.782313,28.638064],[114.779963,28.641024],[114.771645,28.645301],[114.757902,28.650399],[114.757496,28.653606],[114.762672,28.659308],[114.754263,28.671702],[114.753676,28.675528],[114.751822,28.67937],[114.746533,28.684435],[114.743572,28.688664],[114.741719,28.695076]]]]}},{"type":"Feature","properties":{"adcode":360925,"name":"靖安县","center":[115.361744,28.86054],"centroid":[115.231144,28.940173],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":5,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.91124,28.816402],[114.915308,28.816866],[114.926361,28.820084],[114.934159,28.822946],[114.949077,28.822234],[114.955202,28.821708],[114.960943,28.819233],[114.963972,28.817191],[114.964967,28.814963],[114.968967,28.811823],[114.979613,28.807723],[114.983478,28.807878],[114.98723,28.811049],[114.99331,28.808636],[114.996339,28.806826],[115.005403,28.798981],[115.012274,28.801333],[115.015958,28.80107],[115.021677,28.80237],[115.023824,28.8037],[115.033476,28.804288],[115.040234,28.806222],[115.046156,28.811482],[115.048371,28.811668],[115.052552,28.81043],[115.057095,28.811668],[115.061254,28.815242],[115.07129,28.815876],[115.073437,28.81699],[115.07459,28.820997],[115.074341,28.827292],[115.076443,28.827246],[115.079382,28.825606],[115.081009,28.826194],[115.085846,28.832737],[115.088626,28.835398],[115.094028,28.839079],[115.100696,28.841229],[115.107477,28.842064],[115.123435,28.849441],[115.12791,28.850369],[115.135098,28.854684],[115.139121,28.854699],[115.145043,28.852194],[115.151598,28.854792],[115.155824,28.854452],[115.160797,28.858689],[115.162764,28.858411],[115.163442,28.85108],[115.168595,28.843982],[115.171398,28.842667],[115.178811,28.841755],[115.18731,28.837996],[115.19929,28.835429],[115.206093,28.836419],[115.212015,28.835506],[115.21579,28.832242],[115.217733,28.829613],[115.22126,28.83116],[115.227611,28.835351],[115.232674,28.837501],[115.236426,28.837269],[115.239703,28.834129],[115.241647,28.833959],[115.245671,28.836032],[115.251389,28.835924],[115.254147,28.834686],[115.259458,28.835042],[115.262849,28.83464],[115.267731,28.83283],[115.275936,28.832907],[115.289656,28.825684],[115.292187,28.82621],[115.297634,28.830402],[115.304212,28.830726],[115.30923,28.832119],[115.317118,28.833294],[115.324622,28.828406],[115.323582,28.825761],[115.324577,28.823131],[115.324735,28.817671],[115.327854,28.815799],[115.330544,28.810647],[115.329459,28.807444],[115.329075,28.801364],[115.331245,28.796165],[115.335878,28.792854],[115.34345,28.788985],[115.348626,28.785503],[115.351542,28.787825],[115.353418,28.786958],[115.354865,28.783585],[115.363996,28.781495],[115.373241,28.782037],[115.376518,28.777982],[115.376767,28.776265],[115.381355,28.770151],[115.388656,28.766158],[115.390871,28.766499],[115.391617,28.771606],[115.393651,28.773448],[115.393561,28.776946],[115.396205,28.786339],[115.398804,28.787206],[115.404545,28.783616],[115.406557,28.783956],[115.409337,28.793411],[115.409767,28.796923],[115.409111,28.803963],[115.4104,28.806083],[115.416887,28.811653],[115.4111,28.816],[115.409857,28.818521],[115.414536,28.81945],[115.419735,28.822311],[115.418808,28.824322],[115.420571,28.826736],[115.415824,28.825065],[115.411259,28.830386],[115.409156,28.835026],[115.405766,28.837888],[115.39998,28.843843],[115.398126,28.848482],[115.39833,28.849843],[115.401381,28.851745],[115.40163,28.856787],[115.404161,28.86138],[115.406309,28.862524],[115.411191,28.860127],[115.416661,28.859338],[115.420752,28.85722],[115.425363,28.85739],[115.428504,28.856199],[115.428753,28.853833],[115.43533,28.851946],[115.437794,28.852519],[115.440665,28.850756],[115.443513,28.850292],[115.451876,28.852302],[115.450972,28.85705],[115.4533,28.858318],[115.457911,28.858472],[115.461278,28.861287],[115.464081,28.858704],[115.471924,28.855024],[115.474908,28.851993],[115.482005,28.849611],[115.484107,28.847663],[115.491544,28.845915],[115.493759,28.844136],[115.495454,28.843332],[115.505806,28.832722],[115.507682,28.833217],[115.510462,28.837764],[115.51435,28.838723],[115.514847,28.841878],[115.517831,28.842497],[115.518735,28.847895],[115.522261,28.852333],[115.528273,28.857545],[115.530307,28.860359],[115.530398,28.86322],[115.526329,28.870874],[115.52477,28.87644],[115.521379,28.883073],[115.523323,28.886799],[115.5226,28.892287],[115.5193,28.895409],[115.512157,28.896631],[115.513129,28.899552],[115.512519,28.902072],[115.509264,28.906601],[115.507456,28.910171],[115.504066,28.913741],[115.503862,28.916523],[115.506258,28.921809],[115.505354,28.924436],[115.499296,28.92898],[115.498189,28.935331],[115.491815,28.940847],[115.490526,28.945374],[115.488696,28.948418],[115.485328,28.951864],[115.482186,28.956406],[115.479858,28.960994],[115.479135,28.964486],[115.472037,28.966386],[115.471133,28.971205],[115.469122,28.973445],[115.465392,28.979407],[115.463426,28.983948],[115.467765,28.988242],[115.468692,28.992196],[115.472354,28.991207],[115.472444,28.993632],[115.476083,28.994018],[115.472964,28.999887],[115.473981,29.004164],[115.475563,29.006187],[115.472625,29.012117],[115.470071,29.012951],[115.470071,29.01539],[115.471472,29.019436],[115.471337,29.023913],[115.469031,29.026599],[115.464217,29.026167],[115.456441,29.029733],[115.450768,29.029903],[115.448372,29.031879],[115.446632,29.035183],[115.444191,29.035399],[115.440484,29.040185],[115.437839,29.041589],[115.439851,29.047193],[115.443467,29.049462],[115.447355,29.054633],[115.447739,29.057642],[115.445976,29.060606],[115.440122,29.062936],[115.429838,29.065637],[115.428979,29.066686],[115.423509,29.066223],[115.418559,29.063878],[115.411462,29.063245],[115.408546,29.06485],[115.405789,29.067551],[115.398578,29.067844],[115.39573,29.067365],[115.394058,29.071995],[115.394555,29.076239],[115.386486,29.078399],[115.382259,29.080745],[115.379253,29.079989],[115.37575,29.080915],[115.367567,29.084618],[115.359023,29.085528],[115.353147,29.086901],[115.343179,29.092009],[115.334997,29.095712],[115.324848,29.098149],[115.315061,29.099353],[115.304212,29.098998],[115.295148,29.095681],[115.29282,29.095835],[115.28943,29.099414],[115.285881,29.099707],[115.279484,29.097332],[115.270421,29.096684],[115.266171,29.094801],[115.248609,29.090065],[115.243998,29.090049],[115.235657,29.091283],[115.230504,29.092502],[115.22413,29.094678],[115.216671,29.094662],[115.202883,29.086223],[115.196871,29.084494],[115.191718,29.083707],[115.182677,29.083538],[115.179512,29.081347],[115.171556,29.079618],[115.168708,29.07806],[115.160232,29.076794],[115.154016,29.07647],[115.150829,29.075529],[115.144817,29.072396],[115.135279,29.066764],[115.133855,29.065189],[115.128746,29.062072],[115.125017,29.062056],[115.122192,29.060637],[115.114235,29.053598],[115.109263,29.051546],[115.098617,29.050882],[115.094548,29.04869],[115.092243,29.048366],[115.088174,29.045696],[115.08232,29.043318],[115.075946,29.039999],[115.073415,29.03472],[115.070296,29.034982],[115.068713,29.033423],[115.065119,29.033917],[115.060825,29.036001],[115.058474,29.033933],[115.051264,29.031493],[115.05158,29.028807],[115.048484,29.01942],[115.045116,29.015035],[115.040686,29.012827],[115.032865,29.011684],[115.027734,29.009615],[115.023734,29.00943],[115.016682,29.012302],[115.012591,29.009337],[115.004228,29.009739],[115.000136,29.009245],[114.996226,29.007654],[114.993921,29.0056],[114.987795,28.997771],[114.980608,28.994373],[114.979523,28.991856],[114.97993,28.989725],[114.98341,28.986435],[114.984473,28.984443],[114.980901,28.981307],[114.973849,28.97845],[114.964967,28.970819],[114.963882,28.967498],[114.967769,28.961859],[114.968764,28.959125],[114.967385,28.956437],[114.968108,28.951338],[114.969736,28.949577],[114.969736,28.94658],[114.971092,28.943026],[114.967588,28.940615],[114.96691,28.936907],[114.963791,28.934852],[114.959474,28.934713],[114.95744,28.931128],[114.954795,28.928114],[114.949619,28.923633],[114.952219,28.920217],[114.954343,28.913973],[114.949868,28.910125],[114.948286,28.906539],[114.950817,28.899135],[114.951382,28.896028],[114.955428,28.891977],[114.958434,28.890725],[114.957982,28.886165],[114.956151,28.882532],[114.956423,28.880444],[114.955157,28.87794],[114.950614,28.874817],[114.945257,28.873379],[114.942206,28.871245],[114.938883,28.870998],[114.933368,28.868554],[114.92948,28.867936],[114.924643,28.86908],[114.920055,28.866173],[114.918563,28.862029],[114.916371,28.860885],[114.909522,28.854081],[114.90907,28.85156],[114.910562,28.843131],[114.908866,28.837053],[114.909002,28.834315],[114.907849,28.831036],[114.907307,28.826364],[114.905092,28.824415],[114.907216,28.823069],[114.907714,28.819357],[114.91124,28.816402]]]]}},{"type":"Feature","properties":{"adcode":360926,"name":"铜鼓县","center":[114.37014,28.520956],"centroid":[114.363656,28.609484],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":6,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[114.259466,28.376668],[114.265388,28.379402],[114.271016,28.380148],[114.276712,28.379449],[114.294048,28.384234],[114.298365,28.385818],[114.30336,28.386269],[114.306118,28.387434],[114.307768,28.391923],[114.30544,28.396986],[114.308514,28.40149],[114.308423,28.404348],[114.304807,28.408262],[114.303496,28.411523],[114.303971,28.413356],[114.306683,28.415266],[114.317419,28.417952],[114.323748,28.421322],[114.329941,28.426027],[114.335298,28.428931],[114.338982,28.42904],[114.34504,28.426571],[114.347255,28.426648],[114.352363,28.428915],[114.359054,28.427906],[114.377882,28.432921],[114.383352,28.436058],[114.385341,28.440607],[114.388776,28.445202],[114.394291,28.445715],[114.398224,28.447112],[114.403106,28.4518],[114.40765,28.458351],[114.413481,28.459531],[114.416826,28.460757],[114.423585,28.464296],[114.431066,28.467323],[114.435338,28.467401],[114.444289,28.472895],[114.449035,28.47825],[114.451838,28.480143],[114.467027,28.480842],[114.470757,28.482394],[114.477673,28.484318],[114.478103,28.486444],[114.476792,28.495197],[114.477266,28.499712],[114.476611,28.508541],[114.477583,28.515709],[114.480137,28.527344],[114.487777,28.525995],[114.497292,28.52615],[114.501858,28.52753],[114.507351,28.533611],[114.506492,28.537055],[114.509159,28.542282],[114.513725,28.545214],[114.518562,28.546253],[114.521251,28.548672],[114.526653,28.551495],[114.530451,28.555171],[114.532417,28.559017],[114.532643,28.563437],[114.535107,28.563437],[114.539673,28.565809],[114.541842,28.569764],[114.542498,28.576292],[114.548081,28.580556],[114.55285,28.586417],[114.557755,28.586541],[114.564558,28.585595],[114.568921,28.582866],[114.572175,28.582246],[114.57812,28.583486],[114.603729,28.573888],[114.609696,28.574369],[114.613764,28.577207],[114.615821,28.579905],[114.62206,28.579036],[114.626286,28.579858],[114.62866,28.581362],[114.6304,28.584246],[114.634604,28.587641],[114.639532,28.589285],[114.661592,28.594354],[114.670769,28.595161],[114.675899,28.594168],[114.679945,28.592603],[114.682477,28.594851],[114.685845,28.596075],[114.69423,28.59544],[114.698389,28.596385],[114.699158,28.598695],[114.698728,28.605904],[114.699813,28.60826],[114.70291,28.611251],[114.707928,28.619311],[114.70847,28.627448],[114.709555,28.631183],[114.711815,28.634856],[114.71403,28.643116],[114.723411,28.64764],[114.729265,28.649221],[114.730779,28.655713],[114.732723,28.658982],[114.73148,28.660578],[114.729106,28.666636],[114.726145,28.672244],[114.727547,28.674878],[114.734192,28.68253],[114.737085,28.687022],[114.734373,28.686712],[114.723252,28.688586],[114.721218,28.690166],[114.716336,28.690987],[114.709668,28.686077],[114.705848,28.685179],[114.694185,28.688122],[114.6825,28.690476],[114.674679,28.691219],[114.669435,28.690135],[114.666316,28.687936],[114.663129,28.686991],[114.660733,28.688168],[114.654947,28.687595],[114.648256,28.686046],[114.645363,28.687626],[114.643713,28.690941],[114.641882,28.69218],[114.634672,28.692118],[114.630151,28.694379],[114.62371,28.695123],[114.618986,28.699614],[114.616273,28.705546],[114.616115,28.708581],[114.61329,28.711709],[114.606554,28.714063],[114.590551,28.725057],[114.583861,28.732396],[114.581962,28.739657],[114.58246,28.747924],[114.581103,28.753868],[114.57986,28.762057],[114.577939,28.765183],[114.571655,28.770306],[114.567316,28.771482],[114.566457,28.766251],[114.564061,28.764363],[114.561077,28.764796],[114.554364,28.767567],[114.548149,28.767025],[114.545775,28.764131],[114.545481,28.762242],[114.541503,28.759239],[114.536327,28.758404],[114.530744,28.760153],[114.524529,28.758404],[114.517861,28.754302],[114.514538,28.756577],[114.510176,28.757645],[114.500909,28.753868],[114.495281,28.753667],[114.491687,28.75554],[114.488703,28.755695],[114.484137,28.753373],[114.480566,28.748899],[114.474079,28.737737],[114.469739,28.732783],[114.462574,28.729532],[114.459885,28.727054],[114.461309,28.720814],[114.461241,28.716571],[114.464428,28.710191],[114.467208,28.703548],[114.467524,28.700172],[114.46549,28.696904],[114.460224,28.698298],[114.451115,28.702479],[114.445441,28.705886],[114.439768,28.707265],[114.431202,28.714419],[114.424127,28.716029],[114.41972,28.714388],[114.416216,28.709711],[114.413391,28.707466],[114.410091,28.706227],[114.393048,28.704353],[114.38794,28.705329],[114.383623,28.70855],[114.375712,28.712592],[114.370355,28.714202],[114.367982,28.711833],[114.367191,28.703052],[114.365315,28.70172],[114.362444,28.70186],[114.34956,28.704074],[114.34556,28.705793],[114.342644,28.709092],[114.341175,28.713025],[114.338146,28.714698],[114.332947,28.71637],[114.331094,28.717717],[114.329896,28.720861],[114.327591,28.72227],[114.321465,28.723509],[114.313916,28.727999],[114.313034,28.731095],[114.313238,28.734749],[114.311068,28.737644],[114.302637,28.745586],[114.29719,28.74941],[114.290206,28.756887],[114.288443,28.75797],[114.280441,28.757939],[114.272485,28.765183],[114.269818,28.769223],[114.268643,28.775568],[114.268756,28.780954],[114.267919,28.785302],[114.264958,28.792544],[114.260799,28.797883],[114.259534,28.80469],[114.257364,28.807584],[114.252843,28.809193],[114.246876,28.809378],[114.244435,28.807228],[114.241519,28.802385],[114.23284,28.800405],[114.226014,28.806129],[114.223731,28.812813],[114.224974,28.820099],[114.222781,28.823967],[114.218442,28.828576],[114.213379,28.828963],[114.212384,28.825545],[114.210734,28.823688],[114.204428,28.820486],[114.199614,28.812132],[114.197534,28.807475],[114.193488,28.804288],[114.191047,28.803576],[114.182797,28.799322],[114.170682,28.791028],[114.167201,28.789171],[114.163743,28.785983],[114.16302,28.782594],[114.164331,28.777286],[114.163833,28.775971],[114.1559,28.773479],[114.153504,28.770972],[114.156035,28.766483],[114.15712,28.761453],[114.152125,28.746747],[114.151967,28.742459],[114.147559,28.737598],[114.14661,28.734563],[114.148803,28.731142],[114.149481,28.728277],[114.149345,28.723756],[114.147559,28.720427],[114.143785,28.716897],[114.142203,28.713227],[114.141524,28.705081],[114.139987,28.702959],[114.134676,28.702742],[114.131263,28.70076],[114.128234,28.701023],[114.125409,28.697616],[114.122402,28.689469],[114.123849,28.687641],[114.123329,28.682205],[114.126561,28.677124],[114.133116,28.671686],[114.132619,28.668185],[114.130472,28.665319],[114.129409,28.662267],[114.132438,28.658332],[114.132619,28.653931],[114.129929,28.650987],[114.129613,28.645889],[114.132822,28.641845],[114.132325,28.63949],[114.128302,28.634934],[114.127375,28.630408],[114.1236,28.627402],[114.122289,28.623264],[114.122764,28.620117],[114.124618,28.617839],[114.129568,28.615715],[114.132122,28.60719],[114.129206,28.602648],[114.124866,28.597222],[114.122154,28.590727],[114.118696,28.586866],[114.114514,28.585393],[114.110807,28.585657],[114.104569,28.58313],[114.102761,28.581176],[114.100681,28.575889],[114.094804,28.570105],[114.095641,28.56398],[114.094691,28.562258],[114.08825,28.56001],[114.08617,28.558335],[114.0866,28.55621],[114.090307,28.549727],[114.094624,28.546222],[114.097336,28.54281],[114.100659,28.540328],[114.104637,28.538932],[114.109428,28.538575],[114.118492,28.538994],[114.121295,28.537582],[114.123216,28.534728],[114.133681,28.536543],[114.136913,28.535364],[114.138111,28.533704],[114.14062,28.523419],[114.14383,28.519215],[114.147288,28.517695],[114.154634,28.507548],[114.159968,28.506788],[114.164602,28.501947],[114.168896,28.49934],[114.17466,28.497385],[114.18004,28.496904],[114.185216,28.4974],[114.192426,28.499448],[114.19559,28.498548],[114.200699,28.494405],[114.204451,28.492714],[114.210847,28.487779],[114.216882,28.485699],[114.218803,28.482627],[114.219707,28.476108],[114.219323,28.470552],[114.216905,28.466407],[114.208044,28.460385],[114.202303,28.459267],[114.199659,28.453461],[114.196969,28.450636],[114.193759,28.449068],[114.191409,28.446305],[114.19003,28.441321],[114.187544,28.438946],[114.182978,28.436865],[114.175474,28.437036],[114.171835,28.434614],[114.172377,28.432782],[114.178683,28.433278],[114.186391,28.431198],[114.189103,28.431803],[114.193375,28.430872],[114.202236,28.424443],[114.206688,28.418527],[114.210802,28.410374],[114.213492,28.406491],[114.214622,28.403059],[114.217334,28.402112],[114.22077,28.402314],[114.223957,28.400559],[114.228161,28.395433],[114.233337,28.398788],[114.23614,28.396924],[114.252459,28.395744],[114.255985,28.392093],[114.256347,28.381857],[114.259466,28.376668]]]]}},{"type":"Feature","properties":{"adcode":360981,"name":"丰城市","center":[115.786005,28.191584],"centroid":[115.817186,28.106915],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":7,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[115.53198,28.394097],[115.529313,28.391659],[115.519752,28.389686],[115.520792,28.388366],[115.520927,28.383628],[115.518531,28.383721],[115.513966,28.38602],[115.511841,28.383907],[115.510281,28.38049],[115.511163,28.378051],[115.508541,28.376932],[115.509377,28.375488],[115.505535,28.372971],[115.509671,28.367937],[115.508541,28.3618],[115.501692,28.359656],[115.494459,28.355368],[115.49247,28.352509],[115.483949,28.350069],[115.481757,28.34721],[115.479451,28.339875],[115.477394,28.337994],[115.473326,28.336036],[115.471585,28.330954],[115.466884,28.32724],[115.460826,28.325468],[115.454678,28.326152],[115.453006,28.319577],[115.450949,28.316888],[115.445728,28.314774],[115.444033,28.31294],[115.441908,28.306644],[115.437681,28.298109],[115.443061,28.287848],[115.446745,28.286527],[115.458996,28.287444],[115.466816,28.287537],[115.472489,28.285065],[115.474366,28.285236],[115.479406,28.287631],[115.483655,28.287335],[115.486232,28.284117],[115.486752,28.282002],[115.489735,28.278208],[115.492629,28.276886],[115.493623,28.275114],[115.495363,28.267556],[115.498189,28.264104],[115.503885,28.261864],[115.510123,28.258147],[115.515638,28.257681],[115.516361,28.256297],[115.51496,28.251273],[115.516022,28.249998],[115.515593,28.246933],[115.517605,28.246545],[115.520543,28.243947],[115.525787,28.24278],[115.52712,28.239218],[115.52868,28.238021],[115.529155,28.231721],[115.528273,28.227598],[115.530262,28.224611],[115.536455,28.224502],[115.539642,28.22654],[115.54362,28.231067],[115.54674,28.232576],[115.548503,28.232281],[115.548005,28.230429],[115.544457,28.224938],[115.544321,28.222993],[115.546785,28.221593],[115.54952,28.21817],[115.550492,28.214141],[115.550356,28.210998],[115.551373,28.207637],[115.553498,28.206797],[115.5556,28.215914],[115.558787,28.216179],[115.559442,28.21204],[115.564438,28.208788],[115.561883,28.205847],[115.558425,28.206003],[115.557227,28.204743],[115.557905,28.202393],[115.555668,28.201911],[115.552029,28.198767],[115.54405,28.186162],[115.544321,28.182256],[115.546853,28.180746],[115.546875,28.178271],[115.550944,28.177836],[115.551486,28.175112],[115.553792,28.172419],[115.556346,28.171983],[115.555849,28.169726],[115.552051,28.165415],[115.551577,28.159764],[115.553136,28.157507],[115.555668,28.156168],[115.559488,28.155732],[115.561251,28.158005],[115.565093,28.156666],[115.568687,28.152385],[115.570201,28.154207],[115.572236,28.153771],[115.573275,28.151062],[115.575829,28.149957],[115.577592,28.151763],[115.57757,28.15402],[115.579604,28.155608],[115.584712,28.155857],[115.586498,28.154067],[115.587018,28.150688],[115.588306,28.149101],[115.586294,28.145707],[115.580214,28.140709],[115.569049,28.134777],[115.564777,28.131024],[115.568958,28.12615],[115.571151,28.126773],[115.574699,28.131071],[115.577412,28.131414],[115.577728,28.12791],[115.577163,28.121899],[115.578406,28.117773],[115.582271,28.11472],[115.584735,28.111574],[115.589527,28.110951],[115.59294,28.107619],[115.601664,28.10712],[115.608965,28.107229],[115.614797,28.108101],[115.621668,28.101467],[115.62316,28.097682],[115.628381,28.096077],[115.622572,28.091031],[115.623092,28.08776],[115.627748,28.085532],[115.629195,28.080313],[115.631975,28.079768],[115.634551,28.081622],[115.635614,28.084722],[115.641264,28.088289],[115.643141,28.092729],[115.647503,28.09804],[115.651164,28.099006],[115.65295,28.097183],[115.652543,28.092604],[115.653267,28.091124],[115.652814,28.085563],[115.655775,28.082323],[115.655708,28.076247],[115.658126,28.069969],[115.660273,28.069299],[115.672072,28.068473],[115.678243,28.067741],[115.683486,28.068832],[115.692121,28.072649],[115.695737,28.077447],[115.698902,28.078117],[115.698563,28.075406],[115.69203,28.068629],[115.691126,28.067024],[115.691556,28.063581],[115.698472,28.06034],[115.704055,28.059203],[115.705298,28.057894],[115.706632,28.053453],[115.712757,28.052861],[115.714724,28.052113],[115.714181,28.050352],[115.71782,28.050181],[115.717865,28.048934],[115.720736,28.04655],[115.721414,28.044774],[115.718453,28.040566],[115.706338,28.03748],[115.705027,28.042078],[115.701456,28.043761],[115.700032,28.043168],[115.698133,28.03907],[115.69133,28.02869],[115.680774,28.022206],[115.677406,28.018045],[115.676525,28.014724],[115.676412,28.00824],[115.674626,28.004686],[115.669608,28.005777],[115.663664,28.004467],[115.660635,28.00216],[115.655323,28.00085],[115.650057,28.000476],[115.641739,27.996563],[115.640067,27.993773],[115.63523,27.993102],[115.634529,27.990763],[115.634484,27.985166],[115.633512,27.980457],[115.637784,27.973565],[115.641558,27.970696],[115.643728,27.970353],[115.64357,27.965596],[115.647299,27.968169],[115.646599,27.965128],[115.649153,27.962633],[115.6513,27.962774],[115.651571,27.956738],[115.654917,27.956473],[115.65781,27.954399],[115.657199,27.950967],[115.65903,27.94816],[115.666986,27.941281],[115.671281,27.939425],[115.675101,27.939674],[115.679825,27.944385],[115.683645,27.942732],[115.68204,27.937865],[115.681859,27.933419],[115.686018,27.924168],[115.684187,27.920284],[115.681723,27.91888],[115.672275,27.910688],[115.669631,27.907552],[115.666986,27.901014],[115.662963,27.898876],[115.661946,27.892822],[115.658149,27.887609],[115.657245,27.885206],[115.655843,27.877153],[115.657154,27.872049],[115.657109,27.869411],[115.655097,27.865946],[115.653786,27.860888],[115.654781,27.857735],[115.653289,27.854644],[115.653357,27.851897],[115.651323,27.846604],[115.650034,27.834817],[115.65069,27.832865],[115.653628,27.8311],[115.655075,27.828571],[115.659211,27.826666],[115.661562,27.824105],[115.666534,27.8227],[115.673858,27.82131],[115.676028,27.819436],[115.677248,27.8165],[115.677565,27.811628],[115.679802,27.809394],[115.686786,27.798571],[115.690426,27.790449],[115.690493,27.784451],[115.692595,27.777593],[115.695421,27.771969],[115.697704,27.769719],[115.705321,27.767266],[115.710406,27.76661],[115.715492,27.764376],[115.722883,27.761938],[115.725369,27.762642],[115.728195,27.761048],[115.730319,27.757985],[115.729777,27.754439],[115.728104,27.751142],[115.730545,27.748407],[115.731608,27.743172],[115.733619,27.738515],[115.735111,27.729607],[115.738705,27.73178],[115.744152,27.733061],[115.752335,27.737671],[115.755183,27.740656],[115.756946,27.744438],[115.761195,27.745735],[115.774621,27.743344],[115.785968,27.739656],[115.79485,27.733811],[115.802739,27.730717],[115.80744,27.727919],[115.809565,27.728232],[115.817521,27.731983],[115.81942,27.731686],[115.821205,27.729263],[115.823217,27.72981],[115.826359,27.73553],[115.828506,27.73428],[115.828529,27.732592],[115.831309,27.726903],[115.836643,27.725559],[115.842655,27.730357],[115.843492,27.736015],[115.849346,27.744016],[115.84921,27.747516],[115.851787,27.752845],[115.851606,27.758345],[115.848826,27.76172],[115.848261,27.764423],[115.853346,27.770516],[115.854838,27.776031],[115.858409,27.780655],[115.859856,27.784982],[115.859788,27.787731],[115.86128,27.793136],[115.859314,27.797478],[115.862953,27.801351],[115.864896,27.804912],[115.865552,27.811487],[115.863992,27.815985],[115.862907,27.822137],[115.860331,27.827056],[115.859472,27.831944],[115.859833,27.836237],[115.863427,27.844637],[115.864173,27.852053],[115.865552,27.855003],[115.87387,27.855815],[115.88047,27.85402],[115.886143,27.854707],[115.8948,27.861466],[115.898981,27.863917],[115.901558,27.866492],[115.904338,27.871877],[115.906802,27.88082],[115.907457,27.881554],[115.913967,27.883099],[115.920273,27.882584],[115.923754,27.88544],[115.936479,27.888234],[115.942537,27.892884],[115.94491,27.894101],[115.949612,27.894257],[115.958472,27.891292],[115.96132,27.891417],[115.966654,27.895568],[115.969344,27.89638],[115.979673,27.895974],[115.985912,27.89741],[115.994998,27.900593],[116.003406,27.897581],[116.009758,27.900749],[116.017804,27.903526],[116.027049,27.908192],[116.029309,27.910548],[116.031004,27.914183],[116.034078,27.918318],[116.041469,27.9242],[116.047504,27.926618],[116.053268,27.927086],[116.057269,27.928053],[116.057902,27.931968],[116.059552,27.934745],[116.063824,27.93774],[116.069248,27.939456],[116.069384,27.943106],[116.072774,27.946709],[116.079058,27.947052],[116.079578,27.952761],[116.079397,27.958048],[116.080075,27.959233],[116.084415,27.960122],[116.086607,27.962025],[116.08611,27.967982],[116.088574,27.97567],[116.091105,27.979054],[116.097343,27.980254],[116.101186,27.982063],[116.104396,27.985914],[116.104328,27.992556],[116.105707,27.995846],[116.11407,28.003298],[116.118206,28.005403],[116.119426,28.007585],[116.119449,28.012449],[116.120444,28.017031],[116.120195,28.022877],[116.116533,28.029828],[116.117957,28.03201],[116.120263,28.039787],[116.121348,28.04161],[116.12467,28.04281],[116.129552,28.040893],[116.132197,28.040831],[116.135113,28.042467],[116.138752,28.048545],[116.139339,28.052939],[116.144629,28.056383],[116.14377,28.057878],[116.144063,28.062366],[116.137102,28.069517],[116.138458,28.071137],[116.143792,28.070857],[116.147861,28.073583],[116.14933,28.076528],[116.147499,28.085501],[116.145148,28.087588],[116.14386,28.090283],[116.1383,28.091015],[116.135881,28.094364],[116.134932,28.100532],[116.136107,28.104317],[116.140515,28.111419],[116.138209,28.112649],[116.138707,28.117119],[116.139814,28.119953],[116.143973,28.121806],[116.145081,28.124282],[116.15055,28.125169],[116.150799,28.128782],[116.147838,28.130464],[116.142233,28.13146],[116.138232,28.133998],[116.133576,28.134932],[116.128535,28.134045],[116.124535,28.131943],[116.120398,28.13213],[116.116917,28.133344],[116.113459,28.135571],[116.107198,28.135758],[116.100734,28.139884],[116.09653,28.141519],[116.094609,28.144897],[116.088483,28.147419],[116.08672,28.146018],[116.081815,28.147995],[116.081454,28.151202],[116.077453,28.156604],[116.076639,28.160792],[116.078402,28.16185],[116.081612,28.167999],[116.084166,28.170536],[116.085477,28.174054],[116.082855,28.178692],[116.087059,28.185353],[116.093524,28.197569],[116.098361,28.203949],[116.10035,28.21036],[116.100576,28.215416],[116.10539,28.218512],[116.108826,28.224456],[116.11355,28.230601],[116.116013,28.237181],[116.113844,28.243449],[116.111357,28.246094],[116.104373,28.247867],[116.101163,28.2495],[116.098541,28.253404],[116.098112,28.264461],[116.096213,28.268287],[116.092959,28.271833],[116.081635,28.277057],[116.081906,28.277539],[116.073498,28.289014],[116.068774,28.291984],[116.0631,28.291937],[116.044317,28.295995],[116.038395,28.294938],[116.030326,28.288455],[116.021127,28.28393],[116.016584,28.283168],[116.007882,28.283339],[116.006616,28.279032],[116.000491,28.27967],[115.996603,28.281738],[115.994569,28.287771],[115.984759,28.291953],[115.979967,28.291067],[115.978701,28.284288],[115.973864,28.278846],[115.968621,28.276466],[115.966112,28.275984],[115.962224,28.276715],[115.957523,28.27855],[115.953296,28.278503],[115.950832,28.27939],[115.949702,28.281318],[115.954901,28.288206],[115.957455,28.288221],[115.960009,28.292761],[115.957929,28.29727],[115.957658,28.300644],[115.95411,28.299928],[115.951782,28.301001],[115.949227,28.304048],[115.942627,28.305385],[115.940254,28.307328],[115.93779,28.307624],[115.935146,28.306395],[115.931303,28.31022],[115.931032,28.313826],[115.929766,28.315178],[115.92337,28.315598],[115.922104,28.314914],[115.917267,28.308354],[115.920183,28.305945],[115.916521,28.302711],[115.91191,28.303815],[115.910125,28.307188],[115.909582,28.312831],[115.908045,28.315987],[115.905242,28.316204],[115.903457,28.314385],[115.902462,28.309878],[115.895275,28.303659],[115.886934,28.291564],[115.881736,28.286946],[115.879362,28.286884],[115.877644,28.293679],[115.872062,28.30324],[115.866185,28.308836],[115.859901,28.312722],[115.858635,28.316702],[115.858568,28.319966],[115.862794,28.331032],[115.863495,28.336161],[115.863201,28.343154],[115.861529,28.348266],[115.857528,28.355445],[115.8552,28.361754],[115.855358,28.366088],[115.851516,28.375721],[115.847922,28.381577],[115.842022,28.385927],[115.836055,28.392342],[115.829681,28.395635],[115.824098,28.399751],[115.82012,28.401599],[115.814221,28.402935],[115.80744,28.400248],[115.802761,28.399875],[115.800569,28.398602],[115.800705,28.392932],[115.802061,28.385647],[115.801405,28.380443],[115.790737,28.376264],[115.785222,28.371293],[115.78425,28.369677],[115.779707,28.365995],[115.77765,28.362173],[115.774101,28.360573],[115.770439,28.360775],[115.757307,28.368481],[115.750707,28.365482],[115.745961,28.362499],[115.732806,28.352338],[115.728556,28.350022],[115.727019,28.350442],[115.721685,28.360138],[115.720035,28.361862],[115.715808,28.36253],[115.711717,28.365576],[115.706541,28.367564],[115.704213,28.365312],[115.701343,28.364892],[115.696076,28.367393],[115.693025,28.367735],[115.689295,28.364426],[115.686854,28.36323],[115.684142,28.365405],[115.686786,28.365964],[115.687013,28.367533],[115.683803,28.368419],[115.681249,28.37426],[115.674197,28.375022],[115.675236,28.370936],[115.673225,28.367191],[115.669315,28.36744],[115.668297,28.363183],[115.67049,28.357077],[115.66997,28.355507],[115.672976,28.356626],[115.675146,28.36194],[115.678446,28.365094],[115.681678,28.365482],[115.682628,28.36281],[115.690968,28.362158],[115.691556,28.360759],[115.689318,28.358304],[115.692889,28.357916],[115.694291,28.354715],[115.690674,28.349308],[115.685114,28.348981],[115.682266,28.345531],[115.680752,28.345531],[115.679124,28.34233],[115.682786,28.339704],[115.67813,28.338974],[115.675078,28.34073],[115.672524,28.337404],[115.669473,28.339378],[115.671213,28.341911],[115.671078,28.345485],[115.669993,28.346262],[115.663528,28.346106],[115.658985,28.344646],[115.65894,28.342268],[115.657019,28.338911],[115.651594,28.334871],[115.648882,28.334467],[115.644225,28.335928],[115.635523,28.337559],[115.630573,28.336611],[115.628878,28.338709],[115.629918,28.339875],[115.625985,28.342734],[115.624222,28.342579],[115.621984,28.345563],[115.630347,28.348375],[115.6315,28.350799],[115.63254,28.356129],[115.633964,28.357729],[115.638552,28.366119],[115.647638,28.372085],[115.649899,28.372893],[115.652317,28.375596],[115.654578,28.381282],[115.653402,28.384591],[115.650871,28.386781],[115.648271,28.392777],[115.643073,28.39638],[115.638846,28.397235],[115.632947,28.39666],[115.627183,28.396707],[115.622097,28.398011],[115.617825,28.403572],[115.616831,28.41039],[115.619227,28.414458],[115.619566,28.41699],[115.618119,28.418015],[115.614096,28.417952],[115.61231,28.416943],[115.5985,28.417316],[115.597845,28.415996],[115.593392,28.412579],[115.589934,28.409147],[115.589233,28.405591],[115.587945,28.403882],[115.589662,28.401956],[115.588329,28.39913],[115.583401,28.397468],[115.576553,28.396784],[115.571942,28.397576],[115.567805,28.399984],[115.565929,28.39913],[115.563873,28.395184],[115.559352,28.389049],[115.557092,28.38762],[115.552707,28.387169],[115.545632,28.390105],[115.540659,28.393321],[115.539416,28.391783],[115.536614,28.391705],[115.535009,28.390431],[115.531596,28.392715],[115.53198,28.394097]]]]}},{"type":"Feature","properties":{"adcode":360982,"name":"樟树市","center":[115.543388,28.055898],"centroid":[115.416278,27.996351],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":8,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[115.564777,28.131024],[115.559691,28.129093],[115.555351,28.130199],[115.552029,28.129965],[115.546717,28.12858],[115.542649,28.128564],[115.53858,28.127645],[115.53354,28.124017],[115.526442,28.120591],[115.521605,28.12014],[115.512722,28.118505],[115.504269,28.11743],[115.49351,28.118505],[115.482118,28.121557],[115.471924,28.119844],[115.471427,28.120981],[115.474501,28.123425],[115.475315,28.127941],[115.475111,28.134714],[115.47258,28.136085],[115.471314,28.135415],[115.467449,28.130043],[115.464918,28.129623],[115.462883,28.131663],[115.463222,28.134995],[115.458996,28.133531],[115.455605,28.130806],[115.454362,28.128299],[115.450587,28.127645],[115.447174,28.122834],[115.444778,28.122289],[115.445773,28.127007],[115.444168,28.129218],[115.440529,28.12777],[115.438404,28.12218],[115.434313,28.121993],[115.431488,28.118395],[115.426267,28.11743],[115.425928,28.124313],[115.421904,28.12749],[115.42369,28.129747],[115.423464,28.132005],[115.419893,28.130682],[115.41761,28.131133],[115.416593,28.133407],[115.418424,28.13677],[115.417655,28.139027],[115.413406,28.146952],[115.410106,28.147217],[115.406015,28.146111],[115.402986,28.149972],[115.401449,28.150206],[115.396341,28.148431],[115.39503,28.142795],[115.39781,28.140304],[115.396499,28.137595],[115.392656,28.13582],[115.3873,28.135166],[115.383751,28.136536],[115.382734,28.138576],[115.383276,28.143091],[115.381875,28.145613],[115.377693,28.144477],[115.374484,28.14636],[115.370212,28.146283],[115.364493,28.150268],[115.358549,28.15128],[115.355701,28.150237],[115.354209,28.147995],[115.349236,28.142826],[115.349056,28.137393],[115.346954,28.132659],[115.342365,28.133126],[115.340082,28.134714],[115.332149,28.133173],[115.32417,28.126431],[115.322904,28.12464],[115.320599,28.125777],[115.315468,28.122195],[115.313411,28.119034],[115.309569,28.118162],[115.303918,28.114565],[115.300121,28.11064],[115.290967,28.103554],[115.288458,28.099302],[115.289294,28.095127],[115.288548,28.092215],[115.285768,28.089333],[115.278083,28.086622],[115.271166,28.083741],[115.264589,28.07874],[115.260995,28.077416],[115.255751,28.078833],[115.251909,28.083865],[115.249784,28.084831],[115.242687,28.083834],[115.239771,28.084753],[115.236855,28.087837],[115.234708,28.094987],[115.234279,28.100999],[115.233307,28.104613],[115.22917,28.107696],[115.228063,28.109924],[115.224763,28.111185],[115.219474,28.109861],[115.217168,28.106014],[115.217327,28.10103],[115.216355,28.097993],[115.216694,28.094567],[115.222638,28.091763],[115.220468,28.088087],[115.219383,28.083117],[115.210523,28.075764],[115.207404,28.076497],[115.203313,28.073521],[115.196283,28.069689],[115.189457,28.06704],[115.18505,28.063254],[115.182857,28.05953],[115.183016,28.053453],[115.184959,28.049854],[115.184914,28.047843],[115.180416,28.043387],[115.178879,28.042748],[115.17359,28.04348],[115.16699,28.048794],[115.163577,28.048513],[115.15483,28.045522],[115.154468,28.043387],[115.151485,28.041859],[115.146331,28.040644],[115.146015,28.038976],[115.148546,28.037496],[115.15275,28.03282],[115.152886,28.030124],[115.151236,28.024108],[115.151304,28.019603],[115.149563,28.013618],[115.147597,28.01036],[115.143348,28.007242],[115.135007,28.003703],[115.131278,28.003594],[115.129696,28.002534],[115.130215,27.996906],[115.132634,27.995082],[115.133086,27.992681],[115.130238,27.991325],[115.12782,27.985992],[115.129989,27.983201],[115.139098,27.974953],[115.138737,27.972536],[115.133922,27.968856],[115.128678,27.967483],[115.117015,27.959982],[115.115275,27.958266],[115.114778,27.955615],[115.117671,27.952995],[115.119909,27.953572],[115.120564,27.949064],[115.11957,27.941687],[115.121785,27.937771],[115.124655,27.937475],[115.127322,27.93501],[115.128905,27.929722],[115.129379,27.925994],[115.133063,27.921423],[115.133719,27.915712],[115.13607,27.909581],[115.13512,27.907615],[115.136838,27.901997],[115.138827,27.901123],[115.142195,27.901623],[115.144659,27.900562],[115.147529,27.89794],[115.151055,27.899064],[115.155146,27.897316],[115.154898,27.89549],[115.152705,27.897285],[115.149337,27.895194],[115.146919,27.896208],[115.144568,27.8951],[115.144184,27.893212],[115.146241,27.886829],[115.150829,27.887375],[115.149586,27.889544],[115.150061,27.89279],[115.152502,27.892822],[115.154287,27.891386],[115.159441,27.891698],[115.165544,27.890309],[115.17142,27.887375],[115.176009,27.884488],[115.178472,27.881101],[115.180846,27.880196],[115.18618,27.882366],[115.188327,27.878526],[115.190294,27.877949],[115.198385,27.882959],[115.202183,27.883723],[115.206568,27.882163],[115.210342,27.877574],[115.212354,27.876216],[115.217327,27.874812],[115.221101,27.875592],[115.2263,27.878901],[115.227249,27.881195],[115.225102,27.8853],[115.225418,27.888015],[115.228425,27.890715],[115.230798,27.891558],[115.23577,27.889264],[115.24054,27.883052],[115.242009,27.88043],[115.245874,27.876123],[115.250372,27.873735],[115.253649,27.874406],[115.256271,27.876497],[115.259368,27.877465],[115.263368,27.8767],[115.264363,27.875436],[115.265651,27.870254],[115.267731,27.867819],[115.272161,27.868974],[115.282875,27.876107],[115.290831,27.880524],[115.293701,27.881195],[115.300392,27.881039],[115.305138,27.876794],[115.311987,27.871378],[115.314858,27.870613],[115.317728,27.871331],[115.321661,27.873485],[115.324803,27.876591],[115.32851,27.8772],[115.331561,27.876482],[115.334273,27.872689],[115.334974,27.868162],[115.33902,27.866789],[115.343631,27.8681],[115.346185,27.870316],[115.35005,27.871425],[115.357464,27.870551],[115.360447,27.867959],[115.363205,27.868131],[115.365646,27.872377],[115.367477,27.873938],[115.371975,27.874297],[115.378665,27.871097],[115.383954,27.871877],[115.388882,27.876404],[115.391097,27.877012],[115.395776,27.876466],[115.405224,27.872502],[115.408252,27.875217],[115.407642,27.877918],[115.402918,27.88157],[115.395956,27.881788],[115.392204,27.883614],[115.38635,27.888858],[115.382485,27.893399],[115.382621,27.896364],[115.387164,27.900546],[115.396047,27.906039],[115.402692,27.908769],[115.40563,27.912998],[115.406715,27.922234],[115.408501,27.926009],[115.408185,27.928661],[115.404365,27.931766],[115.396748,27.933794],[115.393606,27.935931],[115.393244,27.937803],[115.393606,27.945571],[115.397629,27.948051],[115.405246,27.95064],[115.408411,27.952761],[115.413383,27.954757],[115.415304,27.954523],[115.418604,27.950765],[115.420367,27.947536],[115.425272,27.943699],[115.429635,27.94426],[115.429589,27.948363],[115.426538,27.955334],[115.428459,27.960309],[115.439263,27.959842],[115.439422,27.954944],[115.443987,27.9551],[115.440461,27.943262],[115.439354,27.935946],[115.4467,27.933248],[115.450316,27.932639],[115.449615,27.929363],[115.450791,27.928162],[115.450271,27.925806],[115.451604,27.92409],[115.45999,27.921594],[115.466093,27.92239],[115.471224,27.926212],[115.472761,27.929301],[115.474546,27.935822],[115.472331,27.938817],[115.464307,27.941515],[115.4632,27.943449],[115.464465,27.946428],[115.468331,27.946366],[115.472467,27.947224],[115.47362,27.950733],[115.47536,27.952199],[115.482276,27.954742],[115.485509,27.957299],[115.494233,27.954461],[115.500743,27.953416],[115.503568,27.951498],[115.50836,27.950219],[115.510892,27.948331],[115.515141,27.947895],[115.527459,27.949064],[115.531754,27.945711],[115.537111,27.940267],[115.535009,27.935151],[115.531483,27.929441],[115.529471,27.925136],[115.521244,27.922593],[115.516881,27.91941],[115.513853,27.91565],[115.516294,27.909752],[115.516181,27.906725],[115.510372,27.90025],[115.510575,27.896754],[115.524227,27.885393],[115.531686,27.884785],[115.533404,27.883614],[115.537359,27.878667],[115.540705,27.873485],[115.543575,27.870535],[115.551622,27.865322],[115.55456,27.864713],[115.560934,27.861107],[115.566381,27.859749],[115.571851,27.860108],[115.578225,27.863308],[115.579288,27.861294],[115.57983,27.856018],[115.581186,27.853817],[115.586046,27.8521],[115.588464,27.848962],[115.588962,27.846011],[115.591177,27.841796],[115.598681,27.838798],[115.604286,27.835332],[115.609779,27.830023],[115.612265,27.828446],[115.629353,27.822044],[115.632404,27.822169],[115.636699,27.824089],[115.642259,27.821653],[115.645401,27.821044],[115.648543,27.82259],[115.650599,27.82537],[115.655075,27.828571],[115.653628,27.8311],[115.65069,27.832865],[115.650034,27.834817],[115.651323,27.846604],[115.653357,27.851897],[115.653289,27.854644],[115.654781,27.857735],[115.653786,27.860888],[115.655097,27.865946],[115.657109,27.869411],[115.657154,27.872049],[115.655843,27.877153],[115.657245,27.885206],[115.658149,27.887609],[115.661946,27.892822],[115.662963,27.898876],[115.666986,27.901014],[115.669631,27.907552],[115.672275,27.910688],[115.681723,27.91888],[115.684187,27.920284],[115.686018,27.924168],[115.681859,27.933419],[115.68204,27.937865],[115.683645,27.942732],[115.679825,27.944385],[115.675101,27.939674],[115.671281,27.939425],[115.666986,27.941281],[115.65903,27.94816],[115.657199,27.950967],[115.65781,27.954399],[115.654917,27.956473],[115.651571,27.956738],[115.6513,27.962774],[115.649153,27.962633],[115.646599,27.965128],[115.647299,27.968169],[115.64357,27.965596],[115.643728,27.970353],[115.641558,27.970696],[115.637784,27.973565],[115.633512,27.980457],[115.634484,27.985166],[115.634529,27.990763],[115.63523,27.993102],[115.640067,27.993773],[115.641739,27.996563],[115.650057,28.000476],[115.655323,28.00085],[115.660635,28.00216],[115.663664,28.004467],[115.669608,28.005777],[115.674626,28.004686],[115.676412,28.00824],[115.676525,28.014724],[115.677406,28.018045],[115.680774,28.022206],[115.69133,28.02869],[115.698133,28.03907],[115.700032,28.043168],[115.701456,28.043761],[115.705027,28.042078],[115.706338,28.03748],[115.718453,28.040566],[115.721414,28.044774],[115.720736,28.04655],[115.717865,28.048934],[115.71782,28.050181],[115.714181,28.050352],[115.714724,28.052113],[115.712757,28.052861],[115.706632,28.053453],[115.705298,28.057894],[115.704055,28.059203],[115.698472,28.06034],[115.691556,28.063581],[115.691126,28.067024],[115.69203,28.068629],[115.698563,28.075406],[115.698902,28.078117],[115.695737,28.077447],[115.692121,28.072649],[115.683486,28.068832],[115.678243,28.067741],[115.672072,28.068473],[115.660273,28.069299],[115.658126,28.069969],[115.655708,28.076247],[115.655775,28.082323],[115.652814,28.085563],[115.653267,28.091124],[115.652543,28.092604],[115.65295,28.097183],[115.651164,28.099006],[115.647503,28.09804],[115.643141,28.092729],[115.641264,28.088289],[115.635614,28.084722],[115.634551,28.081622],[115.631975,28.079768],[115.629195,28.080313],[115.627748,28.085532],[115.623092,28.08776],[115.622572,28.091031],[115.628381,28.096077],[115.62316,28.097682],[115.621668,28.101467],[115.614797,28.108101],[115.608965,28.107229],[115.601664,28.10712],[115.59294,28.107619],[115.589527,28.110951],[115.584735,28.111574],[115.582271,28.11472],[115.578406,28.117773],[115.577163,28.121899],[115.577728,28.12791],[115.577412,28.131414],[115.574699,28.131071],[115.571151,28.126773],[115.568958,28.12615],[115.564777,28.131024]]]]}},{"type":"Feature","properties":{"adcode":360983,"name":"高安市","center":[115.381527,28.420951],"centroid":[115.298046,28.359194],"childrenNum":0,"level":"district","parent":{"adcode":360900},"subFeatureIndex":9,"acroutes":[100000,360000,360900]},"geometry":{"type":"MultiPolygon","coordinates":[[[[115.02509,28.583207],[115.010353,28.577455],[115.010624,28.573795],[115.009471,28.569655],[115.015371,28.562537],[115.019801,28.563545],[115.023327,28.562088],[115.026876,28.558211],[115.026808,28.555807],[115.023576,28.552581],[115.023146,28.549588],[115.028164,28.54585],[115.027825,28.539258],[115.029791,28.536062],[115.030017,28.530555],[115.02613,28.526476],[115.025452,28.52148],[115.027079,28.519432],[115.038629,28.518253],[115.044325,28.518517],[115.045523,28.515088],[115.056395,28.514297],[115.058474,28.514825],[115.062204,28.511349],[115.064984,28.510853],[115.068759,28.511566],[115.072714,28.510093],[115.079495,28.504228],[115.081981,28.503902],[115.084852,28.5019],[115.086163,28.499216],[115.093576,28.496609],[115.096628,28.494498],[115.104855,28.494591],[115.106211,28.495507],[115.112902,28.494622],[115.118801,28.494933],[115.120428,28.49276],[115.11966,28.489145],[115.121649,28.4805],[115.12192,28.476776],[115.123751,28.475643],[115.125446,28.471576],[115.1313,28.470676],[115.133063,28.46678],[115.131956,28.46501],[115.133335,28.461347],[115.135934,28.460602],[115.13512,28.456644],[115.133448,28.453772],[115.130668,28.452576],[115.130487,28.45062],[115.133877,28.44736],[115.13512,28.441694],[115.132159,28.43997],[115.12678,28.440358],[115.119479,28.439536],[115.107748,28.438821],[115.100764,28.433403],[115.096311,28.432471],[115.093283,28.428217],[115.089915,28.424599],[115.089417,28.420608],[115.083337,28.408417],[115.083021,28.405715],[115.083857,28.396613],[115.083292,28.393165],[115.080241,28.390696],[115.082795,28.384684],[115.085191,28.374959],[115.085349,28.369755],[115.087587,28.362437],[115.085982,28.360821],[115.085349,28.35675],[115.083812,28.355368],[115.07893,28.346588],[115.082388,28.339735],[115.080648,28.336736],[115.081461,28.334575],[115.084829,28.333146],[115.086208,28.330302],[115.088785,28.329229],[115.101826,28.326463],[115.106912,28.319841],[115.111274,28.315893],[115.121197,28.310779],[115.126689,28.308836],[115.128972,28.306955],[115.131662,28.300612],[115.132205,28.294083],[115.138352,28.290491],[115.143212,28.28861],[115.147665,28.290616],[115.152434,28.291315],[115.154649,28.290569],[115.157429,28.287771],[115.166968,28.285532],[115.167668,28.283666],[115.166109,28.277244],[115.166312,28.272159],[115.165521,28.263917],[115.161792,28.259703],[115.145721,28.253839],[115.139347,28.255472],[115.135392,28.259547],[115.131798,28.260309],[115.123502,28.255021],[115.118869,28.254057],[115.110461,28.259687],[115.106234,28.258769],[115.101985,28.256779],[115.087903,28.251164],[115.082162,28.251366],[115.078026,28.250869],[115.075404,28.247011],[115.074816,28.239918],[115.081959,28.236512],[115.082614,28.234007],[115.081393,28.230616],[115.082524,28.22696],[115.087654,28.222853],[115.097961,28.221764],[115.099521,28.220395],[115.100945,28.216677],[115.101171,28.212211],[115.098933,28.207855],[115.093328,28.202891],[115.093486,28.196604],[115.078704,28.190815],[115.076963,28.18845],[115.078365,28.181882],[115.0778,28.179859],[115.073754,28.172404],[115.073822,28.169135],[115.074997,28.166971],[115.077574,28.159251],[115.076556,28.154829],[115.06973,28.148089],[115.064848,28.141487],[115.070182,28.136303],[115.068442,28.132628],[115.062091,28.133967],[115.057163,28.133484],[115.05653,28.131709],[115.05748,28.124889],[115.05644,28.1226],[115.050563,28.123363],[115.044867,28.122647],[115.045206,28.118395],[115.040754,28.116028],[115.039601,28.111901],[115.03508,28.108615],[115.035035,28.105968],[115.038109,28.102448],[115.036437,28.100719],[115.036143,28.094302],[115.036934,28.090236],[115.0389,28.088071],[115.04498,28.090003],[115.047489,28.089566],[115.052643,28.085174],[115.051603,28.080796],[115.056802,28.071761],[115.057073,28.068317],[115.061548,28.066572],[115.066702,28.070717],[115.076511,28.075531],[115.08336,28.076528],[115.08935,28.07874],[115.09109,28.082292],[115.096063,28.082136],[115.098911,28.08117],[115.103748,28.082557],[115.109783,28.079441],[115.113648,28.080422],[115.115026,28.076761],[115.120926,28.081871],[115.126418,28.082011],[115.130419,28.081279],[115.136499,28.079098],[115.145721,28.077696],[115.15205,28.075063],[115.157542,28.07067],[115.158785,28.06757],[115.156299,28.062989],[115.154581,28.055837],[115.157294,28.055432],[115.162266,28.052923],[115.16699,28.048794],[115.17359,28.04348],[115.178879,28.042748],[115.180416,28.043387],[115.184914,28.047843],[115.184959,28.049854],[115.183016,28.053453],[115.182857,28.05953],[115.18505,28.063254],[115.189457,28.06704],[115.196283,28.069689],[115.203313,28.073521],[115.207404,28.076497],[115.210523,28.075764],[115.219383,28.083117],[115.220468,28.088087],[115.222638,28.091763],[115.216694,28.094567],[115.216355,28.097993],[115.217327,28.10103],[115.217168,28.106014],[115.219474,28.109861],[115.224763,28.111185],[115.228063,28.109924],[115.22917,28.107696],[115.233307,28.104613],[115.234279,28.100999],[115.234708,28.094987],[115.236855,28.087837],[115.239771,28.084753],[115.242687,28.083834],[115.249784,28.084831],[115.251909,28.083865],[115.255751,28.078833],[115.260995,28.077416],[115.264589,28.07874],[115.271166,28.083741],[115.278083,28.086622],[115.285768,28.089333],[115.288548,28.092215],[115.289294,28.095127],[115.288458,28.099302],[115.290967,28.103554],[115.300121,28.11064],[115.303918,28.114565],[115.309569,28.118162],[115.313411,28.119034],[115.315468,28.122195],[115.320599,28.125777],[115.322904,28.12464],[115.32417,28.126431],[115.332149,28.133173],[115.340082,28.134714],[115.342365,28.133126],[115.346954,28.132659],[115.349056,28.137393],[115.349236,28.142826],[115.354209,28.147995],[115.355701,28.150237],[115.358549,28.15128],[115.364493,28.150268],[115.370212,28.146283],[115.374484,28.14636],[115.377693,28.144477],[115.381875,28.145613],[115.383276,28.143091],[115.382734,28.138576],[115.383751,28.136536],[115.3873,28.135166],[115.392656,28.13582],[115.396499,28.137595],[115.39781,28.140304],[115.39503,28.142795],[115.396341,28.148431],[115.401449,28.150206],[115.402986,28.149972],[115.406015,28.146111],[115.410106,28.147217],[115.413406,28.146952],[115.417655,28.139027],[115.418424,28.13677],[115.416593,28.133407],[115.41761,28.131133],[115.419893,28.130682],[115.423464,28.132005],[115.42369,28.129747],[115.421904,28.12749],[115.425928,28.124313],[115.426267,28.11743],[115.431488,28.118395],[115.434313,28.121993],[115.438404,28.12218],[115.440529,28.12777],[115.444168,28.129218],[115.445773,28.127007],[115.444778,28.122289],[115.447174,28.122834],[115.450587,28.127645],[115.454362,28.128299],[115.455605,28.130806],[115.458996,28.133531],[115.463222,28.134995],[115.462883,28.131663],[115.464918,28.129623],[115.467449,28.130043],[115.471314,28.135415],[115.47258,28.136085],[115.475111,28.134714],[115.475315,28.127941],[115.474501,28.123425],[115.471427,28.120981],[115.471924,28.119844],[115.482118,28.121557],[115.49351,28.118505],[115.504269,28.11743],[115.512722,28.118505],[115.521605,28.12014],[115.526442,28.120591],[115.53354,28.124017],[115.53858,28.127645],[115.542649,28.128564],[115.546717,28.12858],[115.552029,28.129965],[115.555351,28.130199],[115.559691,28.129093],[115.564777,28.131024],[115.569049,28.134777],[115.580214,28.140709],[115.586294,28.145707],[115.588306,28.149101],[115.587018,28.150688],[115.586498,28.154067],[115.584712,28.155857],[115.579604,28.155608],[115.57757,28.15402],[115.577592,28.151763],[115.575829,28.149957],[115.573275,28.151062],[115.572236,28.153771],[115.570201,28.154207],[115.568687,28.152385],[115.565093,28.156666],[115.561251,28.158005],[115.559488,28.155732],[115.555668,28.156168],[115.553136,28.157507],[115.551577,28.159764],[115.552051,28.165415],[115.555849,28.169726],[115.556346,28.171983],[115.553792,28.172419],[115.551486,28.175112],[115.550944,28.177836],[115.546875,28.178271],[115.546853,28.180746],[115.544321,28.182256],[115.54405,28.186162],[115.552029,28.198767],[115.555668,28.201911],[115.557905,28.202393],[115.557227,28.204743],[115.558425,28.206003],[115.561883,28.205847],[115.564438,28.208788],[115.559442,28.21204],[115.558787,28.216179],[115.5556,28.215914],[115.553498,28.206797],[115.551373,28.207637],[115.550356,28.210998],[115.550492,28.214141],[115.54952,28.21817],[115.546785,28.221593],[115.544321,28.222993],[115.544457,28.224938],[115.548005,28.230429],[115.548503,28.232281],[115.54674,28.232576],[115.54362,28.231067],[115.539642,28.22654],[115.536455,28.224502],[115.530262,28.224611],[115.528273,28.227598],[115.529155,28.231721],[115.52868,28.238021],[115.52712,28.239218],[115.525787,28.24278],[115.520543,28.243947],[115.517605,28.246545],[115.515593,28.246933],[115.516022,28.249998],[115.51496,28.251273],[115.516361,28.256297],[115.515638,28.257681],[115.510123,28.258147],[115.503885,28.261864],[115.498189,28.264104],[115.495363,28.267556],[115.493623,28.275114],[115.492629,28.276886],[115.489735,28.278208],[115.486752,28.282002],[115.486232,28.284117],[115.483655,28.287335],[115.479406,28.287631],[115.474366,28.285236],[115.472489,28.285065],[115.466816,28.287537],[115.458996,28.287444],[115.446745,28.286527],[115.443061,28.287848],[115.437681,28.298109],[115.441908,28.306644],[115.444033,28.31294],[115.445728,28.314774],[115.450949,28.316888],[115.453006,28.319577],[115.454678,28.326152],[115.460826,28.325468],[115.466884,28.32724],[115.471585,28.330954],[115.473326,28.336036],[115.477394,28.337994],[115.479451,28.339875],[115.481757,28.34721],[115.483949,28.350069],[115.49247,28.352509],[115.494459,28.355368],[115.501692,28.359656],[115.508541,28.3618],[115.509671,28.367937],[115.505535,28.372971],[115.509377,28.375488],[115.508541,28.376932],[115.511163,28.378051],[115.510281,28.38049],[115.511841,28.383907],[115.513966,28.38602],[115.518531,28.383721],[115.520927,28.383628],[115.520792,28.388366],[115.519752,28.389686],[115.529313,28.391659],[115.53198,28.394097],[115.532884,28.398974],[115.535935,28.404892],[115.538738,28.407501],[115.544276,28.408122],[115.547983,28.40792],[115.551012,28.409737],[115.55386,28.416617],[115.554289,28.423419],[115.553407,28.430499],[115.549113,28.438247],[115.541835,28.44278],[115.54292,28.444675],[115.548774,28.449596],[115.551147,28.453834],[115.549136,28.457466],[115.549881,28.461176],[115.549384,28.465492],[115.546966,28.473299],[115.545768,28.475068],[115.545745,28.481323],[115.550401,28.484116],[115.553317,28.48691],[115.553814,28.488803],[115.565884,28.494281],[115.568009,28.495941],[115.567805,28.497897],[115.560143,28.503079],[115.558923,28.50775],[115.559081,28.510853],[115.562358,28.514732],[115.56767,28.513382],[115.570699,28.515135],[115.572416,28.514545],[115.573072,28.517726],[115.571218,28.523869],[115.568642,28.530276],[115.568257,28.533037],[115.569546,28.538963],[115.56941,28.542344],[115.566766,28.552472],[115.563014,28.559033],[115.563149,28.563793],[115.566336,28.565654],[115.582113,28.568291],[115.5853,28.570089],[115.587312,28.573547],[115.586927,28.575082],[115.583673,28.576648],[115.582339,28.579424],[115.582791,28.583052],[115.58087,28.586044],[115.573094,28.590184],[115.571377,28.589393],[115.569229,28.586401],[115.56611,28.584696],[115.562607,28.584199],[115.561567,28.586494],[115.556572,28.583579],[115.556662,28.582029],[115.553475,28.580215],[115.52755,28.582509],[115.528906,28.585905],[115.527663,28.59099],[115.521402,28.597036],[115.516316,28.596773],[115.515503,28.599563],[115.512745,28.603377],[115.509129,28.604756],[115.509716,28.610182],[115.507818,28.61122],[115.502642,28.611065],[115.498573,28.608663],[115.49464,28.603346],[115.488673,28.601796],[115.482322,28.604105],[115.480468,28.603532],[115.477552,28.596385],[115.476016,28.594153],[115.468715,28.589006],[115.465799,28.583223],[115.466251,28.581378],[115.46485,28.57961],[115.460962,28.579377],[115.456035,28.582416],[115.455447,28.57916],[115.450203,28.580478],[115.444824,28.580029],[115.442315,28.576307],[115.438947,28.569267],[115.436302,28.569438],[115.432686,28.564553],[115.430742,28.563189],[115.425815,28.564336],[115.420435,28.564491],[115.418424,28.569423],[115.416661,28.570679],[115.416638,28.57561],[115.420074,28.584773],[115.420051,28.593378],[115.418288,28.593827],[115.416231,28.59068],[115.413564,28.591641],[115.412502,28.596742],[115.40667,28.600462],[115.404839,28.603377],[115.39894,28.603547],[115.396589,28.601641],[115.390487,28.603873],[115.385876,28.602416],[115.384203,28.60099],[115.376676,28.5993],[115.376541,28.596726],[115.379999,28.589796],[115.383254,28.587409],[115.383977,28.585858],[115.382033,28.583734],[115.372359,28.578323],[115.363521,28.575827],[115.356266,28.57288],[115.352559,28.5724],[115.341778,28.563669],[115.336308,28.564445],[115.336511,28.567019],[115.33129,28.569624],[115.33016,28.575532],[115.326114,28.581254],[115.323108,28.588277],[115.320441,28.59068],[115.318271,28.594913],[115.317028,28.599935],[115.313614,28.603082],[115.310427,28.608337],[115.307376,28.610399],[115.304958,28.609918],[115.30211,28.607686],[115.30055,28.609453],[115.297363,28.608244],[115.296143,28.603764],[115.296662,28.599346],[115.294018,28.596013],[115.291532,28.596525],[115.289588,28.59978],[115.285406,28.600742],[115.276795,28.596866],[115.270421,28.599083],[115.266646,28.597641],[115.257108,28.600881],[115.253581,28.604539],[115.252519,28.60781],[115.254599,28.61153],[115.251005,28.616103],[115.250146,28.624302],[115.248428,28.627107],[115.242393,28.629386],[115.238234,28.630067],[115.232968,28.632981],[115.226797,28.63216],[115.222254,28.633585],[115.218751,28.636049],[115.207924,28.635848],[115.203403,28.63481],[115.198905,28.6367],[115.191333,28.638343],[115.184733,28.636452],[115.178382,28.636204],[115.170539,28.634546],[115.16317,28.63154],[115.153316,28.630904],[115.147235,28.627975],[115.141426,28.627092],[115.133244,28.62782],[115.130261,28.628626],[115.126599,28.632501],[115.117965,28.635523],[115.1181,28.63357],[115.113128,28.62937],[115.11367,28.625821],[115.108246,28.620024],[115.103228,28.621946],[115.098956,28.619807],[115.096334,28.612755],[115.092785,28.60826],[115.089689,28.606477],[115.084739,28.606338],[115.079856,28.608151],[115.076489,28.60516],[115.072398,28.604911],[115.068126,28.602586],[115.065526,28.600338],[115.0686,28.59823],[115.066679,28.592153],[115.062339,28.591037],[115.055536,28.583905],[115.052123,28.57975],[115.045274,28.580277],[115.041997,28.583982],[115.034583,28.582726],[115.028141,28.583657],[115.02509,28.583207]]]]}}]}

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[454]);


// WEBPACK FOOTER //
// static/js/app.62b85a5bc0efb0d47708.js